<template>
  <div class="edit_tagTem_wapper">
    <breadcrumb
      :title="$route.query.line || translateLang('main.sideBar.printTag')"
      :childTitle="translateLang('printPage.editPage.title')"
      @goBackPage="goBackPage"
    >
      <template>
        <div class="topBtn">
          <div class="funBtn" @click="backDefault" id="edit_tag_temp_reset_btn">
            <i class="iconfont icon-recover"></i
            ><span
              class="inline-block ellipsis"
              style="max-width: 100%"
              :title="translateLang('printPage.editPage.reset')"
              >{{ $t('printPage.editPage.reset') }}</span
            >
          </div>
          <div class="funBtn" @click="outEdit" id="edit_tag_temp_quit_btn">
            <i class="iconfont icon-quit"></i
            ><span
              class="inline-block ellipsis"
              style="max-width: 100%"
              :title="translateLang('printPage.editPage.exit')"
              >{{ $t('printPage.editPage.exit') }}</span
            >
          </div>
          <div class="save" @click="save" id="edit_tag_temp_save_btn">
            <i class="iconfont icon-save"></i
            ><span
              class="inline-block ellipsis"
              style="max-width: 100%"
              :title="translateLang('common.save')"
              >{{ $t('common.save') }}</span
            >
          </div>
        </div>
      </template>
    </breadcrumb>
    <div class="com_content">
      <div class="edit_tagTem_left">
        <!-- 标签模板切换 -->
        <div class="temp-switch flex bold color-0">
          <div
            class="align-center tab-nav ellipsis"
            @click="handleSwitchTemplate('plank')"
            :class="{ 'tab-background': labelTemplates != 'plank' }"
            id="edit_tag_temp_plank_tab"
            :title="translateLang('printPage.plankTemp')"
          >
            {{ $t('printPage.plankTemp') }}
          </div>
          <div
            class="align-center tab-nav ellipsis"
            @click="handleSwitchTemplate('surplus')"
            :class="{ 'tab-background': labelTemplates != 'surplus' }"
            id="edit_tag_temp_surplus_tab"
            :title="translateLang('printPage.surplusTemp')"
          >
            {{ $t('printPage.surplusTemp') }}
          </div>
        </div>
        <div class="tagTemBox_info" v-show="labelTemplates == 'plank'">
          <p class="classTitle">
            <span class="dian"></span>
            <span class="title">{{ $t('printPage.editPage.tagInfo') }}</span>
          </p>
          <div class="tagTem_name">
            <span>{{ $t('printPage.editPage.tagName') }}：</span>
            <div>
              <a-input
                id="edit_tag_temp_name_input"
                :placeholder="translateLang('printPage.tempNamePlaceHolder')"
                autocomplete="off"
                @input="handleTagNameChange"
                v-model="tagName"
              />
            </div>
          </div>
          <div class="tagTem_size">
            <span>{{ $t('printPage.editPage.tagSize') }}：</span>
            <a-input-number
              id="edit_tag_temp_size_w_inputNumber"
              v-model="tagSizeWmm"
              :min="1"
              :max="600"
              @change="changeTagSize('w', $event)"
            /><a-icon type="close" />
            <a-input-number
              id="edit_tag_temp_size_h_inputNumber"
              v-model="tagSizeHmm"
              :min="1"
              :max="600"
              @change="changeTagSize('h', $event)"
            />
          </div>
          <div class="tagTem_sub">
            <g-paid-feature
              :iconStyle="{ top: '-10px', right: '-12px' }"
              :permission-keys="[USER_PERMISSION_KEY.SECONDARY_LABEL]"
            >
              <span>{{ $translateLang('开启副标签') }}：</span>
            </g-paid-feature>
            <a-switch
              :checked="enable_sub && !isWebToQt"
              class="ml10"
              :disabled="!hasSecondaryLabelPermission && !enable_sub"
              @change="handleEnableSubChange"
            />
            <a-tooltip
              placement="rightTop"
              overlayClassName="enable-sub-tag-tooltip"
            >
              <template #title>
                <span
                  >{{
                    $translateLang(
                      '可以在更多设置-小板副标签设置-设置副标签生成的生效数据源，开启后只有设置的数据源在副标签上有值，才会生成副标签，反之则不生成副标签'
                    )
                  }}
                  <span class="link-text" @click="goToSetting">{{
                    $translateLang('去设置')
                  }}</span>
                </span>
              </template>
              <i
                class="iconfont icon-wenhao ml5"
                v-show="hasSecondaryLabelPermission && !isWebToQt"
              ></i>
            </a-tooltip>
          </div>
          <!-- 分为小板主标签和小板副标签 -->
          <div class="surplus_tag_type" v-show="enable_sub && !isWebToQt">
            <div
              class="surplus_tag_type_item"
              :class="{ active: mainTemplates == 'main' }"
              @click="handleSwitchMainTemplate('main')"
            >
              <span class="ellipsis" :title="$translateLang('小板主标签')">{{
                $translateLang('小板主标签')
              }}</span>
            </div>
            <div
              class="surplus_tag_type_item"
              :class="{ active: mainTemplates == 'sub' }"
              @click="handleSwitchMainTemplate('sub')"
            >
              <span class="ellipsis" :title="$translateLang('小板副标签')">{{
                $translateLang('小板副标签')
              }}</span>
            </div>
          </div>
        </div>

        <!-- 选中余料标签模板 -->
        <div v-show="labelTemplates == 'surplus'">
          <!-- 分为裁剪余料标签和余料标签 -->
          <div class="surplus_tag_type">
            <div
              class="surplus_tag_type_item"
              :class="{ active: surplusTemplates == 'cut' }"
              @click="handleSwitchSurplusTemplate('cut')"
            >
              <span>裁剪余料标签</span>
            </div>
            <div
              class="surplus_tag_type_item"
              :class="{ active: surplusTemplates == 'waste' }"
              @click="handleSwitchSurplusTemplate('waste')"
            >
              <span>余料标签</span>
            </div>
          </div>
        </div>

        <div class="tagTem_set">
          <p class="classTitle">
            <span class="dian"></span>
            <span class="title">{{ $t('printPage.editPage.tagData') }}</span>
            <!-- <span><i @mouseenter="tipsHover = true" @mouseleave="tipsHover = false" class="iconfont icon-hint" :style="{color:tipsHover?'#18A8C7':'#D2D2D2'}"></i></span>
                    <a-popover title="温馨提示" :visible='tipsHover' placement="right">
                        <template slot="content">
                            <div style="width:150px">您可以根据自身需求拖动下方按钮至右边标签纸上来完成标签模板的编辑</div>
                        </template>
                    </a-popover> -->
          </p>
          <div class="hint">{{ $t('printPage.editPage.dragTip') }}</div>
          <!-- 小板数据标签和操作 -->
          <div class="tagTem_setItem_list">
            <!-- 数据标签的来源  surplusTemSetData-->
            <div
              v-for="(item, index) in templateData"
              :key="index"
              :class="
                item.type.split(',').includes(nowChooseSet) ? 'active' : ''
              "
              @mousedown="
                isDraw = true
                mouseInCanvas = false
              "
              @mouseenter="chooseTagSet(item, $event)"
            >
              <span v-if="item.url"
                ><i :class="['iconfont', item.url]"></i
              ></span>
              <!-- 如果找不到icon，就通过image去显示 -->
              <img
                :src="item.imgUrl"
                class="img-class"
                :class="
                  item.type.split(',').includes(nowChooseSet)
                    ? 'color-cover'
                    : ''
                "
                v-else
              />
              <span
                class="inline-block ml5 ellipsis"
                :title="translateLang(item.name)"
                >{{ translateLang(item.name) }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="edit_tagTem_mid x-auto">
        <!-- 中部的canvas处理部分 -->
        <div class="hintMessage" v-if="showHintInfo">
          <div>
            <i style="color: #1890ff" class="iconfont icon-hint"></i
            ><span>{{ $t('printPage.editPage.dataTip') }}</span>
          </div>
          <span @click="showHintInfo = false"
            ><i style="font-size: 12px" class="iconfont icon-close"></i
          ></span>
        </div>
        <div class="permissionHint" v-if="importPermissionHintText">
          <div>
            <i style="color: #faad14" class="iconfont icon-hint"></i>
            <span>{{ importPermissionHintText }}</span>
          </div>
          <span @click="importPermissionHintText = ''">
            <i style="font-size: 12px" class="iconfont icon-close"></i>
          </span>
        </div>
        <!-- 根据切换展示 -->
        <div v-show="labelTemplates == 'plank' && mainTemplates == 'main'">
          <canvas id="mycanvas_tag"></canvas>
        </div>
        <div v-show="labelTemplates == 'plank' && mainTemplates == 'sub'">
          <canvas id="mycanvas_sub_tag"></canvas>
        </div>
        <div v-show="labelTemplates == 'surplus' && surplusTemplates == 'cut'">
          <canvas id="mycanvas_surplus_cut"></canvas>
        </div>
        <div
          v-show="labelTemplates == 'surplus' && surplusTemplates == 'waste'"
        >
          <canvas id="mycanvas_surplus_waste"></canvas>
        </div>

        <!-- 创造一个余料部分的canvas 盛放数据 -->
        <div class="operate_wap">
          <div>
            <a-popover :title="translateLang('common.tip')">
              <template slot="content">
                <p style="width: 200px">
                  {{ $t('printPage.editTip') }}
                </p>
              </template>
              <span class="icon_btn"><i class="iconfont icon-hint"></i></span>
            </a-popover>
          </div>
          <!-- 底部的操作提示弹窗 -->
          <div class="operate_menu">
            <a-popover placement="topLeft">
              <template slot="content">
                <div :style="menuStyle">
                  <span>{{ $t('common.copy') }}</span>
                  <div>
                    <span :style="btnStyle">Ctrl</span>
                    +
                    <span :style="btnStyle">C</span>
                  </div>
                </div>
                <div :style="menuStyle">
                  <span>{{ $t('common.paste') }}</span>
                  <div>
                    <span :style="btnStyle">Ctrl</span>
                    +
                    <span :style="btnStyle">V</span>
                  </div>
                </div>
                <div :style="menuStyle">
                  <span>{{ $t('common.undo') }}</span>
                  <div>
                    <span :style="btnStyle">Ctrl</span>
                    +
                    <span :style="btnStyle">Z</span>
                  </div>
                </div>
                <div :style="menuStyle">
                  <span>{{ $t('arrangedPage.zoomScale') }}</span>
                  <div>
                    <span :style="btnStyle">Ctrl</span>
                    +
                    <span style="font-size: 12px">{{
                      $t('arrangedPage.mouseRoll')
                    }}</span>
                  </div>
                </div>
                <div :style="menuStyle">
                  <span>{{ $t('common.move') }}</span>
                  <div>
                    <span>{{ $t('arrangedPage.mouseRight') }}</span>
                  </div>
                </div>
                <div
                  :style="menuStyle"
                  style="
                    display: flex;
                    justify-content: space-between;
                    padding: 9px 0;
                    width: 180px;
                  "
                >
                  <span>{{ $t('common.delete') }}</span>
                  <div>
                    <span :style="btnStyle">Delete</span>
                  </div>
                </div>
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    padding: 9px 0;
                    width: 180px;
                  "
                >
                  <span
                    >{{ $translateLang('取消')
                    }}{{ $translateLang('选中') }}</span
                  >
                  <div>
                    <span :style="btnStyle">Esc</span>
                  </div>
                </div>
              </template>
              <template slot="title">
                <span>{{ $t('arrangedPage.shortCut') }}</span>
              </template>
              <span class="icon_btn"
                ><i class="iconfont icon-keyboard"></i
              ></span>
            </a-popover>
          </div>
          <!-- 底部缩放按钮 -->
          <div class="zoom_canvas">
            <span class="icon_btn" @click="changeZoom(-0.01)"
              ><i class="iconfont icon-narrow"></i
            ></span>
            <span>{{ calcZoom }}</span>
            <span class="icon_btn" @click="changeZoom(0.01)"
              ><i class="iconfont icon-enlarge"></i
            ></span>
          </div>
        </div>
      </div>
      <!-- 右边具体的数据信息 -->
      <div class="edit_tagTem_right y-auto" v-if="nowChooseSet && currentItem">
        <div class="attBox">
          <p class="classTitle">
            <span class="dian"></span>
            <span class="title">{{ $t('printPage.editPage.attribute') }}</span>
          </p>
          <div>
            <!-- 见光边 前封边 -->
            <div v-show="attItemShow(attShowInSet.visibleEdgeOrFrontEdge)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.dataSource')"
                >{{ $t('printPage.editPage.dataSource') }}：</span
              >
              <a-select
                v-model="visibleEdgeOrFrontEdge"
                style="width: 180px"
                show-search
                :filter-option="filterOption"
                @change="handleVisibleEdgeOrFrontEdgeChange"
              >
                <a-select-option
                  v-for="item in visibleEdgeOrFrontEdgeDataSource"
                  :key="item.value"
                  :value="item.value"
                  :title="item.label"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </div>
            <div v-show="attItemShow(attShowInSet.visibleEdgeOrFrontEdge)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.dataSource')"
                >显示样式：</span
              >
              <a-select
                v-model="visibleEdgeOrFrontEdgeStyle"
                style="width: 180px"
                show-search
                :filter-option="filterOption"
                @change="handleVisibleEdgeOrFrontEdgeStyleChange"
              >
                <a-select-option
                  v-for="item in visibleEdgeOrFrontEdgeStyleDataSource"
                  :key="item.value"
                  :value="item.value"
                  :title="item.label"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </div>

            <div v-show="attItemShow(attShowInSet.imgWH)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="`${
                  nowChooseSet == 'Onecode' || nowChooseSet == 'QRcode'
                    ? translateLang('printPage.oneCode')
                    : translateLang('printPage.image')
                }${translateLang('workShopPage.size')}`"
                >{{
                  nowChooseSet == 'Onecode' || nowChooseSet == 'QRcode'
                    ? translateLang('printPage.oneCode')
                    : translateLang('printPage.image')
                }}{{ $t('workShopPage.size') }}：</span
              >
              <a-input-number
                id="inputNumber"
                v-model="codeW"
                :min="1"
                :max="600"
                @change="changeImgSize('w', $event)"
              /><a-icon type="close" />
              <a-input-number
                id="inputNumber"
                v-model="codeH"
                :min="1"
                :max="600"
                @change="changeImgSize('h', $event)"
              />
            </div>
            <div v-show="attItemShow(attShowInSet.triangleSize)">
              <div class="relative mb5">
                <span
                  class="att-name inline-block ellipsis"
                  style="max-width: 110px"
                >
                  {{ translateLang('common.mark')
                  }}{{ $t('workShopPage.size') }}：</span
                >
                <el-select
                  v-model="triangleSize"
                  style="width: 190px"
                  @change="changeTriangleSizeSize($event)"
                  filterable
                  allow-create
                  default-first-option
                  size="small"
                >
                  <el-option
                    v-for="province in fontSizeOpeion"
                    :key="province"
                    :value="province"
                    :label="province"
                  ></el-option>
                </el-select>
                <transition name="errorInfo">
                  <span
                    v-show="inputAlert.fontSizeAlert"
                    class="error-info absolute fs12"
                  >
                    {{ inputAlert.fontSizeAlert }}
                  </span>
                </transition>
              </div>
            </div>
            <div v-show="attItemShow(attShowInSet.picture)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.holeSlotPicZoom')"
                >{{ $t('printPage.editPage.holeSlotPicZoom') }}：</span
              >
              <el-button
                icon="el-icon-minus"
                circle
                size="mini"
                @click="changePictureScale(null, -0.01)"
                :disabled="pictureScale <= 0.1"
              ></el-button>
              <el-slider
                v-model="pictureScale"
                :min="0.1"
                :max="2"
                :step="0.01"
                @change="changePictureScale"
              ></el-slider>
              <el-button
                icon="el-icon-plus"
                circle
                size="mini"
                @click="changePictureScale(null, 0.01)"
                :disabled="pictureScale >= 2"
              ></el-button>
            </div>
            <!-- 旋转角度 -->
            <div v-show="attItemShow(attShowInSet.angle)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.rotateDeg')"
                >{{ $t('printPage.editPage.rotateDeg') }}：</span
              >
              <a-input-number
                ref="angleRef"
                id="inputNumber"
                v-model="angle"
                @change="changeAngle"
              />
            </div>
            <!-- 颜色深度 -->
            <div v-show="attItemShow(attShowInSet.angle)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.colorDeep')"
                >{{ $t('printPage.editPage.colorDeep') }}：</span
              >
              <a-select
                v-model="GraColor"
                style="width: 100px"
                @change="handleGraColorChange"
              >
                <a-select-option
                  v-for="province in GraColorData"
                  :key="province.value"
                  :title="province.label"
                >
                  {{ province.label }}
                </a-select-option>
              </a-select>
            </div>
            <!-- 边框颜色深度 -->
            <div v-show="attItemShow(attShowInSet.color)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.colorDeep')"
                >{{ $t('printPage.editPage.colorDeep') }}：</span
              >
              <a-select
                v-model="stroke"
                style="width: 100px"
                @change="handleBorderColorChange"
              >
                <a-select-option
                  v-for="province in GraColorData"
                  :key="province.value"
                  :title="province.label"
                >
                  {{ province.label }}
                </a-select-option>
              </a-select>
            </div>
            <!-- 数据尺寸 -->
            <div
              v-show="
                attItemShow(attShowInSet.dataS) && nowChooseSet == 'DataSource'
              "
            >
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.dataSize')"
                >{{ $t('printPage.editPage.dataSize') }}：</span
              >
              <div
                class="flex flex-cross--center"
                style="justify-content: space-between"
              >
                <a-input
                  style="width: 75px"
                  v-model="dataSourceWidth"
                  @keydown="handleChangeDataSourceSize"
                  @focus="handleFocusRectSize"
                  @blur="handleBlurRectSize"
                ></a-input>
                <span style="margin: 0 10px">X</span>
                <a-input
                  style="width: 75px"
                  v-model="dataSourceHeight"
                  @keydown="handleChangeDataSourceSize"
                  @focus="handleFocusRectSize"
                  @blur="handleBlurRectSize"
                ></a-input>
              </div>
            </div>
            <div v-show="attItemShow(attShowInSet.opacity)">
              <span class="att-name"
                >{{ $t('printPage.editPage.dataSource') }}：</span
              >
              <a-select
                v-model="partSignValue"
                style="width: 180px"
                @change="handlePartSign"
              >
                <a-select-option
                  v-for="province in partSign"
                  :key="province.value"
                  :title="$t(province.label)"
                >
                  {{ $t(province.label) }}
                </a-select-option>
              </a-select>
            </div>
            <!-- 透明度 -->
            <div v-show="attItemShow(attShowInSet.opacity)">
              {{ $t('printPage.opacity') }}
              <a-slider
                v-model="inputOpacity"
                :min="0"
                :max="1"
                :step="0.01"
                style="width: 50%"
                @change="
                  (value) => {
                    changeOpacityOrScaleSize(value, 'opacity')
                  }
                "
              />
              {{ inputOpacity }}
            </div>
            <!-- 数据信息 -->
            <div
              v-show="
                attItemShow(attShowInSet.dataS) && nowChooseSet == 'DataSource'
              "
            >
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.dataSource')"
                >{{ $t('printPage.editPage.dataSource') }}：</span
              >
              <a-select
                v-model="nowDataInfo"
                style="width: 180px"
                show-search
                :filter-option="filterOption"
                @change="handleDataSourcesChange"
              >
                <a-select-opt-group
                  v-for="(item, index) in groupDataSource"
                  :label="item.label"
                  :key="index"
                >
                  <a-select-option
                    v-for="(option, idx) in item.options"
                    :key="`${index}-${idx}`"
                    :value="option.value"
                    :title="option.label"
                  >
                    {{ option.label }}
                  </a-select-option>
                </a-select-opt-group>
              </a-select>
            </div>
            <!-- 数据信息 -->
            <div
              v-show="
                attItemShow(attShowInSet.dataS) && nowChooseSet != 'DataSource'
              "
            >
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.dataSource')"
                >{{ $t('printPage.editPage.dataSource') }}：</span
              >
              <!-- 附加清单数据信息选择 -->
              <a-select
                v-if="nowChooseSet === 'Table'"
                v-model="nowTableData"
                style="width: 180px"
                @change="handleTableChange"
              >
                <a-select-option
                  v-for="table in tableSource"
                  :key="table.value"
                  :title="table.label"
                >
                  {{ translateLang(table.label) }}
                </a-select-option>
              </a-select>
              <!-- 其他的数据信息选择 -->
              <a-select
                v-else
                v-model="nowCodeInfo"
                style="width: 180px"
                @change="handleCodeChange"
              >
                <a-select-option
                  v-for="province in nowDataSources"
                  :key="province.value"
                  :title="province.label"
                >
                  {{ province.label }}
                </a-select-option>
              </a-select>
            </div>
            <!-- 孔槽图数据信息-->
            <div v-show="attItemShow(attShowInSet.holeSlotPictureInfo)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.dataSource')"
                >{{ $t('printPage.editPage.dataSource') }}：</span
              >
              <a-select
                v-model="holeSlotPictureDataInfo"
                style="width: 180px"
                show-search
                :filter-option="filterOption"
                @change="handleHoleSlotPictureChange"
              >
                <a-select-option
                  v-for="item in holeSlotPictureDataSource"
                  :key="item.value"
                  :value="item.value"
                  :title="item.label"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </div>

            <!-- 二维码格式 -->
            <div
              v-show="
                attItemShow(attShowInSet.dataS) && nowChooseSet == 'QRcode'
              "
            >
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.QRCodeFormat')"
                >{{ $t('printPage.editPage.QRCodeFormat') }}：</span
              >
              <a-radio-group
                v-model="QRCodeFormat"
                id="printtag_qrcode_format_radio"
                @change="handleChangeQRCodeFormat"
              >
                <a-radio value="QRCode">{{
                  $t('printPage.editPage.formatQR')
                }}</a-radio>
                <br />
                <a-radio value="DMCode">{{
                  $t('printPage.editPage.formatDM')
                }}</a-radio>
              </a-radio-group>
            </div>
            <!-- 条形码且数据源是下料文件名的提示 -->
            <div
              class="ncname-remark p0 fs12"
              v-show="nowCodeInfo === 'ncName' && nowChooseSet === 'Onecode'"
            >
              {{ $t('printPage.editPage.NCFileNameTip') }}
            </div>
            <!-- 板件特殊标注选项 -->
            <div v-show="attItemShow(attShowInSet.partSign)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.dataSource')"
                >{{ $t('printPage.editPage.dataSource') }}：</span
              >
              <a-select
                v-model="partSignValue"
                style="width: 180px"
                @change="handlePartSign"
              >
                <a-select-option
                  v-for="province in partSign"
                  :key="province.value"
                  :title="$t(province.label)"
                >
                  {{ translateLang(province.label) }}
                </a-select-option>
              </a-select>
            </div>
            <!-- 柜体序号-按房间排序的后续表单项 -->
            <div
              v-show="
                attItemShow(attShowInSet.partSign) &&
                partSignValue === 'wardrobeNumToRoom'
              "
            >
              <!-- 房间编号 -->
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.roomNo')"
                >{{ $t('printPage.editPage.roomNo') }}：</span
              >
              <a-select
                v-model="roomSortWay"
                style="width: 180px"
                @change="handleChangeRoomSort"
              >
                <a-select-option
                  v-for="sort in roomSort"
                  :key="sort.value"
                  :title="sort.label"
                >
                  {{ translateLang(sort.label) }}
                </a-select-option>
              </a-select>
            </div>
            <div v-show="nowCodeInfo === 'ncName'">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.genNCSuffix')"
                >{{ $t('printPage.editPage.genNCSuffix') }}：</span
              >
              <a-checkbox
                v-if="nowChooseSet === 'QRcode'"
                v-model="isQRcodeNCSuffix"
                @change="handleChangeQRNCSuffix"
              ></a-checkbox>
              <a-checkbox
                v-else
                v-model="isOnecodeNCSuffix"
                @change="handleChangeOneNCSuffix"
              ></a-checkbox>
            </div>
            <div
              v-show="
                attItemShow(attShowInSet.dataS) &&
                nowChooseSet != 'DataSource' &&
                nowChooseSet !== 'Table' &&
                currentItem &&
                (nowChooseSet == 'QRcode'
                  ? currentItem.source_data == 'oriPlankNum'
                  : currentItem?.getObjects?.()[0].source_data ==
                    'oriPlankNum') &&
                labelTemplates !== 'surplus'
              "
            >
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 130px"
                :title="translateLang('printPage.editPage.noHoleSlot')"
                >{{ $t('printPage.editPage.noHoleSlot') }}：</span
              >
              <a-switch
                v-model="switchCodeValue"
                @change="changeCodeShowValue"
              />
            </div>
            <div
              v-show="
                attItemShow(attShowInSet.dataS) &&
                nowChooseSet == 'Onecode' &&
                currentItem &&
                currentItem.getObjects?.()[0].source_data == 'oriPlankNum' &&
                labelTemplates !== 'surplus'
              "
            >
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 130px"
                :title="$translateLang('适配孔槽分流设置')"
                >{{ $translateLang('适配孔槽分流设置') }}：</span
              >
              <a-switch
                :disabled="switchCodeValue"
                id="printtag_switch_code_value_shunt"
                v-model="switchCodeValueShunt"
                @change="changeCodeShowValueShunt"
              />
              <a-tooltip>
                <template #title>
                  {{
                    $translateLang(
                      '勾选后,孔槽分流后无后道工序加工的孔槽板件便不生成条码'
                    )
                  }}
                </template>
                <a-icon
                  class="ml5"
                  style="color: #999; cursor: pointer"
                  type="question-circle"
                />
              </a-tooltip>
            </div>
            <div v-show="attItemShow(attShowInSet.codeAtt)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.rotate')"
                >{{ $t('printPage.editPage.rotate') }}：</span
              >
              <a-select
                v-model="codeRotateDeg"
                style="width: 180px"
                @change="handleCodeRotateDegChange"
              >
                <a-select-option
                  v-for="rotate in rotateOptions"
                  :key="rotate.value"
                  :value="rotate.value"
                  :title="rotate.label"
                >
                  {{ rotate.label }}
                </a-select-option>
              </a-select>
            </div>
            <!-- 条码属性 -->
            <div v-show="attItemShow(attShowInSet.codeAtt)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.barcodeAtrribute')"
                >{{ $t('printPage.editPage.barcodeAtrribute') }}：</span
              >
              <a-select
                v-model="codeAtt"
                style="width: 180px"
                @change="handleCodeAttChange"
              >
                <a-select-option
                  v-for="province in codeAttOpeion"
                  :key="province"
                  :title="province"
                >
                  {{ province }}
                </a-select-option>
              </a-select>
            </div>
            <!-- 圆框直径 -->
            <div v-show="attItemShow(attShowInSet.diameter)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.circleD')"
                >{{ $t('printPage.editPage.circleD') }}：</span
              >
              <a-select
                show-search
                v-model="nowDiameter"
                style="width: 180px"
                :filter-option="filterOption"
                @change="handleDiameterChange"
                option-filter-prop="children"
                @search="handleSearchDiameter"
              >
                <a-select-option
                  v-for="province in diameterOpeion"
                  :key="province"
                  :title="province"
                >
                  {{ province }}
                </a-select-option>
              </a-select>
            </div>
            <!-- 小板标记尺寸 -->
            <div v-show="attItemShow(attShowInSet.smallPlateSize)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                >{{ $translateLang('图像尺寸') }}：</span
              >
              <a-input-number
                v-model="smallPlateW"
                :min="1"
                :max="600"
                @change="handleSmallPlateSizeChange('w', $event)"
              />
              <a-icon type="close" />
              <a-input-number
                v-model="smallPlateH"
                :min="1"
                :max="600"
                @change="handleSmallPlateSizeChange('h', $event)"
              />
            </div>
            <!-- 五六面钻放板基准 图像尺寸 -->
            <div v-show="attItemShow(attShowInSet.sixSideDrillSize)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                >{{ $translateLang('图像尺寸') }}：</span
              >
              <a-input-number
                v-model="sixSideDrillArrowSize"
                :disabled="sixSideDrillPlankBaseGraph == 'triangle'"
                :min="1"
                :max="600"
                @change="handleSixSideDrillPlankBaseSizeChange('w', $event)"
              />
              <a-icon type="close" />
              <a-input-number
                v-model="sixSideDrillArrowSize"
                :disabled="sixSideDrillPlankBaseGraph == 'triangle'"
                :min="1"
                :max="600"
                @change="handleSixSideDrillPlankBaseSizeChange('h', $event)"
              />
            </div>
            <!-- 五六面钻放板基准 图形样式 -->
            <div v-show="attItemShow(attShowInSet.sixSideDrillGraph)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('图形样式')"
                >{{ $translateLang('图形样式') }}：</span
              >
              <a-select
                v-model="sixSideDrillPlankBaseGraph"
                style="width: 180px"
                @change="
                  handleSixSideDrillPlankBaseGraphChange($event, currentItem)
                "
              >
                <a-select-option
                  v-for="(item, index) in sixSideDrillPlankBaseGraphList"
                  :key="index"
                  :title="translateLang(item.label)"
                  :value="item.value"
                >
                  {{ translateLang(item.label) }}
                </a-select-option>
              </a-select>
            </div>
            <!-- 字体类型 -->
            <div
              v-show="
                attItemShow(
                  labelTemplates == 'plank'
                    ? attShowInSet.fontFamily
                    : attShowInSet.fontFamily.replace('Typography', '')
                )
              "
            >
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.fontFamily')"
                >{{ $t('printPage.editPage.fontFamily') }}：</span
              >
              <a-select
                v-model="nowFontFamily"
                style="width: 180px"
                @change="handleFontFamilyChange($event, currentItem)"
              >
                <a-select-option
                  v-for="province in fontFamilyArr"
                  :key="province"
                  :title="province"
                >
                  {{ province }}
                </a-select-option>
              </a-select>
            </div>
            <!-- 字体大小 -->
            <div
              v-show="
                attItemShow(
                  labelTemplates == 'plank'
                    ? attShowInSet.fontS
                    : attShowInSet.fontS.replace('Typography', '')
                )
              "
              class="relative mb5"
            >
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.fontSize')"
                >{{ $t('printPage.editPage.fontSize') }}：</span
              >
              <el-select
                v-model="nowFontSize"
                style="width: 180px"
                @change="handleFontSizeChange($event, currentItem)"
                filterable
                allow-create
                default-first-option
                size="small"
              >
                <el-option
                  v-for="province in fontSizeOpeion"
                  :key="province"
                  :value="province"
                  :label="province"
                ></el-option>
              </el-select>
              <transition name="errorInfo">
                <span
                  v-show="inputAlert.fontSizeAlert"
                  class="error-info absolute fs12"
                >
                  {{ inputAlert.fontSizeAlert }}
                </span>
              </transition>
            </div>
            <!-- 字体加粗 -->
            <div
              v-show="
                attItemShow(
                  labelTemplates == 'plank'
                    ? attShowInSet.fontW
                    : attShowInSet.fontW.replace('Typography', '')
                ) && nowFontFamily !== '黑体'
              "
            >
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.fontWeight')"
                >{{ $t('printPage.editPage.fontWeight') }}：</span
              >
              <a-checkbox
                v-model="fontWeight"
                @change="changeFontWeight(currentItem)"
              ></a-checkbox>
            </div>
            <!-- 翻面加工数据源线上有问题 暂时注释 -->
            <!-- <div v-show="attItemShow(attShowInSet.flipOverProcessing)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.flipOverProcessing')"
                >{{ $t('printPage.editPage.flipOverProcessing') }}：</span
              >
              <a-checkbox
                v-model="isFlipOverProcessing"
                @change="handleChangeIsFlipOverProcessing"
              ></a-checkbox>
            </div> -->

            <!-- 是否显示图例内框 -->
            <div
              v-show="
                attItemShow(attShowInSet.showSideMachiningSequenceDiagramBorder)
              "
            >
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="
                  translateLang(
                    'printPage.editPage.showSideMachiningSequenceDiagramBorder'
                  )
                "
                >{{
                  $t(
                    'printPage.editPage.showSideMachiningSequenceDiagramBorder'
                  )
                }}：</span
              >
              <a-checkbox
                v-model="isShowSideMachiningSequenceDiagramBorder"
                @change="handleChangeIsShowSideMachiningSequenceDiagramBorder"
              ></a-checkbox>
            </div>
            <!-- 是否显示数字加工顺序 -->
            <div
              v-show="attItemShow(attShowInSet.showSideMachiningSequenceNumber)"
            >
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 130px"
                :title="
                  translateLang(
                    'printPage.editPage.showSideMachiningSequenceNumber'
                  )
                "
                >{{
                  $t('printPage.editPage.showSideMachiningSequenceNumber')
                }}：</span
              >
              <a-checkbox
                v-model="isShowSideMachiningSequenceNumber"
                @change="handleChangeIsShowSideMachiningSequenceNumber"
              ></a-checkbox>
            </div>
            <!-- 图片旋转 -->
            <div v-show="attItemShow(attShowInSet.rotate)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.imgRotate')"
                >{{ $t('printPage.editPage.imgRotate') }}：</span
              >
              <a-select
                v-model="rotateDeg"
                style="width: 180px"
                @change="changePlankRotate"
              >
                <a-select-option
                  v-for="rotateOption in rotateOptions"
                  :key="rotateOption.value"
                  :value="rotateOption.value"
                  :title="rotateOption.label"
                >
                  {{ rotateOption.label }}
                </a-select-option>
              </a-select>
            </div>
            <template v-if="labelTemplates == 'plank'">
              <div v-show="attItemShow(attShowInSet.openDoorD)">
                <span
                  class="att-name inline-block ellipsis"
                  style="max-width: 110px"
                  >{{ $t('printPage.editPage.showOpenSide') }}：</span
                >
                <a-checkbox
                  v-model="showOpenDoor"
                  @change="changeShowOpenDoor"
                ></a-checkbox>
              </div>
              <div v-show="attItemShow(attShowInSet.edgeOff)">
                <span
                  class="att-name inline-block ellipsis"
                  style="max-width: 110px"
                  :title="translateLang('printPage.editPage.noEdgeDisplay')"
                  >{{ $t('printPage.editPage.noEdgeDisplay') }}：</span
                >
                <a-checkbox
                  v-model="showEdgeOff"
                  @change="changeShowEdgeOff"
                ></a-checkbox>
              </div>

              <div v-show="attItemShow(attShowInSet.edgeShow)">
                <span
                  class="att-name inline-block ellipsis"
                  style="max-width: 110px"
                  :title="translateLang('printPage.editPage.allEdgeNoDisplay')"
                  >{{ $t('printPage.editPage.allEdgeNoDisplay') }}：</span
                >
                <a-checkbox
                  v-model="showEdgeDisplay"
                  @change="changeShowEdgeDisplay('showEdgeDisplay')"
                ></a-checkbox>
              </div>

              <div v-show="attItemShow(attShowInSet.isShowDiffEdgeColor)">
                <span
                  class="att-name inline-block ellipsis"
                  style="max-width: 200px"
                  :title="
                    translateLang('printPage.editPage.isShowDiffEdgeColor')
                  "
                  >{{ $t('printPage.editPage.isShowDiffEdgeColor') }}：</span
                >
                <a-checkbox
                  v-model="isShowDiffEdgeColor"
                  @change="changeShowEdgeDisplay('isShowDiffEdgeColor')"
                ></a-checkbox>
              </div>
              <div
                v-if="
                  attItemShow(attShowInSet.hideSameEdgeColorAsPlank) &&
                  isShowDiffEdgeColor
                "
                class="flex flex-cross--center"
              >
                <span
                  class="att-name inline-block ellipsis"
                  style="max-width: 200px; margin-right: 0"
                  :title="
                    translateLang('printPage.editPage.hideSameEdgeColorAsPlank')
                  "
                  >{{ $t('printPage.editPage.hideSameEdgeColorAsPlank') }}</span
                >

                <a-tooltip>
                  <template #title>{{
                    $t('printPage.editPage.hideSameEdgeColorAsPlankTip')
                  }}</template>
                  <a-icon
                    type="question-circle"
                    class="mr5"
                    style="color: #999; cursor: pointer"
                  />
                </a-tooltip>
                ：
                <a-checkbox
                  v-model="hideSameEdgeColorAsPlank"
                  @change="changeShowEdgeDisplay('hideSameEdgeColorAsPlank')"
                ></a-checkbox>
              </div>
            </template>
            <div v-show="attItemShow(attShowInSet.frontEdge)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="$translateLang('显示柜体前边')"
                >{{ $translateLang('显示柜体前边') }}：</span
              >
              <a-checkbox
                v-model="showFrontEdge"
                @change="changeShowEdgeDisplay('showFrontEdge')"
              ></a-checkbox>
            </div>
            <div v-show="attItemShow(attShowInSet.frontEdge)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="$translateLang('显示见光边')"
                >{{ $translateLang('显示见光边') }}：</span
              >
              <a-checkbox
                v-model="showVisibleEdge"
                @change="changeShowEdgeDisplay('showVisibleEdge')"
              ></a-checkbox>
            </div>

            <div v-show="attItemShow(attShowInSet.wrap)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.autoRow')"
                >{{ $t('printPage.editPage.autoRow') }}：</span
              >
              <a-checkbox
                v-model="splitByGrapheme"
                @change="changeWordWrap"
              ></a-checkbox>
            </div>
            <div v-show="attItemShow(attShowInSet.lineS)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.rowMargin')"
                >{{ $t('printPage.editPage.rowMargin') }}：</span
              >
              <a-select
                v-model="lineSpace"
                style="width: 180px"
                @change="handleLineSpaceChange"
              >
                <a-select-option
                  v-for="province in lineSpaceOpeion"
                  :key="province"
                  :title="province"
                >
                  {{ province }}
                </a-select-option>
              </a-select>
            </div>
            <div v-show="attItemShow(attShowInSet.lineCount)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="$translateLang('每行字数')"
                >{{ $translateLang('每行字数') }}：</span
              >
              <a-input-number
                ref="lintCountRef"
                v-model="lineCount"
                :min="1"
                :max="99999"
                @change="handleLineCountAttrChange"
              />
            </div>
            <div v-show="attItemShow(attShowInSet.lineS)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.autoFontSize')"
                >{{ $t('printPage.editPage.autoFontSize') }}：</span
              >
              <a-checkbox
                v-model="isAutoFontSize"
                @change="handleChangeAutoFontSize"
              ></a-checkbox>
            </div>
            <div
              v-show="
                attItemShow(attShowInSet.lineS.replace('Onecode', '')) ||
                attItemShow(attShowInSet.statistics)
              "
            >
              <a-tooltip>
                <template #title>{{
                  $translateLang('由智绘彩标提供技术支持')
                }}</template>
                <NewContent
                  :content="$translateLang('彩标专属')"
                  :styleObj="{
                    background: 'rgb(249, 224, 199)',
                    color: 'rgba(0, 0, 0, 0.65)',
                    fontSize: '13px',
                    top: '-15px',
                  }"
                >
                  <span
                    class="att-name inline-block ellipsis"
                    style="max-width: 110px"
                    >{{ $translateLang('透明度') }}：</span
                  >
                </NewContent>
              </a-tooltip>
              <div>
                <div class="flex flex-cross--center" v-if="hasOpacityAuth">
                  <a-slider
                    v-model="itemOpacity"
                    :min="0"
                    :max="1"
                    :step="0.01"
                    class="mr5"
                    style="width: 130px"
                    @change="handleChangeSlider"
                  />
                  <span class="inline-block ml10">{{ itemOpacity }}</span>
                </div>
                <a-tooltip class="flex flex-cross--center" v-else>
                  <template #title>{{
                    $translateLang(
                      '当前账号未购买智绘彩标;如已购买,请在彩标软件内绑定柜柜账号'
                    )
                  }}</template>
                  <a-slider
                    v-model="itemOpacity"
                    :min="0"
                    :max="1"
                    :step="0.01"
                    class="mr5"
                    style="width: 130px"
                    @change="handleChangeSlider"
                    :disabled="!hasOpacityAuth"
                  />
                  <span class="inline-block ml10">{{ itemOpacity }}</span>
                </a-tooltip>
              </div>
            </div>
            <!-- 统计维度 -->
            <div
              v-if="
                attItemShow(attShowInSet.statistics) &&
                currentItem.source_data == 'sameSizeBoardCount'
              "
              class="statistics-box"
            >
              <p>{{ $t('printPage.editPage.statisticsDimension') }}：</p>
              <!-- 单选框组件 -->
              <a-radio-group
                default-value="noLimit"
                v-model="statisticsDimension"
                @change="handleChangeStatisticsDimension"
                id="edit_tag_temp_statistics_radio"
              >
                <a-radio value="noLimit" id="edit_tag_temp_statistics_noLimit">
                  {{ $t('printPage.editPage.noLimit') }}
                </a-radio>
                <a-radio
                  value="sameOrder"
                  id="edit_tag_temp_statistics_sameOrder"
                >
                  {{ $t('printPage.editPage.sameOrderNo') }}
                </a-radio>
                <a-radio
                  value="sameRoom"
                  id="edit_tag_temp_statistics_sameRoom"
                >
                  {{ $t('printPage.editPage.sameRoom') }}
                </a-radio>
                <a-radio
                  value="sameWardrobe"
                  id="edit_tag_temp_statistics_sameWardrobe"
                >
                  {{ $t('printPage.editPage.sameWardrobe') }}
                </a-radio>
              </a-radio-group>
            </div>
            <div v-show="attItemShow(attShowInSet.textAlign)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.alignWay')"
                >{{ $t('printPage.editPage.alignWay') }}：</span
              >
              <a-select
                v-model="textAlign"
                style="width: 100px"
                @change="handleTextAlignChange"
              >
                <a-select-option
                  v-for="province in textAlignOption"
                  :key="province.value"
                  :title="translateLang(province.label)"
                >
                  {{ $t(province.label) }}
                </a-select-option>
              </a-select>
            </div>
            <!-- 限制小数点位数 余料模板不显示 -->
            <template v-if="mycanvasId == 'mycanvas_tag'">
              <div
                v-show="
                  attItemShow(attShowInSet.dataS) &&
                  (currentItem.source_data == 'oSize' ||
                    currentItem.source_data == 'cutSize')
                "
              >
                <span
                  class="att-name inline-block ellipsis"
                  style="max-width: 110px"
                  :title="translateLang('printPage.editPage.limitFixed')"
                  >{{ $t('printPage.editPage.limitFixed') }}：</span
                >
                <a-checkbox
                  v-model="sizeRestrict"
                  @change="changeSizeRestrict"
                ></a-checkbox>
              </div>
            </template>

            <!-- 限制小数点位数输入框 余料模板不显示 -->
            <template v-if="mycanvasId == 'mycanvas_tag'">
              <div
                v-show="
                  attItemShow(attShowInSet.dataS) &&
                  (currentItem.source_data == 'oSize' ||
                    currentItem.source_data == 'cutSize') &&
                  sizeRestrict
                "
              >
                <span
                  class="att-name inline-block ellipsis"
                  style="max-width: 110px"
                  :title="translateLang('printPage.editPage.digitLimitation')"
                  >{{ $t('printPage.editPage.digitLimitation') }}</span
                >
                <a-input-number
                  ref="sizeRestrictNumRef"
                  v-model="sizeRestrictNum"
                  @change="changeSizeRestrictNum"
                  style="width: 75px"
                  :min="0"
                  :max="5"
                />
              </div>
            </template>

            <!-- 显示正面孔槽 -->
            <div v-show="attItemShow(attShowInSet.holeSize)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.showFrontHS')"
                >{{ $t('printPage.editPage.showFrontHS') }}：</span
              >
              <a-checkbox
                v-model="holeZ"
                @change="changeIsHole('holeZ')"
              ></a-checkbox>
            </div>
            <!-- 显示背面孔槽 -->
            <div v-show="attItemShow(attShowInSet.holeSize)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.showBackHS')"
                >{{ $t('printPage.editPage.showBackHS') }}：</span
              >
              <a-checkbox
                v-model="holeF"
                @change="changeIsHole('holeF')"
              ></a-checkbox>
            </div>
            <!-- 显示小板尺寸 -->
            <div v-show="attItemShow(attShowInSet.holeSize)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="translateLang('printPage.editPage.showPlankSize')"
                >{{ $t('printPage.editPage.showPlankSize') }}：</span
              >
              <a-checkbox
                v-model="plankSize"
                @change="changePlankSize"
              ></a-checkbox>
            </div>

            <!-- 显示板件封边 -->
            <div v-show="attItemShow(attShowInSet.holeSize)">
              <span
                class="att-name inline-block ellipsis"
                style="max-width: 110px"
                :title="$translateLang('显示板件封边')"
                >{{ $translateLang('显示板件封边') }}：</span
              >
              <a-checkbox
                v-model="partEdge"
                @change="changePlankEdgeShow"
              ></a-checkbox>
            </div>
          </div>
        </div>
        <div class="delete_reset">
          <p class="classTitle">
            <span class="dian"></span>
            <span class="title">{{
              $t('printPage.editPage.otherOpration')
            }}</span>
          </p>
          <div>
            <a-button @click="deleteEl()">{{ $t('common.delete') }}</a-button>
            <a-button @click="resetParameter" v-if="isShowReset">
              {{ $t('printPage.editPage.attributeReset') }}
            </a-button>
            <a-button
              v-for="(item, idx) in otherOperate"
              :key="idx"
              :disabled="item.isDisable(activeElementCount)"
              @click="handleOtherClick(item)"
            >
              {{ $t(item.text) }}
            </a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchUserPermission } from '@/apis/auth'
import { buryPoint } from '@/apis/common/buryPoint'
import { getLabelInfo } from '@/apis/tag'
import paibanTestImage from '@/assets/paiban_test.png'
import surplusPlankImage from '@/assets/surplus_plank.png'
import { checkUserPermissions } from '@/auth/user_function'
import GPaidFeature from '@/components/g-paid-feature.vue'
import NewContent from '@/components/newContent.vue'
import breadcrumb from '@/components/topBreadCrumb.vue'
import { USER_PERMISSION_KEY } from '@/data/auth'
import {
  escapeTemplate,
  translateTemplateWay,
} from '@/data/i18n/json/templateMap'
import { REGEXP_REPLACE_FILE_NAME } from '@/data/regexp'
import { translate } from '@/util/commonFun'
import { buryPointApi, toDecimal } from '@/util/commonFuncs'
import { PxToPt, getPathMinMaxPoint } from '@/util/plankCommonFuncs'
import { dealTextStr, fabricTable } from '@/util/tag/tag-draw'
import { needApartPackUser } from '@/util/thirdPartyDealFunc/lblDealFuncs'
import {
  cutSurplusDataSource,
  wasteSurplusDataSource,
} from '@/views/printTag/utils/surplusFieldData'
import { fabric } from 'fabric'
import JsBarcode from 'jsbarcode'
import { cloneDeep } from 'lodash'
import { nanoid } from 'nanoid'
import { mapState } from 'vuex'

import defaultTagData, { subTagDefaultTemData } from '../../util/defaultTagData'
import mockData from '../../util/editTagMock'
import { PtToPx, getDeviceXDPI, mmToPx, pxTomm } from '../../util/exportFuncs'
import { handleTagSaveData } from '../../util/handleTagSaveData'
import { otherOperate } from './data'
import {
  cutSurplusTemSetData,
  partTemSetData,
  wasteSurplusTemSetData,
} from './data/templateData'
import {
  FabricMovingControl,
  FabricSelectedControl,
  getActiveObjectByNotAssignField,
  getElRealRect,
  getPositionByCanvas,
  isControlRectEl,
  isSelectedEl,
} from './utils/fabricControl'

/** 自定义 fabric 控制类数组 */
const fabricControlList = []
const fabricMovingControlList = []

/** 当前拥有的canvas 画布 id */
const canvasIdList = [
  'mycanvas_tag',
  'mycanvas_surplus_cut',
  'mycanvas_surplus_waste',
  'mycanvas_sub_tag',
]

/** 副标签画布数据：无已保存内容时使用 defaultTagData 内 sub_tem_data */
function resolveSubTagTemData(subTemData) {
  return subTemData?.length
    ? subTemData
    : JSON.parse(JSON.stringify(subTagDefaultTemData))
}

/*
定义每种标签数据的type
FixedText  DataSource Graphics(图形) Typography(排版图) Onecode QRcode
 */
const attShowInSet = {
  fontS:
    'FixedText,DataSource,Typography,Onecode,Table,wardrobeNum,multipleSelect,holeSlotPicture,sideMachiningSequenceDiagram, Marking,SurplusSize,smallPlateMarking',
  fontFamily:
    'FixedText,DataSource,Typography,Onecode,Table,wardrobeNum,multipleSelect,holeSlotPicture,sideMachiningSequenceDiagram, Marking,SurplusSize,smallPlateMarking',
  fontW:
    'FixedText,DataSource,Typography,Onecode,wardrobeNum,multipleSelect,holeSlotPicture,sideMachiningSequenceDiagram, Marking,SurplusSize,smallPlateMarking',
  lineS: 'FixedText,DataSource,Onecode',
  dataS: 'DataSource,QRcode,Onecode,Table',
  visibleEdgeOrFrontEdge: 'VisibleEdge,FrontEdge',
  imgWH:
    'Graphics,Typography,Onecode,QRcode,SurplusSize,EdgeBand,VisibleEdge,FrontEdge',
  // 透明度（拖动，最大值为1）
  opacity: 'specialMark',
  codeAtt: 'Onecode',
  angle: 'Graphics',
  color: 'EdgeBand',
  diameter: 'wardrobeNum,Marking',
  wrap: 'FixedText,',
  textAlign: 'FixedText',
  statistics: 'DataSource',
  multipleSelect: 'multipleSelect',
  holeSize: 'holeSlotPicture',
  picture: 'holeSlotPicture,sideMachiningSequenceDiagram',
  rotate: 'Typography',
  openDoorD: 'Typography',
  edgeOff: 'Typography,',
  edgeShow: 'Typography,',
  isShowDiffEdgeColor: 'Typography',
  hideSameEdgeColorAsPlank: 'Typography',
  partSign:
    'wardrobeNum,smallPlateMarking,sixSideDrillArrow,sixSideDrillTriangle',
  frontEdge: 'Typography,',
  visibleEdge: 'Typography,',
  smallPlateSize: 'smallPlateMarking',
  triangleSize: 'VisibleEdge,FrontEdge', // 箭头尺寸
  // 图形样式：
  sixSideDrillGraph: 'sixSideDrillArrow,sixSideDrillTriangle',
  // 尺寸样式：
  sixSideDrillSize: 'sixSideDrillArrow,sixSideDrillTriangle',
  // 每行字数
  lineCount: 'DataSource',
  // 孔槽图数据信息
  holeSlotPictureInfo: 'holeSlotPicture,sideMachiningSequenceDiagram',
  flipOverProcessing: 'sideMachiningSequenceDiagram',
  showSideMachiningSequenceDiagramBorder: 'sideMachiningSequenceDiagram',
  showSideMachiningSequenceNumber: 'sideMachiningSequenceDiagram',
}

const DPI = getDeviceXDPI()
export default {
  components: {
    breadcrumb,
    NewContent,
    GPaidFeature,
  },
  data() {
    return {
      otherOperate: otherOperate,
      mycanvasId: 'mycanvas_tag',
      // 当前选中的模板标签
      labelTemplates: 'plank',
      // 当前选中的余料模板标签
      surplusTemplates: 'cut',
      // 显示提示信息
      showHintInfo: true,
      importPermissionHintText: '',
      inputOpacity: 0.25,
      inputScale: 1,
      switchCodeValue: true,
      switchCodeValueShunt: false, // 适配孔槽分流设置
      tipsHover: false,
      tagId: 0,
      attShowInSet: attShowInSet,
      tagSizeWmm: 60,
      tagSizeHmm: 40,
      QRCodeFormat: 'QRCode',
      tagName: '',
      nowChooseSet: '',
      chooseOtherSet: true,
      nowFontSize: 8,
      lineSpace: 1,
      fontWeight: false,
      // 是否限制成品/切割尺寸
      sizeRestrict: false,
      // 成品/切割尺寸限制小数点位数
      sizeRestrictNum: 2,
      codeW: 10,
      codeH: 10,
      nowDataInfo: '',
      // 孔槽图数据信息
      holeSlotPictureDataInfo: 'holeSlotPicture',
      // 孔槽图数据信息
      holeSlotPictureDataSource: [
        {
          label: '正反面孔槽图',
          value: 'holeSlotPicture',
        },
        {
          label: '侧面加工顺序图',
          value: 'sideMachiningSequenceDiagram',
        },
      ],
      // 见光or前边选择
      visibleEdgeOrFrontEdge: 'VisibleEdge',
      visibleEdgeOrFrontEdgeDataSource: [
        {
          label: '见光边',
          value: 'VisibleEdge',
        },
        {
          label: '前封边',
          value: 'FrontEdge',
        },
      ],
      visibleEdgeOrFrontEdgeStyle: 'triangle',
      visibleEdgeOrFrontEdgeStyleDataSource: [
        {
          label: '矩形',
          value: 'rectangle',
        },
        {
          label: '三角形',
          value: 'triangle',
        },
      ],
      isFlipOverProcessing: false,
      isShowSideMachiningSequenceDiagramBorder: true,
      isShowSideMachiningSequenceNumber: true,
      nowCodeInfo: 'plankNum',
      nowTableData: '',
      codeAtt: 'EAN13',
      angle: 0,
      GraColor: '#000000',
      stroke: '#000000', // 绘制边框颜色
      triangleSize: 6, // 绘制见光边箭头大小
      nowDiameter: 4,
      smallPlateW: 30, // 小板标记默认宽度
      smallPlateH: 18, // 小板标记默认高度
      // 五六面钻放板基准宽高
      sixSideDrillArrowSize: 50,
      arrDPI: [],
      GraColorData: mockData.bgColor,
      textAlignOption: [
        {
          value: 'left',
          label: 'printPage.editPage.JustifyLeft',
        },
        {
          value: 'right',
          label: 'printPage.editPage.JustifyRight',
        },
        {
          value: 'center',
          label: 'printPage.editPage.JustifyCenter',
        },
      ],
      tableSource: [
        {
          value: 'extraParts',
          label: 'printPage.editPage.extraList',
        },
      ],
      oriDiameterOption: [4, 6, 8, 10, 12, 14, 16, 20, 26, 32],
      diameterOpeion: [4, 6, 8, 10, 12, 14, 16, 20, 26, 32],
      fontSizeOpeion: [4, 6, 8, 10, 12, 14, 16, 20, 26, 32],
      lineSpaceOpeion: [1, 2, 3, 4],
      dataSources: {
        codeData: [
          { label: '安装图', value: 'ggid' },
          { label: '板件条码', value: 'oriPlankNum' },
          { label: '正面条码', value: 'plankNum' },
          { label: '反面条码', value: 'plankNumF' },
          { label: '订单备注', value: 'remarks' },
          { label: '下料文件名', value: 'ncName' },
          { label: '房间备注', value: 'remark' },
          { label: '尺寸信息', value: 'size' },
          { label: '简易条码', value: 'simplePlankNum' },
        ],
        // 老板良的二维码信息数据
        lblSpecialCodeData: [
          { label: '易达设备对接码', value: 'hingeEquipment' },
        ],
        onCodeData: [
          { label: '板件条码', value: 'oriPlankNum' },
          { label: '板件条码(无标识)', value: 'oriPlankNumNoMark' },
          { label: '正面条码', value: 'plankNum' },
          { label: '反面条码', value: 'plankNumF' },
          { label: '订单备注', value: 'remarks' },
          { label: '下料文件名', value: 'ncName' },
          { label: '房间备注', value: 'remark' },
        ],
        cutSurplusCodeList: [
          { label: '废料条码', value: 'plankNum' },
          { label: '废料入库码', value: 'restockingCode' },
          { label: '简易条码', value: 'simplePlankNum' },
        ],
        wasteSurplusCodeList: [
          { label: '余料入库码', value: 'restockingCode' },
        ],
        suplusOnCodeList: [{ label: '板件条码', value: 'oriPlankNum' }],
        fieldData: null,
        // 余料部分的数据信息标签，先写死
        cutSurplusDataSource: cutSurplusDataSource,
        // 废料余料数据源数据
        wasteSurplusDataSource: wasteSurplusDataSource,
      },
      codeAttOpeion: mockData.codeAttOpeion,
      currentItem: null, // 当前选中的组件
      // currentDelList: [], // 多选删除标签
      // item_id: 0, //确保每个组件的唯一性，新增组件则加1
      isAllSelect: false,
      group: [],
      overUpPoint: { x: 0, y: 0 },
      mouseInCanvas: false,
      nowETarget: null, //当前鼠标下的元素
      isDraw: false, //是否可以绘制，只有点击标签数据栏拖动才能绘制
      panning: false,
      // 小板标签模板
      mycanvas_tag: null,
      // 裁剪余料标签模板
      mycanvas_surplus_cut: null,
      // 余料标签模板
      mycanvas_surplus_waste: null,
      setTagTimer: null,
      // 标签数据
      tagSizeWPx: 0,
      tagSizeHPx: 0,
      // 保存标签纸位置
      rectData: null, //记录当前纸张信息
      saveCanvas: null, //保存初始画布数据
      loadTime: null, // 定时器
      copyValue: [], // 复制值
      operateArrs: [], //保存操作顺序的数据
      mods: 0, //记录当前撤销的位置
      mouse_wheel: false, //记录是否可滑动滚轮缩放大小
      zoomNum: 2, //当前放大倍数
      canvasZoomPoint: {}, //记录缩放的中点
      splitByGrapheme: false, //自动换行
      textAlign: 'left', // 对齐方式
      // 记录是否是第三方跳转
      thinkerxMaterial: false,
      plankSignBox: [],
      holeZ: true, // 正面孔槽
      holeF: true, // 反面孔槽
      plankSize: true, // 板件尺寸,
      partEdge: false, //板件封边
      pictureScale: 1, //图像缩放大小
      plankRotate: false, // 板件逆时针旋转90°
      showOpenDoor: true, // 开门方向
      showEdgeOff: false,
      showEdgeDisplay: false,
      showFrontEdge: true,
      showVisibleEdge: true,
      isShowDiffEdgeColor: false, // 封边颜色不同时显示各边的颜色
      hideSameEdgeColorAsPlank: false, // 单边颜色与板件相同时不显示
      partSign: mockData.partSign,
      partSignValue: 'wardrobeNum',
      // 记录是否移动画布
      isFabricCanvasMove: false,
      // 记录右键点击的位置
      fabricCutPoint: null,
      //记录已生成过边框的元素
      hasGenControlRectList: [],
      //记录生成的边框元素
      controlRects: [],
      // 数据信息宽度
      dataSourceWidth: 100,
      // 数据信息高度
      dataSourceHeight: 20,
      // 旋转角度
      rotateOptions: [
        {
          label: '0°',
          value: 0,
        },
        {
          label: '90°',
          value: 90,
        },
        {
          label: '180°',
          value: 180,
        },
        {
          label: '270°',
          value: 270,
        },
      ],
      oriTempData: null,
      rotateDeg: 0,
      // 超出文本字体自动调整
      isAutoFontSize: true,
      // 每行字数
      lineCount: '',
      // 条码旋转角度
      codeRotateDeg: 90,
      // 二维码生成NC后缀
      isQRcodeNCSuffix: true,
      // 条形码生成NC后缀
      isOnecodeNCSuffix: true,
      // 记录各种输入警示
      inputAlert: {
        fontSizeAlert: '',
      },
      nowFontFamily: '微软雅黑',
      fontFamilyArr: ['微软雅黑', '黑体', '宋体'],
      // 是否展示重置参数
      isShowReset: true,
      // 房间，柜体排序方式
      roomSort: mockData.roomSort,
      // 房间排序方式
      roomSortWay: '',
      // 柜体排序方式
      wardrobeSortWay: '',
      // 统计维度
      statisticsDimension: 'noLimit',
      // 记录键盘状态
      keyboard: {
        /** 是否按下了ctrl键 */
        isCtrlDown: false,
      },
      /** 记录当前激活的元素个数 */
      activeElementCount: 1,
      /** 单个文本数据项的透明度 */
      itemOpacity: 1,
      /** 透明度滑块防抖 */
      sliderTimer: null,
      // 是否有权限编辑透明度
      hasOpacityAuth: null,
      // 五六面钻放板基准 图形样式
      sixSideDrillPlankBaseGraph: 'arrow',
      // 五六面钻放板基准 图形样式列表
      sixSideDrillPlankBaseGraphList: [
        {
          label: 'printPage.editPage.arrow', //箭头
          value: 'arrow',
        },
        {
          label: 'printPage.editPage.triangle', //三角角标
          value: 'triangle',
        },
      ],
      /** 是否在缩放 */
      isObjectScaling: false,
      /** 是否开启副标签 */
      enable_sub: false,
      /** 进入页面时副标签是否已开启（用于埋点：仅从未开→开启时上报） */
      initialEnableSub: false,
      mainTemplates: 'main',
      // 小板副标签模板
      mycanvas_sub_tag: null,
      USER_PERMISSION_KEY,
    }
  },
  methods: {
    handleChangeSlider(val) {
      if (this.sliderTimer) {
        clearTimeout(this.sliderTimer)
      }
      this.sliderTimer = setTimeout(() => {
        // this.currentItem.opacity = val
        this.currentItem.set({
          opacity: val,
        })
        buryPoint({ function_module: 'tag', function_point: 'textOpacity' })
        this[this.mycanvasId].renderAll()
      }, 300)
    },
    // 模板切换的方法
    handleSwitchTemplate(type) {
      if (type == 'plank') {
        this.labelTemplates = 'plank'
        // 切换为普通小板模板时，修改余料模板为裁剪余料模板
        this.surplusTemplates = 'cut'

        this.mycanvasId = 'mycanvas_tag'
        this.mainTemplates = 'main'
      } else {
        this.labelTemplates = type
        this.mycanvasId = 'mycanvas_surplus_cut'
      }
      this.clearControlRect()
      this.currentCanvas.discardActiveObject()
      const [_, first] = this.currentCanvas.getObjects()
      if (first) {
        // this.currentCanvas.setActiveObject(first)
        if (first.typeName == 'DataSource') {
          this.genControlRect(first)
        }
        this.getKclassValueToAttr(first)
      }
      this.currentItem = first
    },
    // 小板主副标签模板切换
    handleSwitchMainTemplate(type) {
      const prevCanvas = this.currentCanvas
      this.clearControlRect()
      if (prevCanvas) {
        prevCanvas.discardActiveObject()
        prevCanvas.renderAll()
      }

      this.mainTemplates = type
      this.mycanvasId = type == 'main' ? 'mycanvas_tag' : 'mycanvas_sub_tag'

      // v-show 切换后等 DOM 显示再操作，避免副画布未就绪时报错
      this.$nextTick(() => {
        const canvas = this.currentCanvas
        if (!canvas) return
        canvas.calcOffset?.()
        const [, first] = canvas.getObjects()
        if (first) {
          if (first.typeName == 'DataSource') {
            this.genControlRect(first)
          }
          this.getKclassValueToAttr(first)
        }
        this.currentItem = first || null
        canvas.renderAll()
      })
    },
    goToSetting() {
      this.$router.push('/moreSettings')
    },
    handleEnableSubChange(val) {
      // 无权限时不允许新开启；已开启的可手动关闭
      if (val && !this.hasSecondaryLabelPermission) {
        this.enable_sub = false
        return
      }
      this.enable_sub = val
      if (!val) {
        this.mainTemplates = 'main'
        this.mycanvasId = 'mycanvas_tag'
      }
      if (val && this.isWebToQt) {
        this.$message.warning(
          this.$translateLang(
            '内嵌暂不支持副标签功能，请打开网页端云排版后使用'
          )
        )
        this.enable_sub = false
      }
    },
    // 余料模板切换
    handleSwitchSurplusTemplate(type) {
      this.surplusTemplates = type
      this.mycanvasId = `mycanvas_surplus_${type}`

      this.clearControlRect()
      this.currentCanvas.discardActiveObject()
      const [_, first] = this.currentCanvas.getObjects()
      if (first) {
        // this.currentCanvas.setActiveObject(first)
        if (first.typeName == 'DataSource') {
          this.genControlRect(first)
        }
        this.getKclassValueToAttr(first)
      }
      this.currentItem = first
    },
    changeZoom(value) {
      if (this.zoomNum <= 2.99 || this.zoomNum > 0.01) {
        this.zoomNum += value
        this[this.mycanvasId].zoomToPoint(this.canvasZoomPoint, this.zoomNum)
      }
    },
    outEdit() {
      this.$router.go(-1)
    },
    goBackPage() {
      this.$router.go(-1)
    },
    // 将保存的时候转回去的排版图条形码，保存完后再转回来
    handleRotate(data) {
      let items
      if (data.length > 1) {
        items = data.slice(1)
      } else {
        items = []
      }
      items.forEach((item) => {
        if (item.typeName == 'Typography' || item.typeName == 'Onecode') {
          if (item.plankRotate || item.rotateDeg) {
            item.rotate(item.plankRotate || item.rotateDeg)
          }
        }
      })
    },
    async save() {
      if (!this.tagName) {
        this.$message({
          message: translate('printPage.editPage.tempNamePlaceholder'),
          type: 'warning',
          duration: 1500,
        })
        return
      }
      // 副标签已开启时校验权限，过期则拦截保存
      if (this.enable_sub) {
        let hasPermission = this.hasSecondaryLabelPermission
        try {
          const res = await fetchUserPermission({
            permission_type: 'SECONDARY_LABEL',
          })
          hasPermission = Boolean(res.status && res.data?.enable)
        } catch (e) {
          hasPermission = false
        }
        if (!hasPermission) {
          this.$message({
            message: this.$translateLang(
              '副标签权限已过期，请关闭副标签后重新保存'
            ),
            type: 'warning',
            duration: 2000,
          })
          return
        }
      }
      this.currentCanvas.discardActiveObject()
      // 获取到小板模板和余料模板
      let saveData = this['mycanvas_tag']
        .getObjects()
        .filter(
          (klass) => !klass.isDeleteRect || klass.typeName !== 'controlRect'
        )
      let subSaveData = this['mycanvas_sub_tag']
        .getObjects()
        .filter(
          (klass) => !klass.isDeleteRect || klass.typeName !== 'controlRect'
        )
      // 获取裁剪余料的数据信息
      let surplusSaveData = this['mycanvas_surplus_cut']
        .getObjects()
        .filter(
          (klass) => !klass.isDeleteRect || klass.typeName !== 'controlRect'
        )
      // 获取废料余料的数据信息
      let wasteSaveData = this['mycanvas_surplus_waste']
        .getObjects()
        .filter(
          (klass) => !klass.isDeleteRect || klass.typeName !== 'controlRect'
        )
      let mock = handleTagSaveData(saveData).filter(
        (item) => item.type && item.type !== 'controlRect'
      )
      let surplusMock = handleTagSaveData(surplusSaveData).filter(
        (item) => item.type && item.type !== 'controlRect'
      )
      let wasteMock = handleTagSaveData(wasteSaveData).filter(
        (item) => item.type && item.type !== 'controlRect'
      )
      let subMock = handleTagSaveData(subSaveData).filter(
        (item) => item.type && item.type !== 'controlRect'
      )
      let img = saveData[0]
      let rectInfo = {
        left: img.left,
        top: img.top,
      }
      let name = this.tagName
      let data = {
        tem_data: mock,
        tag_width: this.tagSizeWmm,
        tag_height: this.tagSizeHmm,
        rectInfo: rectInfo,
        surplus_data: surplusMock,
        surplus_waste_data: wasteMock,
        sub_tem_data: subMock,
        enable_sub: this.enable_sub,
      }
      let payload = { name, data }
      if (this.tagId) {
        payload.id = Number(this.tagId)
      }
      this.$token('/save_tag_setting', payload, (res) => {
        if (res.status == 1) {
          // 对比原始数据和保存数据
          const oriData = this.oriTempData
          const currentData = mock

          this.$message({
            message: translate('common.saveSuccess'),
            type: 'success',
            duration: 1000,
          })
          // setTimeout(() => {
          //     this.$router.go(-1)
          // },300)
          this.saveCanvas = payload.data
          this.saveCanvas.name = payload.name
          this.handleRotate(saveData)
          this.handleRotate(surplusSaveData)
          this.handleRotate(subSaveData)
          this.handleBuryPoint()
        } else {
          this.$message({
            message: `${res.msg},${res.data.err_msg}`,
            type: 'error',
            duration: 1000,
          })
        }
      })
    },
    handleBuryPoint() {
      // 仅初始未开启、本次保存开启时埋点
      if (!this.initialEnableSub && this.enable_sub) {
        buryPointApi('tag', 'enable_sub')
        this.initialEnableSub = true
      }
    },
    resetParameter() {
      const allObjects = this.currentCanvas.getObjects()
      const activeObjects = this.currentCanvas
        .getActiveObjects()
        .map((object) => {
          // 当活跃对象是控制元素时寻找其控制的元素
          if (isControlRectEl(object)) {
            return allObjects.find(
              (_object) =>
                _object !== object && _object.item_id === object.item_id
            )
          }
          return object
        })
      activeObjects.forEach((current) => {
        if (current?.opacity && current?.opacity !== 0.25) {
          current.opacity = 0.25
        }
        // 需要先将板件图转成正常位置
        if (current.typeName == 'Typography' && current.plankRotate) {
          current.rotate(0)
        }
        const { left, top } = getPositionByCanvas(current)
        this.currentCanvas.remove(current)
        // 删除孔槽图的子集
        if (
          current.typeName == 'holeSlotPicture' ||
          current.typeName == 'sideMachiningSequenceDiagram'
        ) {
          current.auxiliaryEl?.forEach((klass) => {
            this.currentCanvas.remove(klass)
          })
          current.partEdgeElList?.forEach((klass) => {
            this.currentCanvas.remove(klass)
          })
        }
        this.resetData(current.typeName)
        this.reDrawByCurrentPostion({ x: left, y: top }, current.typeName)
        // 取消选区状态，避免一些意外的显示效果
        this.currentCanvas.discardActiveObject()
      })
    },
    backDefault() {
      // if(this.tagId){
      let deleteObjs = this[this.mycanvasId].getObjects()
      for (let i in deleteObjs) {
        this[this.mycanvasId].remove(deleteObjs[i])
      }
      let backData = this.saveCanvas
      this.currentItem = null
      this.tagSizeWmm = backData.tag_width
      this.tagSizeHmm = backData.tag_height
      this.rectData = backData.rectInfo
      // 当前所在的标签编辑页面
      if (this.labelTemplates == 'plank') {
        const temData =
          this.mainTemplates == 'sub'
            ? resolveSubTagTemData(backData.sub_tem_data)
            : backData.tem_data
        this.draw(temData, true, this.mycanvasId)
      } else {
        this.draw(
          backData?.surplus_data ?? backData?.surplus_tem_data,
          true,
          this.mycanvasId
        )
      }
      // }else{
      //     let deleteObjs = this.mycanvas.getObjects().slice(1)
      //     for(let i in deleteObjs){
      //         this.mycanvas.remove(deleteObjs[i])
      //     }
      //     this.mycanvas.renderAll()
      // }
    },
    /** 输入搜索 */
    handleSearchDiameter(val) {
      const hasExist = this.oriDiameterOption.some((item) => item == val)
      if (val && !hasExist) {
        this.diameterOpeion = [...this.oriDiameterOption, val]
      } else {
        this.diameterOpeion = this.oriDiameterOption
      }
    },
    /** 删除选中元素 */
    deleteEl(objects) {
      objects = objects || this.currentCanvas.getActiveObjects()
      const allObjects = this.currentCanvas.getObjects()
      // 删除元素内如果存在控制块元素需要删除其源元素
      objects.forEach((object) => {
        if (object.typeName == 'controlRect') {
          objects.push(
            allObjects.find(
              (it) => it.item_id === object.item_id && !isControlRectEl(it)
            )
          )
        }
      })
      objects.forEach((current) => {
        this.deleteCurrentData(current)
      })
      if (!objects?.length) {
        return this.$message({
          message: translate('printPage.editPage.deleteAreaTip'),
          type: 'warning',
          duration: 1000,
        })
      }
      // 删除板件标注蓝框
      this[this.mycanvasId].discardActiveObject()
      this[this.mycanvasId].renderAll()
      // 清空已选中板件标注
      this.currentItem = null
      this.$message({
        message: translate('common.deleteSuccess'),
        type: 'success',
        duration: 1000,
      })
    },
    // 删除板件标注
    deleteCurrentData(current) {
      if (current) {
        this.countOldTem()
        this[this.mycanvasId].remove(current)
        this.clearControlRect()
        this[this.mycanvasId].renderAll()
        // 删除的是板件标注 同时需要删除板件标注框体
        if (this.plankSignBox.length && current.source_data == 'plankSign') {
          let box = this[this.mycanvasId]
            .getObjects()
            .find(
              (klass) =>
                klass.source_data == 'plankSignBox' &&
                klass.item_id == current.item_id
            )
          this[this.mycanvasId].remove(box)
          let index = this.plankSignBox.findIndex(
            (klass) => klass.item_id == current.item_id
          )
          this.plankSignBox.splice(index, 1)
        }
        // 删除主元素 附属元素一同删除
        if (current.auxiliaryEl) {
          current.auxiliaryEl?.forEach((klass) => {
            this[this.mycanvasId].remove(klass)
          })
        }
        if (current.partEdgeElList) {
          current.partEdgeElList?.forEach((klass) => {
            this[this.mycanvasId].remove(klass)
          })
        }
      }
    },
    changeWordWrap() {
      // 自动换行
      this.countOldTem()
      let current = this.currentItem
      if (current) {
        current.set({
          splitByGrapheme: this.splitByGrapheme,
        })
        this[this.mycanvasId].renderAll()
      }
    },
    handleTextAlignChange(value) {
      // 对齐方式
      this.countOldTem()
      let current = this.currentItem
      if (current) {
        current.set({
          textAlign: value,
        })
        this[this.mycanvasId].renderAll()
      }
    },
    handleDiameterChange(value) {
      this.countOldTem()
      let current = this.currentItem
      if (current) {
        let groupItems = current.getObjects()
        let pValue = mmToPx(value / 2, this.arrDPI)

        if (value > 0) {
          groupItems[0].set({
            radius: pValue,
            // left: -pValue,
            // top: -pValue,
            mRadius: value,
            realRadius: value,
          })
          const maxWidth = Math.max(...groupItems.map((item) => item.width))
          const maxHeight = Math.max(...groupItems.map((item) => item.height))
          const maxSize = Math.max(maxWidth, maxHeight)
          current.set({
            width: maxSize,
            height: maxSize,
            visible: true,
          })
          groupItems[0].set({
            visible: true,
          })
        } else {
          groupItems[0].set({
            mRadius: 0,
            realRadius: 0,
            visible: false,
          })
        }

        this[this.mycanvasId].renderAll()
      }
    },
    handleGraColorChange(value) {
      this.countOldTem()
      let current = this.currentItem
      if (current) {
        current.set({
          fill: value,
        })
      }
      this[this.mycanvasId].renderAll()
    },
    handleBorderColorChange(value) {
      this.countOldTem()
      let current = this.currentItem
      if (current) {
        current.set({
          stroke: value,
        })
      }
      this[this.mycanvasId].renderAll()
    },
    changeAngle(value) {
      this.countOldTem()
      let current = this.currentItem
      if (current) {
        current.set({
          angle: value,
        })
      }
      this[this.mycanvasId].renderAll()
    },
    changeTagSize(type, value) {
      this.countOldTem()
      if (type == 'w') {
        this.tagSizeWPx = mmToPx(value, this.arrDPI)
        this.setTagTimer = setTimeout(() => {
          clearTimeout(this.setTagTimer)
          let rect = this['mycanvas_tag'].getObjects()[0]
          let rect2 = this['mycanvas_surplus_cut'].getObjects()[0]
          let rect3 = this['mycanvas_surplus_waste'].getObjects()[0]
          let rect4 = this['mycanvas_sub_tag']?.getObjects()?.[0]
          rect.set('width', this.tagSizeWPx)
          rect2.set('width', this.tagSizeWPx)
          rect3.set('width', this.tagSizeWPx)
          rect4?.set('width', this.tagSizeWPx)
          this['mycanvas_tag'].renderAll()
          this['mycanvas_tag'].item(0).setCoords()
          this['mycanvas_surplus_cut'].renderAll()
          this['mycanvas_surplus_cut'].item(0).setCoords()
          this['mycanvas_surplus_waste'].renderAll()
          this['mycanvas_surplus_waste'].item(0).setCoords()
          if (rect4) {
            this['mycanvas_sub_tag'].renderAll()
            this['mycanvas_sub_tag'].item(0).setCoords()
          }
        }, 100)
      } else {
        this.tagSizeHPx = mmToPx(value, this.arrDPI)
        this.setTagTimer = setTimeout(() => {
          clearTimeout(this.setTagTimer)
          let rect = this['mycanvas_tag'].getObjects()[0]
          // 拿到所有typeName为sixSideDrillTriangle的元素，应该是一个数组
          let sixSideDrillTriangle = this['mycanvas_tag']
            .getObjects()
            .filter((item) => item.typeName === 'sixSideDrillTriangle')
          if (sixSideDrillTriangle.length) {
            sixSideDrillTriangle.forEach((item) => {
              this.drawSixSideDrillTriangle(item, true)
            })
          }
          rect.set('height', this.tagSizeHPx)
          this['mycanvas_tag'].renderAll()
          this['mycanvas_tag'].item(0).setCoords()
          let rect2 = this['mycanvas_surplus_cut'].getObjects()[0]
          rect2.set('height', this.tagSizeHPx)
          this['mycanvas_surplus_cut'].renderAll()
          this['mycanvas_surplus_cut'].item(0).setCoords()
          let rect3 = this['mycanvas_surplus_waste'].getObjects()[0]
          rect3.set('height', this.tagSizeHPx)
          this['mycanvas_surplus_waste'].renderAll()
          this['mycanvas_surplus_waste'].item(0).setCoords()
          let rect4 = this['mycanvas_sub_tag']?.getObjects()?.[0]
          if (rect4) {
            rect4.set('height', this.tagSizeHPx)
            this['mycanvas_sub_tag'].renderAll()
            this['mycanvas_sub_tag'].item(0).setCoords()
          }
        }, 50)
      }
    },
    async chooseTagSet(item) {
      if (this.chooseOtherSet) {
        this.resetData(item.type.split(',')[0])
        this.nowChooseSet = item.type.split(',')[0]
        this.currentItem = null
      }
    },
    /** @desc 设置字体大小 */
    handleFontSizeChange(value, current) {
      const tempValue = Number(this.inputCheck(value))
      this.countOldTem()
      if (current) {
        let px = PtToPx(tempValue, this.arrDPI)
        current.set({
          fontSize: px,
          fontPt: tempValue,
        })
        if (current.source_data == 'plankSign') {
          let box = this[this.mycanvasId]
            .getObjects()
            .find(
              (item) =>
                item.source_data == 'plankSignBox' &&
                item.item_id == current.item_id
            )
          if (box) {
            this[this.mycanvasId].remove(box)
            this.drawAllSignRect()
          }
        }
        if (current.typeName == 'Onecode') {
          // let text = current.getObjects()[1]
          // text.set({
          //     fontSize: PtToPx(value,this.arrDPI),
          //     fontPt:value
          // })
          let img = current.getObjects()[0]
          img.set({
            fontSize: px,
            fontPt: tempValue,
          })
          this.upDateImg(current, this.codeAtt, img)
        } else if (
          current.typeName == 'Typography' ||
          current.typeName == 'SurplusSize'
        ) {
          let items = current.getObjects()
          const openKlass = items.filter((klass) => klass.uniqueID)
          items = items.filter((klass) => !klass.uniqueID)
          const oldW = items[1].width
          const oldH = items[1].height / 2
          items.forEach((item, index) => {
            if (index) {
              item.set({
                fontSize: px,
                fontPt: tempValue,
              })
            }
          })
          openKlass.forEach((klass) => {
            klass.set({
              left: klass.left - oldW + items[1].width,
              top: klass.top - oldH + items[1].height / 2,
            })
          })
        } else if (
          current.typeName == 'wardrobeNum' ||
          current.typeName == 'Marking' ||
          current.typeName == 'smallPlateMarking'
        ) {
          let textItem = current.getObjects()[1]
          textItem.set({
            fontSize: px,
            fontPt: tempValue,
          })
        } else if (current.typeName == 'holeSlotPicture') {
          current.auxiliaryEl?.forEach((klass) => {
            klass.fontF({ fontSize: px, fontPt: tempValue })
          })
          current.partEdgeElList?.forEach((klass) => {
            klass.fontF({ fontSize: px, fontPt: tempValue })
          })
        } else if (current.typeName == 'sideMachiningSequenceDiagram') {
          current.set({
            fontPt: tempValue,
            textFontSize: px,
          })
          current.auxiliaryEl?.forEach((klass) => {
            klass.fontF({ fontSize: px, fontPt: tempValue })
          })
        } else if (current.typeName === 'Table') {
          this.handleChangeTableSize(value, current)
        }
      }
      this.changeKlassControlRect(current)
      this[this.mycanvasId].renderAll()
    },
    inputCheck(value) {
      let reg = /[^\d]/
      if (reg.test(value) || value < 4 || value > 32) {
        this.inputAlert.fontSizeAlert = '请输入4-32的整数'
        this.nowFontSize = 8
        value = 8
      } else {
        this.inputAlert.fontSizeAlert = ''
      }
      return value
    },
    handleFontFamilyChange(value, current) {
      if (current) {
        current.set({
          fontFamily: value,
        })
        if (current.typeName == 'Onecode') {
          let img = current.getObjects()[0]
          img.set({
            fontFamily: value,
          })
          this.upDateImg(current, this.codeAtt, img)
        } else if (
          current.typeName == 'Typography' ||
          current.typeName == 'SurplusSize'
        ) {
          let items = current.getObjects()
          items = items.filter((klass) => !klass.uniqueID) // 开门方向的uniqueID是 showDoor
          items.forEach((item, index) => {
            if (index) {
              item.set({
                fontFamily: value,
              })
            }
          })
        } else if (
          current.typeName == 'wardrobeNum' ||
          current.typeName == 'Marking' ||
          current.typeName == 'smallPlateMarking'
        ) {
          let textItem = current.getObjects()[1]
          textItem.set({
            fontFamily: value,
          })
        } else if (current.typeName == 'holeSlotPicture') {
          current.auxiliaryEl?.forEach((klass) => {
            klass.fontF({ fontFamily: value })
          })
          current.partEdgeElList?.forEach((klass) => {
            klass.fontF({ fontFamily: value })
          })
        } else if (current.typeName == 'sideMachiningSequenceDiagram') {
          current.auxiliaryEl?.forEach((klass) => {
            klass.fontF({ fontFamily: value })
          })
        } else if (current.typeName == 'Table') {
          this.handleChangeTableSize(this.nowFontSize, current)
        }
      }
      this[this.mycanvasId].renderAll()
    },
    /** @desc 改变文本字体加粗 */
    changeFontWeight(current) {
      this.countOldTem()
      if (current) {
        if (current.typeName == 'Onecode') {
          // let text = current.getObjects()[1]
          // text.set({
          //     fontWeight:"bold"
          // })
          let img = current.getObjects()[0]
          img.set({
            fontWeight: this.fontWeight ? 'bold' : '',
          })
          this.upDateImg(current, this.codeAtt, img)
        } else if (
          current.typeName == 'Typography' ||
          current.typeName == 'SurplusSize'
        ) {
          let items = current.getObjects()
          items.forEach((e, i) => {
            if (i) {
              e.set({
                fontWeight: this.fontWeight ? 'bold' : '',
              })
            }
          })
        } else if (
          current.typeName == 'wardrobeNum' ||
          current.typeName == 'Marking' ||
          current.typeName == 'smallPlateMarking'
        ) {
          let item = current.getObjects()[1]
          item.set({
            fontWeight: this.fontWeight ? 'bold' : '',
          })
        } else if (current.typeName == 'holeSlotPicture') {
          current.auxiliaryEl?.forEach((klass) => {
            klass.fontF({ fontWeight: this.fontWeight ? 'bold' : '' })
          })
          current.partEdgeElList?.forEach((klass) => {
            klass.fontF({ fontWeight: this.fontWeight ? 'bold' : '' })
          })
        } else if (current.typeName == 'sideMachiningSequenceDiagram') {
          current.auxiliaryEl?.forEach((klass) => {
            klass.fontF({ fontWeight: this.fontWeight ? 'bold' : '' })
          })
        } else {
          current.set({
            fontWeight: this.fontWeight ? 'bold' : '',
          })
        }
      }
      this[this.mycanvasId].renderAll()
    },
    // 翻面加工
    handleChangeIsFlipOverProcessing() {
      this.countOldTem()
      let current = this.currentItem
      current.set({
        flipOverProcessing: this.isFlipOverProcessing,
      })
    },
    // 显示图例内框
    handleChangeIsShowSideMachiningSequenceDiagramBorder() {
      this.countOldTem()
      let current = this.currentItem
      current.set({
        showSideMachiningSequenceDiagramBorder:
          this.isShowSideMachiningSequenceDiagramBorder,
      })
      // 找到组内的矩形并更新其边框显隐
      if (current && current.getObjects) {
        const allObjects = current.getObjects()
        const baseRect = allObjects.find(
          (obj) => obj.typeName === 'sideMachiningSequenceDiagramBaseRect'
        )
        if (baseRect && baseRect.borderShowF) {
          baseRect.borderShowF(this.isShowSideMachiningSequenceDiagramBorder)
        }
        current.set({
          showSideMachiningSequenceDiagramBorder:
            this.isShowSideMachiningSequenceDiagramBorder,
        })
      }
      this[this.mycanvasId].renderAll()
    },
    // 显示数字加工顺序
    handleChangeIsShowSideMachiningSequenceNumber() {
      this.countOldTem()
      let current = this.currentItem
      current.set({
        showSideMachiningSequenceNumber: this.isShowSideMachiningSequenceNumber,
      })
      current.auxiliaryEl?.forEach((klass) => {
        klass.set({
          opacity: this.isShowSideMachiningSequenceNumber ? 1 : 0,
        })
      })
      this[this.mycanvasId].renderAll()
    },
    // 90°旋转
    changePlankRotate(deg) {
      this.countOldTem()
      let current = this.currentItem
      current.rotate(deg)
      current.set({
        plankRotate: this.plankRotate,
        rotateDeg: deg,
      })
      this[this.mycanvasId].renderAll()
    },
    // 显示开门方向
    changeShowOpenDoor() {
      this.countOldTem()
      let current = this.currentItem
      const klassArr = current.getObjects()
      if (klassArr.length) {
        const openDoor = klassArr.filter(
          (klass) => klass.uniqueID == 'showDoor'
        )
        openDoor.forEach((klass) => {
          klass.set({
            opacity: Number(this.showOpenDoor),
          })
        })
      }
      current.set({
        showOpenDoor: this.showOpenDoor,
      })
      this[this.mycanvasId].renderAll()
    },
    // 显示封边信息
    changeShowEdgeOff() {
      this.countOldTem()
      let current = this.currentItem
      current.set({
        showEdgeOff: this.showEdgeOff,
      })
    },
    changeShowEdgeDisplay(type) {
      if (type == 'isShowDiffEdgeColor') {
        buryPointApi('tag', 'show_diff_edge_color')
      }
      if (type == 'hideSameEdgeColorAsPlank') {
        buryPointApi('tag', 'hide_same_edge_color_as_plank')
      }
      this.countOldTem()
      let current = this.currentItem
      current.set({
        [type]: this[type],
      })
      this[this.mycanvasId].renderAll()
    },
    // 是否有小数点位数限制
    changeSizeRestrict() {
      this.countOldTem()
      let current = this.currentItem
      if (current) {
        if (
          current.source_data == 'oSize' ||
          current.source_data == 'cutSize'
        ) {
          current.set({
            sizeRestrict: this.sizeRestrict,
          })
        }
      }
    },
    /** 小数点位数限制调整 */
    changeSizeRestrictNum(num) {
      this.countOldTem()
      this.currentItem?.set({
        sizeRestrictNum: num,
      })
    },
    changeGroupTextAttribute(klassArr, data, key = null, otherData = {}) {
      let d = klassArr
      if (key) {
        d = klassArr.filter((klass) => klass[key])
      }
      d.forEach((klass) => {
        klass.set(Object.assign(data, otherData))
      })
    },
    // 切换显示孔槽状态
    changeIsHole(key) {
      this.countOldTem()
      const current = this.currentItem
      current.set({
        [key]: this[key],
      })
    },
    // 切换显示大板尺寸状态
    changePlankSize() {
      this.countOldTem()
      const current = this.currentItem
      current.auxiliaryEl?.forEach((klass) => {
        klass.showF()
      })
      this[this.mycanvasId].renderAll()
    },
    // 切换显示小板封边
    changePlankEdgeShow() {
      this.countOldTem()
      this.changeIsHole('partEdge')
      const current = this.currentItem
      current.partEdgeElList?.forEach((klass) => {
        klass.showF()
      })
      this[this.mycanvasId].renderAll()
    },
    handleLineSpaceChange(value) {
      this.countOldTem()
      let current = this.currentItem
      if (current) {
        if (current.typeName == 'Onecode') {
          let img = current.getObjects()[0]
          this.upDateImg(current, this.codeAtt, img)
          img.set({
            lineHeight: value,
          })
        } else {
          current.set({
            lineHeight: value,
          })
        }
      }
      this[this.mycanvasId].renderAll()
    },
    handleLineCountAttrChange() {
      let current = this.currentItem

      if (!current) return

      const { text, oriText, fontSize } = dealTextStr(
        current.oriText || current.text,
        current.fontSize,
        current.rectWidth,
        current.rectHeight,
        this.isAutoFontSize,
        this.lineCount
      )
      this.nowFontSize = fontSize
      // 重新获取当前文本信息
      const textObj = new fabric.Text(text, {
        fontSize,
      })
      current.fontSize = fontSize
      current.text = text
      current.oriText = oriText
      current.rectWidth = textObj.width
      current.rectHeight = textObj.height
      // 更新控制框体
      this.controlRects[0].set({
        width: textObj.width,
        height: textObj.height,
      })
      current.set({
        lineCount: this.lineCount,
      })
      this[this.mycanvasId].renderAll()
      buryPointApi('tag', 'line_count')
    },
    handleCodeRotateDegChange(deg) {
      const oriLeft = this.currentItem.left
      const oriTop = this.currentItem.top
      this.currentItem.rotate(deg)
      this.currentItem.set({
        rotateDeg: deg,
        oriLeft,
        oriTop,
      })
      this[this.mycanvasId].renderAll()
    },
    handleCodeAttChange(value) {
      let current = this.currentItem
      if (value == 'EAN13') {
        this.fontSizeOpeion = [4, 6, 8]
      } else {
        this.fontSizeOpeion = [4, 6, 8, 10, 12, 14, 16, 20, 26, 32]
      }
      if (current) {
        let img = current.getObjects()[0]
        img.set({
          code_type: value,
        })
        this.upDateImg(current, this.codeAtt, img)
      }
    },
    // 切换数据信息报错 报错原因：余料的数据信息还未从接口获取
    handleDataSourcesChange(value) {
      // 触发事件导致报错，需要获取this.nowDataSources的数据
      this.countOldTem()
      let current = this.currentItem
      if (current) {
        let text = this.nowDataSources.filter((item) => {
          if (item.value == value) {
            return item
          }
        })[0].text
        let textC = new fabric.Text(text, {
          fontSize: current.fontSize,
        })
        const {
          text: str,
          fontSize,
          oriText,
        } = dealTextStr(
          text,
          current.fontSize,
          current.rectWidth ?? textC.width,
          current.rectHeight ?? textC.height,
          this.isAutoFontSize,
          this.lineCount
        )
        current.oriText = oriText
        current.set({
          text: str,
          source_data: value,
          fontPt: Math.ceil(PxToPt(fontSize)),
          fontSize: fontSize,
        })
        // 同步一下标签上的小数位数限制
        this.sizeRestrict = current.sizeRestrict
        // 每次切换为板件标注时添加， 不是则查看是否是板件标注切换的，是则删除数组中存在的板件标注并重新绘制框体
        if (current.source_data == 'plankSign') {
          this.plankSignBox.push(current)
          this.drawAllSignRect()
        } else {
          let index = this.plankSignBox.findIndex(
            (klass) => klass.item_id == current.item_id
          )
          if (index !== -1) {
            let box = this[this.mycanvasId]
              .getObjects()
              .find(
                (klass) =>
                  klass.source_data == 'plankSignBox' &&
                  klass.item_id == this.plankSignBox[index].item_id
              )
            if (box) {
              this[this.mycanvasId].remove(box)
            }
            this.plankSignBox.splice(index, 1)
          }
        }
      }
      this[this.mycanvasId].renderAll()
    },
    // 绘制单个板件标注的框体
    drawSignRect(current) {
      const { top, left, width, height } = current
      let rect = new fabric.Rect({
        top: top - pxTomm(30, this.arrDPI) / 2,
        left: left - pxTomm(30, this.arrDPI) / 2,
        width: width + pxTomm(30, this.arrDPI),
        stroke: 1,
        fill: 'transparent',
        height: height + pxTomm(30, this.arrDPI),
        source_data: 'plankSignBox',
        typeName: 'DataSource',
        item_id: current.item_id,
        hasControls: false,
      })
      this[this.mycanvasId].add(rect)
      this[this.mycanvasId].setActiveObject(rect)
    },
    // 重绘所有板件标注
    drawAllSignRect() {
      this[this.mycanvasId]
        .getObjects()
        .filter((klass) => klass.source_data == 'plankSignBox')
        .forEach((klass) => this[this.mycanvasId].remove(klass))
      this.plankSignBox.forEach((klass) => {
        this[this.mycanvasId].remove(klass)
        this[this.mycanvasId].add(klass)
        this.drawSignRect(klass)
      })
    },
    changeCodeShowValue(value) {
      let current = this.currentItem
      if (current) {
        current.set({
          showCode: value,
        })
      }
    },
    changeCodeShowValueShunt(value) {
      let current = this.currentItem
      if (current) {
        current.set({
          switchCodeValueShunt: value,
        })
        buryPointApi('tag', 'suitShuntSetting')
      }
    },
    handleCodeChange(value) {
      this.countOldTem()
      // 设置条形码数据源
      let current = this.currentItem
      if (this.nowChooseSet == 'Onecode') {
        let activs = current.getObjects()
        let img = activs[0]
        // let text = activs[1]
        if (['plankNum', 'oriPlankNum', 'remarks', 'ncName'].includes(value)) {
          this.codeAttOpeion = mockData.codeAttOpeion
          this.codeAtt = 'EAN13'
          this.upDateImg(current, this.codeAtt, img)
          img.set({
            source_data: value,
            code_type: 'EAN13',
          })
          // text.set({
          //     text:'6160479583801'
          // })
        } else {
          this.codeAttOpeion = mockData.codeAttOpeionK
          this.codeAtt = 'CODE128'
          this.upDateImg(current, this.codeAtt, img)
          img.set({
            source_data: value,
            code_type: 'CODE128',
          })
          // text.set({
          //     text:'6160479583801K'
          // })
        }
      } else {
        current.set({
          source_data: value,
        })
      }

      this[this.mycanvasId].renderAll()
    },
    /**
     * 选择特殊标记符号 绘制对应图形
     * @param {Object} current 当前选中的组件
     * @param {String} type 当前绘制类型 init：初始化时绘制，handler： 操作时绘制
     * @param {String} canvasId 目标画布 id（初始化多画布时必须传入，避免异步落到错误画布）
     * @return
     * @author zhouchi 2024-07-16
     * */
    selectSpecialMark(current = {}, type, canvasId) {
      const targetCanvasId = canvasId || this.mycanvasId
      if (current?.opacity && type === 'init')
        this.inputOpacity = current.opacity
      else this.inputOpacity = 0.25
      const defaultData = {
        width: 10,
        height: 10,
      }
      let specialMarkW = mmToPx(defaultData.width, this.arrDPI)
      let specialMarkH = mmToPx(defaultData.height, this.arrDPI)
      let specialMarkOx = current?.left ?? this.overUpPoint.x
      let specialMarkoy = current?.top ?? this.overUpPoint.y
      let pointArr1 = [
        {
          x: specialMarkOx,
          y: specialMarkoy + specialMarkH, //1
        },
        {
          x: specialMarkOx + specialMarkW / 2, //2
          y: specialMarkoy,
        },
        {
          x: specialMarkOx + specialMarkW,
          y: specialMarkoy + specialMarkH, //3
        },
      ]
      const options =
        type === 'init'
          ? {
              top: current.top,
              left: current.left,
              hasControls: current.hasControls,
              typeName: current.typeName,
              item_id: current.item_id,
              angle: current.angle,
              fill: current.fill,
              originX: 'center',
              originY: 'center',
              mWidth: current.mWidth,
              mHeight: current.mHeight,
              scaleX: current.scaleX,
              scaleY: current.scaleY,
              opacity: current.opacity,
            }
          : {
              top: specialMarkoy,
              left: specialMarkOx,
              opacity: this.inputOpacity,
              typeName: 'specialMark',
              hasControls: true,
              originX: 'center',
              originY: 'center',
            }

      Promise.resolve().then(() => {
        setTimeout(() => {
          const canvas = this[targetCanvasId]
          if (!canvas) return
          let specialMark = new fabric.Polygon(pointArr1, options)
          // 禁止旋转
          this.setItemId(specialMark)
          specialMark.setControlVisible('mtr', false)
          this.currentItem = specialMark
          canvas.add(specialMark)
          this.getKclassValueToAttr(specialMark)
        })
      })
    },
    /**
     * 选择板件标记（不包括特殊标记符号）
     * @param {Object} current 当前选中的组件
     * * @return
     * @author zhouchi 2024-07-16
     * */
    selectWardrobeNum(current) {
      const position = {
        radius: this.drawDiameter,
        fontSize: this.nowFontSize,
        left: current?.left ?? this.overUpPoint.x,
        top: current?.top ?? this.overUpPoint.y,
        fontFamily: this.nowFontFamily,
        fontWeight: this.fontWeight ? 'bold' : '',
        roomSortWay: this.roomSortWay,
        realRadius: this.nowDiameter,
      }
      this.drawOrderOrPanel(this.partSignValue, position, 'wardrobeNum')
    },

    /**
     * 选择孔槽图数据信息 绘制孔槽图或者加工顺序图
     * @param {String} value 当前选中的孔槽图数据信息
     * @return
     * @author bhc 2026-01-22
     * */
    handleHoleSlotPictureChange(value) {
      // 删除当前选中的元素，并保存位置
      const current = this.currentItem
      let drawPosition = this.overUpPoint
      if (
        current &&
        (current.typeName === 'holeSlotPicture' ||
          current.typeName === 'sideMachiningSequenceDiagram')
      ) {
        // 保存元素位置
        drawPosition = {
          x: current.left || this.overUpPoint.x,
          y: current.top || this.overUpPoint.y,
        }
        // 删除附属元素
        if (current.auxiliaryEl) {
          current.auxiliaryEl.forEach((klass) => {
            this[this.mycanvasId].remove(klass)
          })
        }
        if (current.partEdgeElList) {
          current.partEdgeElList.forEach((klass) => {
            this[this.mycanvasId].remove(klass)
          })
        }
        // 删除主元素
        this[this.mycanvasId].remove(current)
        this[this.mycanvasId].renderAll()
      }

      if (value === 'holeSlotPicture') {
        this.codeW = 19
        this.codeH = 19
        this.pictureScale = 1
        this.reDrawByCurrentPostion(drawPosition, 'holeSlotPicture')
        // 绘制孔槽图
      } else {
        this.codeW = 20
        this.codeH = 20
        this.triangleSize = 6
        this.isFlipOverProcessing = false
        this.isShowSideMachiningSequenceDiagramBorder = true
        this.isShowSideMachiningSequenceNumber = true
        this.reDrawByCurrentPostion(
          drawPosition,
          'sideMachiningSequenceDiagram'
        )
        // 绘制加工顺序图
      }
    },

    /**
     * 见光or前边选择变化 绘制见光边or前封边
     * @param value 见光or前边选择
     */
    handleVisibleEdgeOrFrontEdgeChange(value) {
      this.visibleEdgeOrFrontEdge = value
      // 删除当前选中的元素，并保存位置
      const current = this.currentItem
      let drawPosition = this.overUpPoint
      if (
        current &&
        (current.typeName === 'VisibleEdge' || current.typeName === 'FrontEdge')
      ) {
        // 保存元素位置
        drawPosition = {
          x: current.left || this.overUpPoint.x,
          y: current.top || this.overUpPoint.y,
        }
        // 删除主元素
        this[this.mycanvasId].remove(current)
        this[this.mycanvasId].renderAll()
        this.reDrawByCurrentPostion(drawPosition, value)
      }
    },
    /**
     * 显示样式变化 三角形 矩形
     * @param value 显示样式
     */
    handleVisibleEdgeOrFrontEdgeStyleChange(value) {
      this.visibleEdgeOrFrontEdgeStyle = value
      // 删除当前选中的元素，并保存位置
      const current = this.currentItem
      let drawPosition = this.overUpPoint
      if (
        current &&
        (current.typeName === 'VisibleEdge' || current.typeName === 'FrontEdge')
      ) {
        const typeName = current.typeName
        // 保存元素位置
        drawPosition = {
          x: current.left || this.overUpPoint.x,
          y: current.top || this.overUpPoint.y,
        }
        // 删除主元素
        this[this.mycanvasId].remove(current)
        this[this.mycanvasId].renderAll()
        this.reDrawByCurrentPostion(drawPosition, typeName)
      }
    },

    // 板件标记变化，由于需要兼容之前数据 所以还是采用的wardrobeNum作为标识，wardrobeNum现代表partSign
    handlePartSign(value) {
      let current = this.currentItem
      let fieldValue = ''
      let textValue = ''
      if (value === 'specialMark') {
        this.temp = current
        //移除板件标记
        this[this.mycanvasId].remove(current)
        this.selectSpecialMark(current, 'handler')
        return
      }
      if (value === 'smallPlateMarking') {
        // 从其他标记类型切换为小板标记时使用默认尺寸，避免沿用上一块已调整的尺寸
        if (current?.typeName !== 'smallPlateMarking') {
          this.smallPlateW = 30
          this.smallPlateH = 18
        }
        this.drawSmallPlateMarking(current)
        return
      }
      if (value === 'sixSideDrillPlankBase') {
        this[this.mycanvasId].remove(current)
        if (this.sixSideDrillPlankBaseGraph === 'arrow') {
          this.drawSixSideDrillArrow(current)
        } else {
          this.drawSixSideDrillTriangle(current)
        }
        return
      }
      current = this.currentItem

      if (
        this.currentItem.typeName === 'specialMark' ||
        this.currentItem.typeName === 'smallPlateMarking' ||
        this.currentItem.typeName === 'sixSideDrillArrow' ||
        this.currentItem.typeName === 'sixSideDrillTriangle'
      ) {
        this[this.mycanvasId].remove(current)
        this.selectWardrobeNum(current)
        this[this.mycanvasId].setActiveObject(this.currentItem)
      }
      const text = this.currentItem?.getObjects?.()[1]
      const group = this.currentItem?.getObjects?.()[0]
      const radius = group.mRadius

      //柜体序号
      if (value === 'wardrobeNum') {
        textValue = '1'
        fieldValue = 'wardrobeNum'
      } else if (value === 'isFrontPlank') {
        //面板标记
        textValue = '面'
        fieldValue = 'isFrontPlank'
      } else {
        // 选择了按房间排序后，由于内容较多，因此判断如果当前的圆框直径是4的话，就重新赋值为6
        if (radius === 4) {
          this.nowDiameter = 6
          this.handleDiameterChange(6)
        }
        // 柜体序号，按房间排序，默认按字母排序
        textValue = 'A-1'
        this.roomSortWay = 'letters'
        fieldValue = `wardrobeNumToRoom`
      }

      // 根据内容调整框选大小
      const groupItems = this.currentItem.getObjects()
      const maxWidth = Math.max(...groupItems.map((item) => item.width))
      const maxHeight = Math.max(...groupItems.map((item) => item.height))
      const maxSize = Math.max(maxWidth, maxHeight)
      this.currentItem.set({
        field: fieldValue,
        width: maxSize,
        height: maxSize,
      })
      text.set({
        text: textValue,
        roomSortWay: this.roomSortWay,
      })
      this[this.mycanvasId].renderAll()
    },
    handleTableChange(value) {
      const { top, left, fontSize, fontPt } = this.currentItem
      this[this.mycanvasId].remove(this.currentItem)
      const tableUrl = fabricTable(
        this[this.mycanvasId],
        true,
        false,
        fontSize * 2,
        value
      )
      fabric.Image.fromURL(tableUrl, (img) => {
        img.set({
          top,
          left,
          hasControls: false,
          source_data: value,
          fontSize,
          fontPt,
          typeName: 'Table',
          mWidth: img.width,
          mHeight: img.height,
          // pxWidth: mmToPx(this.codeW, this.arrDPI),
          // pxHeight: mmToPx(this.codeH, this.arrDPI),
          showCode: true,
          scaleX: 0.5,
          scaleY: 0.5,
        })
        this.setItemId(img)
        this[this.mycanvasId].add(img)
        this.currentItem = img
        this[this.mycanvasId].setActiveObject(this.currentItem)
      })
    },
    handleChangeTableSize(value, current) {
      let tempValue = value
      tempValue = Number(this.inputCheck(tempValue))
      const { source_data, fontFamily } = current
      const { left, top } = getPositionByCanvas(current)
      let px = PtToPx(tempValue, this.arrDPI)
      this[this.mycanvasId].remove(current)
      const tableUrl = fabricTable(
        this[this.mycanvasId],
        true,
        false,
        px * 2,
        source_data,
        10,
        10,
        fontFamily
      )
      fabric.Image.fromURL(tableUrl, (img) => {
        img.set({
          top,
          left,
          hasControls: true,
          source_data,
          fontSize: px,
          fontPt: tempValue,
          typeName: 'Table',
          mWidth: img.width,
          mHeight: img.height,
          // pxWidth: mmToPx(this.codeW, this.arrDPI),
          // pxHeight: mmToPx(this.codeH, this.arrDPI),
          showCode: true,
          scaleX: 0.5,
          scaleY: 0.5,
          fontFamily,
        })
        img.setControlVisible('mtr', false)
        this.setItemId(img)
        this[this.mycanvasId].add(img)
        const instance = this.getCurrentUseSelectedControl()
        // 因为这里要重建选区，需要提前存储一份活跃对象(麻啦)
        instance?.addActiveToPre()
        this.currentCanvas.discardActiveObject()
        this.currentCanvas.renderAll()
        // 避免在多选的情况下取消掉了多选的选中
        if (this.activeElementCount === 1) {
          this[this.mycanvasId].setActiveObject(this.currentItem)
          this.currentItem = img
        } else {
          // 执行两次因为取活跃对象是取的倒数第二个详情可以查看addObjectToSelected的实现
          instance?.addActiveToPre([img])
          instance?.addActiveToPre()
          // 多选状态下将新生成的元素添加到选中内
          instance?.addObjectToSelected(img)
        }
      })
    },
    changePictureScale(e, step) {
      if (step) {
        this.pictureScale = parseFloat((step + this.pictureScale).toFixed(2))
      }
      this.countOldTem()
      const current = this.currentItem
      current.set({
        mWidth: 19 * this.pictureScale,
        mHeight: 19 * this.pictureScale,
        defaultScale: this.pictureScale,
      })
      current.set({
        scaleX: mmToPx(19 * this.pictureScale, this.arrDPI) / current.width,
        scaleY: mmToPx(19 * this.pictureScale, this.arrDPI) / current.height,
      })
      if (current.auxiliaryEl) {
        current.auxiliaryEl.forEach((klass) => {
          klass.moveF(current)
        })
      }
      if (current.partEdgeElList) {
        current.partEdgeElList.forEach((klass) => {
          klass.moveF(current)
        })
      }
      this[this.mycanvasId].renderAll()
    },
    /**
     * 设置特殊标记符号的透明度和大小
     * @params {Number} value 滑动条的值
     * @params {String} type  觉得当前操作的时大小 or 透明度
     * @return
     * @author zhouchi 2024-07-16
     */
    changeOpacityOrScaleSize(value, type) {
      const current = this.currentItem
      if (type === 'scale') {
        current.set({
          scaleX: value,
          scaleY: value,
        })
      } else {
        current.set({
          opacity: value,
        })
      }
      this[this.mycanvasId].renderAll()
    },
    changeTriangleSizeSize(value) {
      const tempValue = Number(this.inputCheck(value))
      this.countOldTem()
      if (!tempValue) tempValue = 6
      this.triangleSize = tempValue
      let current = this.currentItem
      if (
        this.nowChooseSet == 'VisibleEdge' ||
        this.nowChooseSet == 'FrontEdge'
      ) {
        const triangleSize = this.triangleSize || 6
        const baseRect = current
          .getObjects()
          .find(
            (obj) =>
              obj.typeName === 'VisibleEdgeBase' ||
              obj.typeName === 'FrontEdgeBase'
          )
        const triangles = current
          .getObjects()
          .filter(
            (obj) =>
              obj.typeName === 'VisibleEdgeArrow' ||
              obj.typeName === 'FrontEdgeArrow'
          )
        // const newWidth = mmToPx(this.codeW, this.arrDPI)
        // const newHeight = mmToPx(this.codeH, this.arrDPI)
        const newWidth = this.codeW
        const newHeight = this.codeH
        current.set({
          scaleX: 1,
          scaleY: 1,
          triangleSize: triangleSize,
        })
        if (baseRect) {
          baseRect.set({
            width: newWidth,
            height: newHeight,
            triangleSize: triangleSize,
          })
        }

        triangles.forEach((tri) => {
          tri.set({ width: triangleSize, height: triangleSize })
          // 相对于baseRect左边缘和上边缘要考虑到边框1
          if (tri.position === 'left') {
            // 左箭头:
            tri.set({
              left: baseRect.left - triangleSize / 2 - 1,
              top: baseRect.top + newHeight / 2 + 0.5,
            })
          }
          if (tri.position === 'right') {
            // 右箭头：
            tri.set({
              left: baseRect.left + newWidth + triangleSize / 2 + 1 + 1,
              top: baseRect.top + newHeight / 2 + 0.5,
            })
          }
          if (tri.position === 'top') {
            // 上箭头：相对于baseRect中心
            tri.set({
              left: baseRect.left + newWidth / 2 + 0.5,
              top: baseRect.top - triangleSize / 2 - 1,
            })
          }
          if (tri.position === 'bottom') {
            // 下箭头：相对于baseRect中心
            tri.set({
              left: baseRect.left + newWidth / 2 + 1 - 0.5,
              top: baseRect.top + newHeight + triangleSize / 2 + 1 + 1,
            })
          }
        })

        current.addWithUpdate()
        current.setCoords()
        this[this.mycanvasId].renderAll()
      }
    },
    changeImgSize(type = 'w', value) {
      if (!value) {
        if (type == 'w') {
          this.codeW = 1
        } else {
          this.codeH = 1
        }
        value = 1
      }
      this.countOldTem()
      let current = this.currentItem
      let px = mmToPx(value, this.arrDPI)
      if (current) {
        if (this.nowChooseSet == 'QRcode') {
          this.codeW = value
          this.codeH = value
          current.set({
            mWidth: value,
            mHeight: value,
          })
          this.imgScaleX(current, mmToPx(value, this.arrDPI), current.width)
          this.imgScaleY(current, mmToPx(value, this.arrDPI), current.height)
        } else if (this.nowChooseSet == 'Onecode') {
          let img = current.item(0)
          switch (type) {
            case 'w':
              current.set({
                mWidth: value,
                width: mmToPx(value, this.arrDPI),
              })
              img.set({
                mWidth: value,
                width: mmToPx(value, this.arrDPI),
              })
              this.upDateImg(current, this.codeAtt, img, 'size')
              // this.imgScaleX(current,mmToPx(value,this.arrDPI), current.width)
              break
            case 'h':
              // this.imgScaleY(current,mmToPx(value,this.arrDPI), current.height)
              current.set({
                mHeight: value,
                height: mmToPx(value, this.arrDPI),
              })
              this.upDateImg(current, this.codeAtt, img, 'size')
              break
          }
          img.set({
            left: -mmToPx(this.codeW, this.arrDPI) / 2,
            top: -mmToPx(this.codeH, this.arrDPI) / 2,
          })
        } else if (this.nowChooseSet == 'EdgeBand') {
          switch (type) {
            case 'w':
              current.set({
                mWidth: value,
                width: mmToPx(value, this.arrDPI),
              })
              this.imgScaleX(current, mmToPx(value, this.arrDPI), current.width)
              break
            case 'h':
              current.set({
                mHeight: value,
                height: mmToPx(value, this.arrDPI),
              })
              this.imgScaleY(
                current,
                mmToPx(value, this.arrDPI),
                current.height
              )
              break
          }
        } else if (
          this.nowChooseSet == 'VisibleEdge' ||
          this.nowChooseSet == 'FrontEdge'
        ) {
          const triangleSize = this.triangleSize || 6
          current.set({
            scaleX: 1,
            scaleY: 1,
            triangleSize: this.triangleSize,
          })

          const baseRect = current
            .getObjects()
            .find(
              (obj) =>
                obj.typeName === 'VisibleEdgeBase' ||
                obj.typeName === 'FrontEdgeBase'
            )
          const triangles = current
            .getObjects()
            .filter(
              (obj) =>
                obj.typeName === 'VisibleEdgeArrow' ||
                obj.typeName === 'FrontEdgeArrow'
            )

          if (type === 'w') {
            // const newWidth = mmToPx(value, this.arrDPI)
            const newWidth = value
            if (baseRect) {
              baseRect.set({
                width: newWidth,
                height: this.codeH,
                scaleX: 1,
              })
            }

            triangles.forEach((tri) => {
              // 相对于baseRect左边缘 间距1 边框1
              tri.set({
                width: triangleSize,
                height: triangleSize,
              })
              if (tri.position === 'left') {
                // 左箭头：
                tri.set({
                  left: baseRect.left - triangleSize / 2 - 1,
                  top: baseRect.top + this.codeH / 2,
                })
              }
              if (tri.position === 'right') {
                // 右箭头：
                tri.set({
                  left: baseRect.left + newWidth + triangleSize / 2 + 1 + 1,
                  top: baseRect.top + this.codeH / 2,
                })
              }
              if (tri.position === 'top') {
                // 上箭头：
                tri.set({
                  left: baseRect.left + newWidth / 2,
                  top: baseRect.top - triangleSize / 2 - 1,
                })
              }
              if (tri.position === 'bottom') {
                // 下箭头：
                tri.set({
                  left: baseRect.left + newWidth / 2,
                  top: baseRect.top + this.codeH + triangleSize / 2 + 1 + 1,
                })
              }
            })
          }
          if (type === 'h') {
            // const newHeight = mmToPx(value, this.arrDPI)
            const newHeight = value
            if (baseRect) {
              baseRect.set({
                height: newHeight,
                width: this.codeW,
                scaleY: 1,
              })
            }
            triangles.forEach((tri) => {
              tri.set({
                width: triangleSize,
                height: triangleSize,
              })
              if (tri.position === 'top') {
                // 上箭头：相对于baseRect上边缘 间距1
                tri.set({
                  top: baseRect.top - triangleSize / 2 - 1,
                  left: baseRect.left + this.codeW / 2,
                })
              }
              if (tri.position === 'bottom') {
                // 下箭头：相对于baseRect下边缘 边框宽1 间距1
                tri.set({
                  top: baseRect.top + newHeight + triangleSize / 2 + 1 + 1,
                  left: baseRect.left + this.codeW / 2,
                })
              }
              if (tri.position === 'right') {
                // 右箭头：相对于baseRect中心
                tri.set({
                  top: baseRect.top + newHeight / 2,
                  left: baseRect.left + this.codeW + triangleSize / 2 + 1 + 1,
                })
              }
              if (tri.position === 'left') {
                // 左箭头：相对于baseRect中心
                tri.set({
                  top: baseRect.top + newHeight / 2,
                  left: baseRect.left - triangleSize / 2 - 1,
                })
              }
            })
          }

          // 让group刷新
          current.addWithUpdate()
          current.setCoords()
        } else {
          switch (type) {
            case 'w':
              current.set({
                mWidth: value,
              })
              this.imgScaleX(current, mmToPx(value, this.arrDPI), current.width)
              break
            case 'h':
              this.imgScaleY(
                current,
                mmToPx(value, this.arrDPI),
                current.height
              )
              current.set({
                mHeight: value,
              })
              break
          }
        }
      }

      this[this.mycanvasId].renderAll()
    },
    setItemId(item) {
      this.currentItem = item
      if (item.item_id) return
      item.set({ item_id: nanoid() })
      // this.item_id += 1
    },
    resetData(type) {
      // 画不同组件数据重置不同
      switch (type) {
        case 'Typography':
          this.codeW = 15
          this.codeH = 25
          this.showEdgeOff = false
          this.showEdgeDisplay = false
          this.showOpenDoor = true
          this.plankRotate = false
          this.showFrontEdge = true
          this.showVisibleEdge = true
          this.isShowDiffEdgeColor = false
          this.hideSameEdgeColorAsPlank = false
          break
        case 'Onecode':
          this.codeW = 35
          this.codeH = 10
          this.nowCodeInfo =
            this.labelTemplates == 'plank' ? 'plankNum' : 'oriPlankNum'
          break
        case 'QRcode':
          this.codeW = 10
          this.codeH = 10
          this.nowCodeInfo =
            this.labelTemplates == 'plank' ? 'ggid' : 'restockingCode'
          this.QRCodeFormat = 'QRCode'
          break
        case 'DataSource':
          this.nowDataInfo = ''
          break
        case 'Graphics':
          this.codeW = 10
          this.codeH = 10
          this.GraColor = '#000000'
          this.angle = 0
          break
        case 'wardrobeNum':
          this.nowDiameter = 4
          this.partSignValue = 'wardrobeNum'
          this.smallPlateW = 30
          this.smallPlateH = 18
          break
        case 'smallPlateMarking':
          this.partSignValue = 'smallPlateMarking'
          this.smallPlateW = 30
          this.smallPlateH = 18
          break
        case 'holeSlotPicture':
          this.codeW = 19
          this.codeH = 19
          this.pictureScale = 1
          break
        case 'sideMachiningSequenceDiagram':
          this.codeW = 20
          this.codeH = 20
          break
        case 'Marking':
          this.nowDiameter = 10
          break
        case 'SurplusSize':
          this.codeW = 12
          this.codeH = 15
          break
        case 'EdgeBand':
          this.codeW = 5
          this.codeH = 5
          this.stroke = '#000000'
          break
        case 'VisibleEdge':
          this.codeW = 68
          this.codeH = 68
          this.triangleSize = 6
          break
        case 'FrontEdge':
          this.codeW = 68
          this.codeH = 68
          this.triangleSize = 6
          break
        case 'sixSideDrillArrow':
          this.sixSideDrillArrowSize = 50
          break
        default:
          break
      }
      this.splitByGrapheme = false
      this.textAlign = 'left'
      this.fontWeight = type !== 'Marking' ? false : true
      this.nowFontSize = type == 'Marking' ? 10 : 8
      this.lineSpace = 1
      this.lineCount = ''
      this.nowFontFamily = '微软雅黑'
    },
    imgScaleX(img, imgW, oImgW) {
      let scaleX = imgW / oImgW
      img.set({
        scaleX: scaleX,
      })
    },
    imgScaleY(img, imgH, oImgH) {
      let scaleY = imgH / oImgH
      img.set({
        scaleY: scaleY,
      })
    },
    draw(data = null, update = false, canvasId) {
      if (!canvasId) {
        canvasId = 'mycanvas_tag'
      }
      this.mycanvasId = canvasId
      // 如果canvasId的值不存在，表示是从mounted进入的，此时需要
      // 绘制的时候当前需要绘制的对象
      let parentDIV = document.getElementsByClassName('edit_tagTem_mid')[0]
      let width = parentDIV.clientWidth
      let height = parentDIV.clientHeight
      // 判断当前是添加一个模板还是更新一个模板
      if (!update) {
        let mycanvas = new fabric.Canvas(canvasId, {
          width: width,
          height: height,
          selections: false,
          // 允许右键点击(如不开启则在点击时无法判断到底是右键还是左键)
          fireRightClick: true,
        })
        this[canvasId] = mycanvas
        // 没实现出现在顶层
        this[canvasId].preserveObjectStacking = false // 选择画布中的对象时，该对象出现在顶层
        // 创建事件监听
        this.addFabricCanvasListener()
      }
      if (data) {
        this.tagSizeWPx = mmToPx(this.tagSizeWmm, this.arrDPI)
        this.tagSizeHPx = mmToPx(this.tagSizeHmm, this.arrDPI)
        // 标签框 整个标签
        let rect = new fabric.Rect({
          width: this.tagSizeWPx,
          height: this.tagSizeHPx,
          fill: '#fff',
          top: this.rectData.top,
          left: this.rectData.left,
          typeName: 'TageBox',
          selectable: false,
        })
        rect.hasControls = false // 只能移动不能（编辑）操作
        this[canvasId].add(rect)
      } else {
        this.tagSizeWPx = mmToPx(this.tagSizeWmm, this.arrDPI)
        this.tagSizeHPx = mmToPx(this.tagSizeHmm, this.arrDPI)
        // 标签框
        let rect = new fabric.Rect({
          width: this.tagSizeWPx,
          height: this.tagSizeHPx,
          fill: '#fff',
          top: (height - this.tagSizeHPx) / 2,
          left: (width - this.tagSizeWPx) / 2,
          typeName: 'TageBox',
          selectable: false,
        })
        rect.hasControls = false
        this[canvasId].add(rect)
      }
      this.drawItemTem(data, true, canvasId)
      if (!update) {
        // 移动画布位置
        this.moveFabricCanvasToCenter()
      }
    },
    // init canvas
    drawItemTem(data, checkOne = false, canvasId) {
      data.forEach((item, index) => {
        let drawD = item.data
        switch (item.type) {
          case 'holeSlotPicture':
            this.drawHoleSlotPictureByTemp(drawD, item, canvasId, data)
            break
          case 'sideMachiningSequenceDiagram':
            this.drawSideMachiningSequenceDiagram(drawD, item, canvasId, data)
            break
          case 'FixedText':
            // eslint-disable-next-line no-case-declarations
            let iText = new fabric.Textbox(translateTemplateWay(drawD.text), {
              fontPt: drawD.fontPt,
              fontSize: drawD.fontSize,
              fontWeight: drawD.fontWeight,
              lineHeight: drawD.lineHeight,
              top: drawD.top,
              left: drawD.left,
              typeName: item.type,
              item_id: drawD.item_id,
              hasControls: true,
              opacity: drawD.opacity ?? 1,
              lockScalingY: false,
              lockRotation: true,
              lockScalingFlip: false,
              splitByGrapheme: drawD.splitByGrapheme
                ? drawD.splitByGrapheme
                : false,
              objectCaching: false,
              textAlign: drawD.textAlign ? drawD.textAlign : 'left',
              fontFamily: drawD.fontFamily ?? '微软雅黑',
              language: this.$store.state.exportLanguage || 'zh', // 标签导出语言
            })
            this.setControlVisible(iText, false, 'mtr')
            // 兼容老数据
            if (drawD.width && drawD.height) {
              iText.set({
                width: drawD.width,
                height: drawD.height,
              })
            }
            this[canvasId].add(iText)
            break
          case 'DataSource':
            // 字段用错了
            if (drawD.source_data == 'edgeInfo') {
              drawD.source_data = 'sholeInfo'
            }
            if (drawD.source_data == 'name') {
              drawD.source_data = 'partName'
            }
            // 不对板件标注的框体进行绘制，后续统一绘制
            if (item.data.source_data == 'plankSignBox') {
              break
            }

            // eslint-disable-next-line no-case-declarations
            let textC = new fabric.Text(drawD.text, {
              fontSize: drawD.fontSize,
            })
            // eslint-disable-next-line no-case-declarations
            const { text, fontSize } = dealTextStr(
              drawD.text,
              drawD.fontSize,
              drawD.rectWidth ?? textC.width,
              drawD.rectHeight ?? textC.height,
              drawD.isAutoFontSize,
              drawD.lineCount ?? ''
            )
            // eslint-disable-next-line no-case-declarations
            let Text = new fabric.Text(translateTemplateWay(text), {
              fontPt: drawD.fontPt,
              fontSize: fontSize,
              fontWeight: drawD.fontWeight,
              lineHeight: drawD.lineHeight,
              top: drawD.top,
              left: drawD.left,
              width: drawD.width,
              height: drawD.height,
              rectHeight: drawD.rectHeight ?? 11.3,
              rectWidth: drawD.rectWidth ?? 80,
              maxWidth: drawD.width,
              isSymmetricSwapping: true,
              textWrap: 'word',
              hasControls: false,
              opacity: drawD.opacity ?? 1,
              typeName: item.type,
              item_id: drawD.item_id,
              source_data: drawD.source_data,
              textBackgroundColor: drawD.textBackgroundColor,
              sizeRestrict: drawD.sizeRestrict ? drawD.sizeRestrict : undefined,
              sizeRestrictNum: drawD.sizeRestrictNum ?? 2,
              isAutoFontSize: drawD.isAutoFontSize ?? true,
              fontFamily: drawD.fontFamily ?? '微软雅黑',
              // 统计维度默认值为不限
              statisticsDimension: drawD.statisticsDimension ?? 'noLimit',
              lineCount: drawD.lineCount ?? '',
              oriText: drawD.oriText || text,
            })
            Text.setControlVisible('mtr', false)
            // 保存所有的板件标注
            if (drawD.source_data == 'plankSign') {
              this.plankSignBox.push(Text)
            }
            this.nowFontSize = fontSize
            this.inputAlert.fontSizeAlert = ''
            this[canvasId].add(Text)
            break
          case 'Graphics':
            // eslint-disable-next-line no-case-declarations
            let Graphics = new fabric.Polygon(drawD.points, {
              top: drawD.top,
              left: drawD.left,
              hasControls: drawD.hasControls,
              typeName: item.type,
              item_id: drawD.item_id,
              angle: drawD.angle,
              fill: drawD.fill,
              originX: 'center',
              originY: 'center',
              mWidth: drawD.mWidth,
              mHeight: drawD.mHeight,
              scaleX: drawD.scaleX,
              scaleY: drawD.scaleY,
            })
            Graphics.setControlVisible('mtr', false)
            this[canvasId].add(Graphics)
            break
          case 'QRcode':
            fabric.Image.fromURL(
              require('../../assets/tag_tem_test.png'),
              (img) => {
                img.set({
                  top: drawD.top,
                  left: drawD.left,
                  hasControls: true,
                  typeName: item.type,
                  item_id: drawD.item_id,
                  width: drawD.width,
                  height: drawD.height,
                  source_data: drawD.source_data,
                  mWidth: drawD.mWidth,
                  mHeight: drawD.mHeight,
                  scaleX: drawD.scaleX,
                  scaleY: drawD.scaleY,
                  showCode: drawD.showCode,
                  isQRcodeNCSuffix: drawD.isQRcodeNCSuffix ?? true,
                  QRCodeFormat: drawD.QRCodeFormat ?? 'QRCode',
                })
                this.setControlVisible(
                  img,
                  false,
                  'mtr',
                  'ml',
                  'mr',
                  'mt',
                  'mb'
                )
                this[canvasId].add(img)
              }
            )
            break
          case 'Onecode':
            // eslint-disable-next-line no-case-declarations
            let option = {
              source_data: drawD.source_data,
              codeType: drawD.code_type,
              fontWeight: drawD.fontWeight,
              fontPt: drawD.fontPt,
              lineHeight: drawD.lineHeight,
              scaleX: drawD.Xscale ?? 1,
              scaleY: drawD.Yscale ?? 1,
              fontFamily: drawD.fontFamily ?? '微软雅黑',
            }
            // eslint-disable-next-line no-case-declarations
            let url = this.createDefaultUrl(option)
            fabric.Image.fromURL(url, (img) => {
              img.set({
                source_data: drawD.source_data,
                code_type: drawD.code_type,
                fontPt: drawD.fontPt,
                fontSize: drawD.fontSize,
                lineHeight: drawD.lineHeight,
                fontWeight: drawD.fontWeight,
                fontFamily: drawD.fontFamily ?? '微软雅黑',
                // width: mmToPx(drawD.mWidth, this.arrDPI),
                // height: mmToPx(drawD.mHeight, this.arrDPI),
              })
              img.scaleToWidth(drawD.width * (drawD.Xscale ?? 1))
              img.scaleToHeight(drawD.height * (drawD.Yscale ?? 1))
              // let textValue = drawD.source_data == 'plankNum'?'6160479583801':'6160479583801K'
              // let oText = new fabric.Text(textValue,{
              //     top:25,
              //     fontPt:drawD.fontPt,
              //     fontSize:drawD.fontSize,
              //     lineHeight:drawD.lineHeight,
              //     fontWeight:drawD.fontWeight,
              // })
              let group = new fabric.Group([img], {
                typeName: item.type,
                hasControls: true,
                top: drawD.top,
                left: drawD.left,
                width: drawD.width * (drawD.Xscale ?? 1),
                height: drawD.height * (drawD.Yscale ?? 1),
                mWidth: drawD.mWidth,
                mHeight: drawD.mHeight,
                item_id: drawD.item_id,
                showCode: drawD.showCode,
                switchCodeValueShunt: drawD.switchCodeValueShunt ?? false,
                Xscale: drawD.Xscale,
                Yscale: drawD.Yscale,
                rotateDeg: drawD.rotateDeg,
                isOnecodeNCSuffix: drawD.isOnecodeNCSuffix ?? true,
              })
              this[canvasId].add(group)
              this[canvasId].bringToFront(group)
              group.set({
                Xscale: 1,
                Yscale: 1,
              })
              group.setControlVisible('mtr', false)
              group.setControlVisible('ml', false)
              group.setControlVisible('mr', false)
              if (drawD.rotateDeg) {
                this.codeRotateDeg = drawD.rotateDeg
                group.rotate(drawD.rotateDeg)
              }
            })
            break
          case 'SurplusSize':
          case 'Typography':
            this.drawTypographyByTemp(drawD, item, canvasId)
            break
          case 'wardrobeNum':
            this.drawWardrobeNumByTemp(drawD, item)
            break
          case 'specialMark':
            drawD.typeName = item.type
            this.selectSpecialMark(drawD, 'init', canvasId)
            //删除 typeName 元素

            delete drawD.typeName
            break
          case 'sixSideDrillArrow':
            this.sixSideDrillArrowSize = Math.ceil(drawD.width * drawD.scaleX)
            this.drawSixSideDrillArrow({ left: drawD.left, top: drawD.top })
            break
          case 'sixSideDrillTriangle':
            this.drawSixSideDrillTriangle({ left: drawD.left, top: drawD.top })
            break
          case 'smallPlateMarking':
            // 还原小板标记属性
            this.smallPlateW = drawD.width || 30
            this.smallPlateH = drawD.height || 18
            this.nowFontSize = drawD.fontPt || 8
            this.nowFontFamily = drawD.fontFamily || '微软雅黑'
            this.fontWeight = drawD.fontWeight === 'bold'
            this.drawSmallPlateMarking({ left: drawD.left, top: drawD.top })
            return
          case 'Table':
            const tableUrl = fabricTable(
              this[canvasId],
              true,
              false,
              drawD.fontSize * 2,
              'extraParts',
              10,
              10,
              drawD.fontFamily ?? '微软雅黑'
            )
            fabric.Image.fromURL(tableUrl, (img) => {
              img.set({
                top: drawD.top,
                left: drawD.left,
                fontPt: drawD.fontPt,
                fontSize: drawD.fontSize,
                hasControls: false,
                source_data: drawD.source_data,
                typeName: 'Table',
                mWidth: drawD.mWidth,
                mHeight: drawD.mHeight,
                // pxWidth: mmToPx(this.codeW, this.arrDPI),
                // pxHeight: mmToPx(this.codeH, this.arrDPI),
                showCode: true,
                scaleX: drawD.scaleX,
                scaleY: drawD.scaleY,
                fontFamily: drawD.fontFamily ?? '微软雅黑',
              })
              this.setItemId(img)
              this[canvasId].add(img)
            })
            break
          case 'Marking':
            // 绘制余料标识
            const circle = this.drawCircle(drawD.radius, drawD.mRadius, {
              top: drawD.top,
              left: drawD.left,
              visible: Boolean(drawD.realRadius ?? drawD.mRadius),
            })
            const surplusText = this.drawText(
              '余',
              drawD.top,
              drawD.left,
              drawD.fontSize,
              drawD.fontPt,
              drawD.fontWeight,
              {
                fontFamily: drawD.fontFamily ?? '微软雅黑',
              }
            )
            let group = new fabric.Group([circle, surplusText], {
              left: drawD.left,
              top: drawD.top,
              typeName: item.type,
              hasControls: false,
            })
            this.setItemId(group)
            this[this.mycanvasId].add(group)
            break
          case 'EdgeBand':
            const scale = Math.max(drawD.scaleX, drawD.scaleY)
            const top = drawD.top
            const left = drawD.left
            const width = drawD.width || mmToPx(drawD.mWidth, this.arrDPI) //drawD.mWidth || drawD.width
            const height = drawD.height || mmToPx(drawD.mWidth, this.arrDPI) //drawD.mHeight || drawD.height
            const size = Math.max(width, height) // 边框的尺寸 目前不考虑过多 就取最大的值
            const strokeWidth = drawD.strokeWidth || 2

            let square = new fabric.Rect({
              top,
              left,
              width,
              height,
              fill: 'rgba(0,0,0,0)',
              stroke: drawD.stroke || '#000000',
              strokeWidth,
              selectable: true,
              typeName: 'EdgeBand',
              originX: 'left',
              originY: 'top',
              // scaleX: drawD.scaleX,
              // scaleY: drawD.scaleY,
            })
            this[canvasId].add(square)
            break
          case 'VisibleEdge':
            // 绘制见光边标识
            const drawDtop = drawD.top
            const drawDleft = drawD.left
            const triangleSize = drawD.triangleSize * drawD.scaleX || 6 // 三角形大小
            //  纵横方向分别减去 箭头的高度 * 2 - 间距* 2 - 边框* 2 这样换算下来才是对的
            const drawDwidth = drawD.width * drawD.scaleX - triangleSize * 2 - 4
            const drawDheight =
              drawD.height * drawD.scaleY - triangleSize * 2 - 4
            this.visibleEdgeOrFrontEdgeStyle =
              drawD.visibleEdgeOrFrontEdgeStyle || 'triangle'
            const baseRect = new fabric.Rect({
              left: 0,
              top: 0,
              width: drawDwidth,
              height: drawDheight,
              fill: 'rgba(0,0,0,0)',
              stroke: 'rgba(0,0,0,.2)',
              strokeWidth: 1,
              selectable: false,
              evented: false,
              opacity: 1,
              typeName: 'VisibleEdgeBase',
            })
            // 创建基础三角形（向上）
            const topTriangle =
              this.visibleEdgeOrFrontEdgeStyle === 'triangle'
                ? new fabric.Triangle({
                    left: drawDwidth / 2 + 0.5,
                    top: -triangleSize / 2 - 1,
                    width: triangleSize,
                    height: triangleSize,
                    fill: '#000000',
                    selectable: false,
                    typeName: 'VisibleEdgeArrow',
                    hasControls: false,
                    originX: 'center',
                    originY: 'center',
                    position: 'top',
                  })
                : new fabric.Rect({
                    left: drawDwidth / 2 + 0.5,
                    top: -triangleSize / 2 - 1,
                    width: triangleSize,
                    height: triangleSize,
                    fill: '#000000',
                    selectable: false,
                    typeName: 'VisibleEdgeArrow',
                    hasControls: false,
                    originX: 'center',
                    originY: 'center',
                    position: 'top',
                  })

            // 通过克隆和旋转生成其他方向的三角形
            const bottomTriangle = fabric.util.object.clone(topTriangle)
            bottomTriangle.set({
              top: drawDheight + triangleSize / 2 + 1 + 1,
              angle: 180,
              position: 'bottom',
            })
            const leftTriangle = fabric.util.object.clone(topTriangle)
            leftTriangle.set({
              left: -triangleSize / 2 - 1,
              top: drawDheight / 2,
              angle: -90,
              position: 'left',
            })
            const rightTriangle = fabric.util.object.clone(topTriangle)
            rightTriangle.set({
              left: drawDwidth + triangleSize / 2 + 1 + 1,
              top: drawDheight / 2,
              angle: 90,
              position: 'right',
            })
            const visibleEdge = new fabric.Group(
              [
                baseRect,
                topTriangle,
                bottomTriangle,
                leftTriangle,
                rightTriangle,
              ],
              {
                left: drawDleft,
                top: drawDtop,
                selectable: true,
                hasControls: true,
                typeName: 'VisibleEdge',
                triangleSize: triangleSize,
                originX: 'left',
                originY: 'top',
                visibleEdgeOrFrontEdgeStyle: this.visibleEdgeOrFrontEdgeStyle,
              }
            )
            const arr = ['mtr', 'ml', 'mr', 'mt', 'mb']
            arr.forEach((item) => {
              visibleEdge.setControlVisible(item, false)
            })
            this[canvasId].add(visibleEdge)
            // 设置元素ID
            this.setItemId(visibleEdge)
            break
          case 'FrontEdge':
            if (!drawD) {
              break
            }
            const frontEdgeTop = drawD.top
            const frontEdgeLeft = drawD.left
            const frontEdgeTriangleSize = drawD.triangleSize * drawD.scaleX || 6 // 三角形大小
            //  纵横方向分别减去 箭头的高度 * 2 - 间距* 2 - 边框* 2 这样换算下来才是对的
            const frontEdgeWidth =
              drawD.width * drawD.scaleX - frontEdgeTriangleSize * 2 - 4
            const frontEdgeHeight =
              drawD.height * drawD.scaleY - frontEdgeTriangleSize * 2 - 4
            this.visibleEdgeOrFrontEdgeStyle =
              drawD.visibleEdgeOrFrontEdgeStyle || 'triangle'
            const frontEdgeBaseRect = new fabric.Rect({
              left: 0,
              top: 0,
              width: frontEdgeWidth,
              height: frontEdgeHeight,
              fill: 'rgba(0,0,0,0)',
              stroke: 'rgba(0,0,0,.2)',
              strokeWidth: 1,
              selectable: false,
              evented: false,
              opacity: 1,
              typeName: 'FrontEdgeBase',
            })
            // 创建基础三角形（向上）
            const frontEdgeTopTriangle =
              this.visibleEdgeOrFrontEdgeStyle === 'triangle'
                ? new fabric.Triangle({
                    left: frontEdgeWidth / 2 + 0.5,
                    top: -frontEdgeTriangleSize / 2 - 1,
                    width: frontEdgeTriangleSize,
                    height: frontEdgeTriangleSize,
                    fill: '#000000',
                    selectable: false,
                    typeName: 'FrontEdgeArrow',
                    hasControls: false,
                    originX: 'center',
                    originY: 'center',
                    position: 'top',
                  })
                : new fabric.Rect({
                    left: frontEdgeWidth / 2 + 0.5,
                    top: -frontEdgeTriangleSize / 2 - 1,
                    width: frontEdgeTriangleSize,
                    height: frontEdgeTriangleSize,
                    fill: '#000000',
                    selectable: false,
                    typeName: 'FrontEdgeArrow',
                    hasControls: false,
                    originX: 'center',
                    originY: 'center',
                    position: 'top',
                  })

            // 通过克隆和旋转生成其他方向的三角形
            const frontEdgeBottomTriangle =
              fabric.util.object.clone(frontEdgeTopTriangle)
            frontEdgeBottomTriangle.set({
              top: frontEdgeHeight + frontEdgeTriangleSize / 2 + 1 + 1,
              angle: 180,
              position: 'bottom',
            })
            const frontEdgeLeftTriangle =
              fabric.util.object.clone(frontEdgeTopTriangle)
            frontEdgeLeftTriangle.set({
              left: -frontEdgeTriangleSize / 2 - 1,
              top: frontEdgeHeight / 2,
              angle: -90,
              position: 'left',
            })
            const frontEdgeRightTriangle =
              fabric.util.object.clone(frontEdgeTopTriangle)
            frontEdgeRightTriangle.set({
              left: frontEdgeWidth + frontEdgeTriangleSize / 2 + 1 + 1,
              top: frontEdgeHeight / 2,
              angle: 90,
              position: 'right',
            })
            const frontEdge = new fabric.Group(
              [
                frontEdgeBaseRect,
                frontEdgeTopTriangle,
                frontEdgeBottomTriangle,
                frontEdgeLeftTriangle,
                frontEdgeRightTriangle,
              ],
              {
                left: frontEdgeLeft,
                top: frontEdgeTop,
                selectable: true,
                hasControls: true,
                typeName: 'FrontEdge',
                triangleSize: frontEdgeTriangleSize,
                originX: 'left',
                originY: 'top',
                visibleEdgeOrFrontEdgeStyle: this.visibleEdgeOrFrontEdgeStyle,
              }
            )
            const frontEdgeControlArr = ['mtr', 'ml', 'mr', 'mt', 'mb']
            frontEdgeControlArr.forEach((item) => {
              frontEdge.setControlVisible(item, false)
            })
            this[canvasId].add(frontEdge)
            // 设置元素ID
            this.setItemId(frontEdge)

            break
        }
      })
      // 绘制板件标注
      this.drawAllSignRect()
      // 初始化时默认选中第一个绘制的元素
      if (checkOne) {
        let klass = this[canvasId].getObjects()
        if (klass.length > 1) {
          this[canvasId].setActiveObject(klass[1])
          this.currentItem = klass[1]
          if (this.currentItem && this.currentItem.typeName === 'DataSource') {
            this.isAutoFontSize = this.currentItem.isAutoFontSize ?? true
            this.lineCount = this.currentItem.lineCount ?? ''
          }
          this.dataSourceWidth = this.currentItem.rectWidth
            ? Number(this.currentItem.rectWidth).toFixed(2)
            : 100
          this.dataSourceHeight = this.currentItem.rectHeight
            ? Number(this.currentItem.rectHeight).toFixed(2)
            : 20
          if (klass[1].typeName === 'DataSource') {
            this.genControlRect(klass[1])
          }
          this.itemOpacity = this.currentItem.opacity ?? 1
          this.getKclassValueToAttr(klass[1])
        }
      }
    },
    drawTypographyByTemp(drawD, item, canvasId) {
      let imgUrl =
        item.type == 'Typography' ? paibanTestImage : surplusPlankImage
      return new Promise((resolve, reject) => {
        fabric.Image.fromURL(imgUrl, (img) => {
          let mWidth = item.type == 'Typography' ? 15 : 12
          let mHeight = item.type == 'Typography' ? 25 : 15
          img.set({
            left: drawD.imgItem.left,
            top: drawD.imgItem.top,
            mWidth: mWidth,
            mHeight: mHeight,
          })
          this.imgScaleY(img, mmToPx(mHeight, this.arrDPI) - 10, img.height)
          this.imgScaleX(img, mmToPx(mWidth, this.arrDPI) - 10, img.width)
          let textItems = []
          let surplusSizeInfo = {
            RE: 977,
            BE: 762,
          }
          let textS = ''
          drawD.textItems.forEach((e) => {
            if (
              item.type == 'SurplusSize' &&
              canvasId == 'mycanvas_surplus_cut'
            ) {
              textS = surplusSizeInfo[e.positionName] ?? ''
            }
            let text = new fabric.Text(
              canvasId == 'mycanvas_tag' ? '0.5' : String(textS),
              {
                positionName: e.positionName,
                fontSize: e.fontSize,
                fontPt: e.fontPt,
                fontWeight: e.fontWeight,
                fontFamily: e.fontFamily ?? '微软雅黑',
              }
            )
            text.set({
              top: e.top,
              left: e.left,
              oTop: e.top,
              oLeft: e.left,
            })
            textItems.push(text)
          })
          // 根据板件封边信息位置重新绘制新的开门方向
          let openL = textItems[2]?.left ?? 0
          let openT = textItems[2]?.top ?? 0
          const offsetLeft = (textItems[2]?.width ?? 0) + 6
          const offsetTop = (textItems[2]?.height ?? 0) / 2
          let circle
          if (item.type == 'Typography') {
            circle = this.drawCircle(6, 6, {
              left: openL + offsetLeft,
              top: openT + offsetTop,
              uniqueID: 'showDoor',
              opacity: Number(drawD.showOpenDoor ?? true),
            })
          }
          const text = this.drawText(
            canvasId == 'mycanvas_tag' ? '开' : '',
            openT + offsetTop,
            openL + offsetLeft,
            8,
            12,
            '',
            {
              uniqueID: 'showDoor',
              opacity: Number(drawD.showOpenDoor ?? true),
            }
          )
          let Group = new fabric.Group(
            canvasId == 'mycanvas_tag'
              ? [img].concat(textItems, circle, text)
              : [img].concat(textItems, text),
            {
              typeName: item.type,
              showEdgeOff: drawD.showEdgeOff ?? false,
              showEdgeDisplay: drawD.showEdgeDisplay ?? false,
              showOpenDoor: drawD.showOpenDoor ?? true,
              plankRotate: drawD.plankRotate ?? false,
              showFrontEdge: drawD.showFrontEdge ?? true,
              showVisibleEdge: drawD.showVisibleEdge ?? true,
              isShowDiffEdgeColor: drawD.isShowDiffEdgeColor ?? false,
              hideSameEdgeColorAsPlank: drawD.hideSameEdgeColorAsPlank ?? false,
              ...drawD,
              hasControls: true,
            }
          )

          if (drawD.rotateDeg || drawD.rotateDeg == 0) {
            Group.rotate(drawD.rotateDeg)
            this.rotateDeg = drawD.rotateDeg
          } else {
            if (drawD.plankRotate) {
              Group.rotate(-90)
              this.rotateDeg = 270
            } else {
              this.rotateDeg = 0
            }
          }
          // this.imgScaleX(Group, mmToPx(mWidth, this.arrDPI), Group.width)
          // this.imgScaleY(Group, mmToPx(mHeight, this.arrDPI), Group.height)
          this.setControlVisible(Group, false, 'mtr')
          this[canvasId].add(Group)
          resolve(Group)
        })
      })
    },
    drawHoleSlotPictureByTemp(drawD, item, canvasId, data) {
      // eslint-disable-next-line no-case-declarations
      const uniqueID = item.data.uniqueID
      // eslint-disable-next-line no-case-declarations
      const auxiliaryEl = data.filter((item) => {
        const d = item.data
        return d?.uniqueID == uniqueID && item.type == 'holeSlotPicture-size'
      })

      // 封边文字绘制
      const partEdgeElList = data.filter((item) => {
        const d = item.data
        return d?.uniqueID == uniqueID && item.type == 'holeSlotPicture-edge'
      })
      if (!auxiliaryEl) return
      return new Promise((resolve, reject) => {
        fabric.Image.fromURL(
          // eslint-disable-next-line @typescript-eslint/no-var-requires
          require('../../assets/hole_slot.png'),
          (img) => {
            img.set({
              typeName: item.type,
              ...drawD,
              hasControls: true,
            })

            const auxiliaryS = []
            const partEdgeS = []
            /** 全部的额外信息绘制 */
            const allNextLevelArr = [...auxiliaryEl, ...partEdgeElList]
            allNextLevelArr.forEach((item) => {
              const draw = item.data
              const type = item.type
              const text = new fabric.Text(draw.text, {
                typeName: type,
                ...draw,
                fontFamily: draw.fontFamily ?? '微软雅黑',
              })
              text.set({
                opacity: Number(draw.isShow),
              })
              // 注入方法
              if (type.includes('size')) {
                this.klassSetMethods(text, { show: 'plankSize' })
                auxiliaryS.push(text)
              } else {
                this.klassSetMethods(text, { show: 'partEdge' })
                partEdgeS.push(text)
              }
              this[canvasId].add(text)
            })
            const edgeDraws = this.dealPartEdgeDraws(
              drawD.left,
              drawD.top,
              drawD.mWidth,
              drawD.mHeight,
              drawD.uniqueID
            )

            img.set({
              auxiliaryEl: auxiliaryS,
              partEdgeElList: partEdgeS.length ? partEdgeS : edgeDraws,
            })
            this.setControlVisible(img, false, 'mtr')
            this[canvasId].add(img)
            resolve(img)
          }
        )
      })
    },
    // 绘制加工顺序图
    drawSideMachiningSequenceDiagram(drawD, item, canvasId, data) {
      this.isShowSideMachiningSequenceNumber =
        drawD.showSideMachiningSequenceNumber
      this.isShowSideMachiningSequenceDiagramBorder =
        drawD.showSideMachiningSequenceDiagramBorder
      this.isFlipOverProcessing = drawD.flipOverProcessing
      const numberFontPt = Number(drawD.fontPt) || 8
      this.nowFontSize = numberFontPt
      const drawDtop = drawD.top + 7.5
      const drawDleft = drawD.left + 7.5
      const scaleX = Number(drawD.scaleX) || 1
      const scaleY = Number(drawD.scaleY) || 1
      // 内框只跟 mm 走，禁止用 Group 整框 width 反推（字号/孔槽会让它越存越大）
      const innerMmW = Number(drawD.mWidth) || 20
      const innerMmH = Number(drawD.mHeight) || 20
      const codeWidth = Math.round(mmToPx(innerMmW, this.arrDPI))
      const codeHeight = Math.round(mmToPx(innerMmH, this.arrDPI))
      // 矩形在 Group 中的位置应该是 (0, 0)，而不是绝对坐标
      const sideMachiningSequenceDiagramBaseRect = new fabric.Rect({
        top: 0,
        left: 0,
        width: codeWidth,
        height: codeHeight,
        fill: 'rgba(0,0,0,0)',
        stroke: 'rgba(0,0,0,.2)',
        strokeWidth: 1,
        selectable: false,
        evented: false,
        opacity: 1,
        typeName: 'sideMachiningSequenceDiagramBaseRect',
      })
      // 添加边框显隐控制方法
      sideMachiningSequenceDiagramBaseRect.borderShowF = function (isShow) {
        this.set({
          opacity: isShow ? 1 : 0,
        })
      }
      sideMachiningSequenceDiagramBaseRect.borderShowF(
        this.isShowSideMachiningSequenceDiagramBorder
      )

      // 绘制孔图片
      const loadHoleImage = () => {
        return new Promise((resolve) => {
          fabric.Image.fromURL(require('../../assets/hole.png'), (img) => {
            resolve(img)
          })
        })
      }
      // 绘制侧槽图片
      const loadSideSlotImage = () => {
        return new Promise((resolve) => {
          fabric.Image.fromURL(require('../../assets/slot2.png'), (slotImg) => {
            resolve(slotImg)
          })
        })
      }

      // 包装 clone 方法
      const cloneImage = (sourceImg) => {
        return new Promise((resolve) => {
          sourceImg.clone((clonedImg) => {
            resolve(clonedImg)
          })
        })
      }

      // 异步加载图片并创建所有元素
      ;(async () => {
        // 加载孔图片
        const holeImg = await loadHoleImage()
        // 获取图片原始尺寸
        const imgWidth = holeImg.width || holeImg.getScaledWidth()
        const imgHeight = holeImg.height || holeImg.getScaledHeight()
        // 等比缩放
        const scale = 0.1
        const scaledWidth = imgWidth * scale
        const scaledHeight = imgHeight * scale
        // 计算图片位置：在矩形上方中心（相对于 Group 的坐标系）
        const holeTop = -mmToPx(1, this.arrDPI) // 图片中心距离矩形顶部 1mm（转换为 px），负值表示在矩形上方
        // 中心图片位置
        const holeCenterLeft = codeWidth / 2 // 矩形中心（相对于 Group）
        const holeCenterTop = codeHeight / 2 // 矩形中心（相对于 Group）
        //  上下 和 左右 分别间隙要更具宽高计算
        const holeSpacingW = (codeWidth - scaledHeight * 5) / 2 // 左右图片距离中心图片 6mm
        const holeSpacingH = (codeHeight - scaledHeight * 5) / 2 // 上下图片距离中心图片 6mm

        // 设置中心图片
        holeImg.set({
          left: holeCenterLeft,
          top: holeTop,
          scaleX: scale,
          scaleY: scale,
          angle: 90,
          originX: 'center',
          originY: 'center',
          selectable: false,
          evented: false,
          typeName: 'sideMachiningSequenceDiagramHole',
        })
        // 复制两个图片，分别放在左右两侧 模拟侧孔
        const imgLeft = await cloneImage(holeImg)
        imgLeft.set({
          left: holeCenterLeft - holeSpacingW,
          top: holeTop,
          scaleX: scale,
          scaleY: scale,
          angle: 90,
          originX: 'center',
          originY: 'center',
          selectable: false,
          evented: false,
          typeName: 'sideMachiningSequenceDiagramHole',
        })
        const imgRight = await cloneImage(holeImg)
        imgRight.set({
          left: holeCenterLeft + holeSpacingW,
          top: holeTop,
          scaleX: scale,
          scaleY: scale,
          angle: 90,
          originX: 'center',
          originY: 'center',
          selectable: false,
          evented: false,
          typeName: 'sideMachiningSequenceDiagramHole',
        })
        // 将三个图片组成一个组（上边的组 宽度间隙）
        const holeGroupTop = new fabric.Group([holeImg, imgLeft, imgRight], {
          left: holeCenterLeft,
          top: holeTop,
          selectable: false,
          evented: false,
          originX: 'center',
          originY: 'center',
          typeName: 'sideMachiningSequenceDiagramHoleGroup',
        })
        // 复制下边侧孔组
        const holeGroupBottom = await cloneImage(holeGroupTop)
        const holeBottom = codeHeight + mmToPx(1, this.arrDPI) + 1
        holeGroupBottom.set({
          left: holeCenterLeft,
          top: holeBottom,
          angle: 0,
          originX: 'center',
          originY: 'center',
        })

        const holeImg2 = await cloneImage(holeImg)
        holeImg2.set({
          left: holeCenterTop,
          top: holeTop,
          scaleX: scale,
          scaleY: scale,
          angle: 90,
          originX: 'center',
          originY: 'center',
          selectable: false,
          evented: false,
          typeName: 'sideMachiningSequenceDiagramHole',
        })
        // 复制两个图片，分别放在左右两侧 模拟侧孔
        const imgLeft2 = await cloneImage(holeImg2)
        imgLeft2.set({
          left: holeCenterTop - holeSpacingH,
          top: holeTop,
          scaleX: scale,
          scaleY: scale,
          angle: 90,
          originX: 'center',
          originY: 'center',
          selectable: false,
          evented: false,
          typeName: 'sideMachiningSequenceDiagramHole',
        })
        const imgRight2 = await cloneImage(holeImg2)
        imgRight2.set({
          left: holeCenterTop + holeSpacingH,
          top: holeTop,
          scaleX: scale,
          scaleY: scale,
          angle: 90,
          originX: 'center',
          originY: 'center',
          selectable: false,
          evented: false,
          typeName: 'sideMachiningSequenceDiagramHole',
        })
        // 将三个图片组成一个组（上边的组 宽度间隙）
        const holeGroupTop2 = new fabric.Group(
          [holeImg2, imgLeft2, imgRight2],
          {
            left: holeCenterLeft,
            top: holeTop,
            selectable: false,
            evented: false,
            originX: 'center',
            originY: 'center',
            typeName: 'sideMachiningSequenceDiagramHoleGroup',
          }
        )
        // 复制左边侧孔组
        const holeGroupLeft = await cloneImage(holeGroupTop2)
        const holeLeft = -mmToPx(1, this.arrDPI)
        holeGroupLeft.set({
          left: holeLeft,
          top: holeCenterTop,
          angle: 90,
          originX: 'center',
          originY: 'center',
        })
        // 复制右边侧孔组
        const holeGroupRight = await cloneImage(holeGroupTop2)
        const holeRight = codeWidth + mmToPx(1, this.arrDPI) + 1
        holeGroupRight.set({
          left: holeRight,
          top: holeCenterTop,
          angle: 90,
          originX: 'center',
          originY: 'center',
        })

        // 绘制侧槽
        const slotImg = await loadSideSlotImage()
        const slotImgWidth = slotImg.width || slotImg.getScaledWidth()
        const slotImgHeight = slotImg.height || slotImg.getScaledHeight()
        const slotImgScale = 0.34
        const slotImgScaledWidth = slotImgWidth * slotImgScale
        const slotImgScaledHeight = slotImgHeight * slotImgScale
        // 为了保持侧槽和其相邻边也一样长，需要计算缩放比例
        const a = codeWidth / slotImgScaledWidth
        const b = codeHeight / slotImgScaledWidth

        slotImg.set({
          left: 0,
          top: 0,
          scaleX: slotImgScale,
          scaleY: slotImgScale,
          selectable: false,
          evented: false,
          typeName: 'sideMachiningSequenceDiagramSlot',
        })

        const slotImgTop = await cloneImage(slotImg)
        slotImgTop.set({
          scaleX: slotImgScale * a,
          scaleY: slotImgScale,
          left: 0,
          top: 0 - slotImgScaledHeight - 1,
          angle: 0,
        })
        const slotImgBottom = await cloneImage(slotImgTop)
        slotImgBottom.set({
          left: 0,
          top: codeHeight + 1 + 1,
          angle: 0,
        })

        const slotImg2 = await cloneImage(slotImg)
        slotImg2.set({
          left: 0,
          top: 0,
          angle: 0,
          scaleX: slotImgScale * b,
          scaleY: slotImgScale,
        })
        // 复制另外三个图片，分别放在矩形的另外三边
        const slotImgLeft = await cloneImage(slotImg2)
        slotImgLeft.set({
          left: -1,
          top: 0,
          angle: 90,
        })
        const slotImgRight = await cloneImage(slotImg2)
        slotImgRight.set({
          left: codeWidth + 1 + slotImgScaledHeight + 1,
          top: 0,
          angle: 90,
        })

        // 1/3 再上移一个孔宽；2/4 左移一个孔宽，贴槽外沿不再外推
        const textFontSize = PtToPx(numberFontPt, this.arrDPI)
        const slotOutset = slotImgScaledHeight + 1
        const holeWidth = scaledHeight

        // 创建四个L型角标，分别放在矩形的四角
        const cornerMarkLength = mmToPx(2, this.arrDPI) // 角标长度 2mm
        const cornerStrokeWidth = 2
        const cornerColor = 'rgba(0,0,0,0.8)'

        // 左下角直角三角形角标（直角对应原 L 形角点 (0, codeHeight)）
        const cornerBottomLeft = new fabric.Polygon(
          [
            { x: 0, y: codeHeight },
            { x: cornerMarkLength, y: codeHeight },
            { x: 0, y: codeHeight - cornerMarkLength },
          ],
          {
            fill: cornerColor,
            stroke: cornerColor,
            strokeWidth: 0,
            selectable: false,
            evented: false,
            typeName: 'sideMachiningSequenceDiagramCorner',
          }
        )

        // 创建最终的 Group，包含矩形、四个图片组、四个数字文本、四个L型角标
        const sideMachiningSequenceDiagram = new fabric.Group(
          [
            sideMachiningSequenceDiagramBaseRect,
            holeGroupTop,
            holeGroupBottom,
            holeGroupLeft,
            holeGroupRight,
            cornerBottomLeft,
          ],
          {
            left: drawDleft,
            top: drawDtop,
            selectable: true,
            hasControls: true,
            typeName: 'sideMachiningSequenceDiagram',
            originX: 'left',
            originY: 'top',
            // 启用 8 个方向的拖动放大缩小以及旋转
            lockRotation: false, // 允许旋转
            lockScalingX: false, // 允许 X 轴缩放
            lockScalingY: false, // 允许 Y 轴缩放
            lockMovementX: false, // 允许 X 轴移动
            lockMovementY: false, // 允许 Y 轴移动
            showSideMachiningSequenceDiagramBorder:
              this.isShowSideMachiningSequenceDiagramBorder,
            showSideMachiningSequenceNumber:
              this.isShowSideMachiningSequenceNumber,
            flipOverProcessing: this.isFlipOverProcessing,
            fontPt: numberFontPt,
            textFontSize: textFontSize,
            mWidth: innerMmW,
            mHeight: innerMmH,
            scaleX,
            scaleY,
            uniqueID: drawD.uniqueID || String(Date.now()),
          }
        )

        // 计算所有元素的边界，包括矩形外部的元素
        // 获取孔图片组的实际尺寸（考虑缩放后的尺寸）
        const holeGroupHalfWidth = (scaledWidth / 2) * 1.5
        const holeGroupHalfHeight = scaledHeight / 2
        const cornerHalfStroke = cornerStrokeWidth / 2

        const minLeft = Math.min(
          holeLeft - holeGroupHalfWidth,
          -slotOutset,
          -cornerHalfStroke
        )
        const minTop = Math.min(
          holeTop - holeGroupHalfHeight,
          -slotOutset,
          -cornerHalfStroke
        )
        const maxRight = Math.max(
          holeRight + holeGroupHalfWidth,
          codeWidth + slotOutset,
          codeWidth + cornerMarkLength + cornerHalfStroke
        )
        const maxBottom = Math.max(
          holeBottom + holeGroupHalfHeight,
          codeHeight + slotOutset,
          codeHeight + cornerMarkLength + cornerHalfStroke
        )

        // 计算 Group 需要的实际宽度和高度（包含所有外部元素）
        const actualWidth = Math.round(maxRight - minLeft)
        const actualHeight = Math.round(maxBottom - minTop)

        // 调整 Group 的位置和尺寸，使其包含所有元素
        // 由于元素都是相对于 (0, 0) 定位的，我们需要调整 Group 的 left 和 top
        sideMachiningSequenceDiagram.set({
          left: Math.round(drawDleft + minLeft),
          top: Math.round(drawDtop + minTop),
          width: actualWidth,
          height: actualHeight,
          innerOffsetX: -minLeft,
          innerOffsetY: -minTop,
          slotOutset,
          holeWidth,
        })
        sideMachiningSequenceDiagram.setCoords()

        sideMachiningSequenceDiagram.setControlVisible('mtr', false)
        // 设置元素ID
        this.setItemId(sideMachiningSequenceDiagram)
        this[canvasId].add(sideMachiningSequenceDiagram)
        this.createSideDiagramAuxiliaryNumbers(
          sideMachiningSequenceDiagram,
          canvasId
        )
        this[this.mycanvasId].renderAll()
      })()
    },
    drawWardrobeNumByTemp(drawD, item) {
      const position = {
        radius: drawD.mRadius,
        fontSize: drawD.fontPt,
        left: drawD.left,
        top: drawD.top,
        fontWeight: drawD.fontWeight,
        fontFamily: drawD.fontFamily ?? '微软雅黑',
        roomSortWay: drawD.roomSortWay ?? 'letters',
        realRadius: drawD.realRadius ?? drawD.mRadius,
      }
      const group = this.drawOrderOrPanel(
        drawD.field ?? 'wardrobeNum',
        position,
        item.type
      )
      return group
    },
    upDateImg(object, codeType, kClass = null, type = '') {
      let urlInfo = this.createImgUrl(codeType, this.nowCodeInfo)
      let img = new Image()
      img.onload = () => {
        object?.item(0)?.setElement?.(img)
        // 好骚啊，不知道为啥要设置一个属性变化才能刷新才有效，只有group里刷新不了
        if (type != 'size') {
          this.codeW = pxTomm(urlInfo.width, this.arrDPI)
          this.codeH = pxTomm(urlInfo.height, this.arrDPI)
        }
        let scale = object.scaleX

        object.set({
          scaleX: scale == 1 ? 1.000001 : 1,
          width: mmToPx(this.codeW, this.arrDPI),
          height: mmToPx(this.codeH, this.arrDPI),
          mWidth: this.codeW,
          mHeight: this.codeH,
        })
        object.item(0).set({
          width: mmToPx(this.codeW, this.arrDPI),
          left: -mmToPx(this.codeW, this.arrDPI) / 2,
          top: -mmToPx(this.codeH, this.arrDPI) / 2,
          fontSize: PtToPx(this.nowFontSize, this.arrDPI),
          fontPt: this.nowFontSize,
        })
        clearTimeout(this.loadTime)
        this.loadTime = setTimeout(() => {
          if (urlInfo.width > mmToPx(this.codeW, this.arrDPI) + 0.5) {
            this.$message({
              type: 'warning',
              message: '条码长度超出边框，请调整边框宽高',
              duration: 1500,
            })
          }
          if (urlInfo.height > mmToPx(this.codeH, this.arrDPI) + 0.5) {
            this.$message({
              type: 'warning',
              message: '条码高度超出边框，请调整边框宽高',
              duration: 1500,
            })
          }
        }, 500)
        object.setCoords()
        this[this.mycanvasId].renderAll()
      }
      img.src = urlInfo.url
    },
    createImgUrl(codeType, source_data, inspect = true) {
      let num = 6160479583801
      if (source_data == 'plankNumF') {
        num = num + 'K'
      }
      let canvas = document.createElement('canvas')
      if (codeType == 'EAN13' && this.nowFontSize > 8) {
        this.nowFontSize = 8
      }
      JsBarcode(canvas, num, {
        format: codeType,
        width: 1.0,
        height: (mmToPx(10, this.arrDPI) / 3) * 2,
        margin: 0,
        fontOptions: this.fontWeight ? 'bold' : '',
        fontSize: PtToPx(this.nowFontSize, this.arrDPI),
        textMargin: this.lineSpace,
        lineCount: this.lineCount,
        font: this.nowFontFamily,
      })
      let url = canvas.toDataURL('image/png')
      return {
        url: url,
        width: canvas.width,
        height: canvas.height,
      }
    },
    createDefaultUrl(option) {
      let num = 6160479583801
      if (option.source_data == 'plankNumF') {
        num = num + 'K'
      }
      let canvas = document.createElement('canvas')
      JsBarcode(canvas, num, {
        format: option.codeType,
        width: 1.0,
        height: (mmToPx(10, this.arrDPI) / 3) * 2,
        margin: 0,
        fontOptions: option.fontWeight == 'bold' ? 'bold' : '',
        fontSize: PtToPx(option.fontPt, this.arrDPI),
        textMargin: option.lineHeight,
        font: option.fontFamily,
      })
      let url = canvas.toDataURL('image/png')
      return url
    },
    countOldTem() {
      this.mods = 0
      let saveValue = [
        'switchCodeValueShunt',
        'showCode',
        'item_id',
        'source_data',
        'mHeight',
        'mWidth',
        'code_type',
        'hasControls',
        'typeName',
        'fontPt',
        'fontSize',
        'fontWeight',
        'angle',
        'lineHeight',
        'scaleX',
        'scaleY',
        'textBackgroundColor',
        'selectable',
        'positionName',
        'oLeft',
        'oTop',
        'splitByGrapheme',
        'splitByGrapheme',
        'textAlign',
        'mRadius',
        'realRadius',
        '_isLine',
        '_isClone',
        '_afterOpacity',
        'triangleSize',
      ]
      const json = this[this.mycanvasId].toJSON(saveValue)
      // 不存储线段元素和用于临时使用的克隆元素
      json.objects = json.objects.filter(
        (item) => !item._isLine && !item._isClone
      )
      // 重置部分操作带来的参数影响
      json.objects.forEach((item) => {
        // 透明度使用之前存储的
        item.opacity = item._afterOpacity ?? item.opacity
      })
      json.id = this.currentCanvas.lowerCanvasEl.id
      // 禁止上下拖动
      this.operateArrs.push(json) // toJSON-画板信息序列化成json
    },
    setControlVisible(tem, visible, ...values) {
      for (let i = 0; i <= values.length; i++) {
        tem['setControlVisible'](values[i], visible)
      }
    },
    listenerMousedown(e) {
      this.chooseOtherSet = false
      this.isDraw = false
    },
    listenerMousemove(e) {
      if (e.target.tagName != 'CANVAS' && this.isAllSelect) {
        this[this.mycanvasId].discardActiveObject() // 取消画布中所有对象的选中状态
        this[this.mycanvasId].requestRenderAll() // 请求重新渲染
        this.isAllSelect = false
      }
    },
    listenerMouseup(e) {
      this.chooseOtherSet = true
      if (this.nowETarget && this.isDraw && !this.mouseInCanvas) {
        this.nowETarget = null
        this.resetData(this.nowChooseSet)
        this.countOldTem()
        this.reDrawByCurrentPostion(this.overUpPoint, this.nowChooseSet)
        buryPointApi('tag', `${this.labelTemplates}_${this.nowChooseSet}`)
      }
      this.isDraw = false
    },
    /** 重新绘制一个元素基于现在的位置 */
    reDrawByCurrentPostion(newPosition, type) {
      const { x: newX, y: newY } = newPosition
      switch (type) {
        case 'holeSlotPicture':
          this.holeSlotPictureDataInfo = 'holeSlotPicture'
          fabric.Image.fromURL(require('../../assets/hole_slot.png'), (img) => {
            const unique = new Date().getTime().toString()
            img.set({
              top: newY,
              left: newX,
              hasControls: true,
              typeName: 'holeSlotPicture',
              holeF: this.holeF,
              holeZ: this.holeZ,
              partEdge: this.partEdge,
              mWidth: 19,
              mHeight: 19,
              uniqueID: unique,
              defaultScale: this.pictureScale,
            })
            this.setControlVisible(img, false, 'mtr')
            img.scaleToWidth(mmToPx(this.codeW, this.arrDPI))
            img.scaleToHeight(mmToPx(this.codeH, this.arrDPI))
            const w = mmToPx(this.codeW, this.arrDPI)
            const h = mmToPx(this.codeH, this.arrDPI)
            // 封边文字绘制
            const { top: imgTop, left: imgLeft } = img

            const edgeTextDraws = this.dealPartEdgeDraws(
              imgLeft,
              imgTop,
              w,
              h,
              unique
            )

            const plankSize = [
              { value: '1220', name: 'width' },
              { value: '2440', name: 'height' },
            ]

            const textEls = []
            plankSize.forEach((item) => {
              let elW = this.getElementInfo('span', 'offsetWidth', item.value)
              elW = pxTomm(elW, this.arrDPI) / 2
              const text = new fabric.Text(item.value, {
                positionName: item.name,
                fontSize: this.nowFontSize,
                fontPt: this.nowFontSize,
                hasControls: false,
                createElementWidth: elW,
                isShow: this.plankSize,
                typeName: 'holeSlotPicture-size',
                uniqueID: unique,
                opacity: Number(this.plankSize),
                selectable: false,
                fontFamily: this.nowFontFamily,
              })

              /**
               * moveF 附属元素跟随移动方法
               */
              let left = 0,
                top = 0
              // moveF = null
              switch (item.name) {
                case 'width':
                  left = imgLeft + w / 2
                  top = imgTop + h
                  break
                case 'height':
                  left = imgLeft + w
                  top = imgTop + h / 2
                  break
              }
              // 注入方法
              this.klassSetMethods(text, { show: 'plankSize' })
              text.set({
                top: top,
                left: left,
              })
              this.setItemId(text)
              this[this.mycanvasId].add(text)
              textEls.push(text)
            })
            this.setItemId(img)
            this[this.mycanvasId].add(img)
            // 添加附属元素
            img.set({
              auxiliaryEl: textEls,
              partEdgeElList: edgeTextDraws,
            })
            // 选中该元素
            this.currentItem = img
            this[this.mycanvasId].setActiveObject(img)
            this.getKclassValueToAttr(img)
            this[this.mycanvasId].renderAll()
          })
          break
        case 'sideMachiningSequenceDiagram': {
          this.holeSlotPictureDataInfo = 'sideMachiningSequenceDiagram'
          const codeWidth = mmToPx(this.codeW, this.arrDPI)
          const codeHeight = mmToPx(this.codeH, this.arrDPI)
          // 矩形在 Group 中的位置应该是 (0, 0)，而不是绝对坐标
          const sideMachiningSequenceDiagramBaseRect = new fabric.Rect({
            top: 0,
            left: 0,
            width: codeWidth,
            height: codeHeight,
            fill: 'rgba(0,0,0,0)',
            stroke: 'rgba(0,0,0,.2)',
            strokeWidth: 1,
            selectable: false,
            evented: false,
            opacity: 1,
            typeName: 'sideMachiningSequenceDiagramBaseRect',
          })
          // 添加边框显隐控制方法
          sideMachiningSequenceDiagramBaseRect.borderShowF = function (isShow) {
            this.set({
              opacity: isShow ? 1 : 0,
            })
          }
          sideMachiningSequenceDiagramBaseRect.borderShowF(
            this.isShowSideMachiningSequenceDiagramBorder
          )

          // 绘制孔图片
          const loadHoleImage = () => {
            return new Promise((resolve) => {
              fabric.Image.fromURL(require('../../assets/hole.png'), (img) => {
                resolve(img)
              })
            })
          }

          // 包装 clone 方法
          const cloneImage = (sourceImg) => {
            return new Promise((resolve) => {
              sourceImg.clone((clonedImg) => {
                resolve(clonedImg)
              })
            })
          }

          // 绘制侧槽图片
          const loadSideSlotImage = () => {
            return new Promise((resolve) => {
              fabric.Image.fromURL(
                require('../../assets/slot2.png'),
                (slotImg) => {
                  resolve(slotImg)
                }
              )
            })
          }

          // 异步加载图片并创建所有元素
          ;(async () => {
            // 加载孔图片
            const holeImg = await loadHoleImage()
            // 获取图片原始尺寸
            const imgWidth = holeImg.width || holeImg.getScaledWidth()
            const imgHeight = holeImg.height || holeImg.getScaledHeight()
            // 等比缩放
            const scale = 0.1
            const scaledWidth = imgWidth * scale
            const scaledHeight = imgHeight * scale
            // 计算图片位置：在矩形上方中心（相对于 Group 的坐标系）
            const holeTop = -mmToPx(1, this.arrDPI) // 图片中心距离矩形顶部 1mm（转换为 px），负值表示在矩形上方
            // 中心图片位置
            const holeCenterLeft = codeWidth / 2 // 矩形中心（相对于 Group）
            // 左右图片距离中心图片的距离（可以根据需要调整）
            // const holeSpacing = mmToPx(6, this.arrDPI) // 左右图片距离中心图片 6mm
            const holeSpacing = (codeWidth - scaledHeight * 5) / 2 // 左右图片距离中心图片 6mm

            // 设置中心图片
            holeImg.set({
              left: holeCenterLeft,
              top: holeTop,
              scaleX: scale,
              scaleY: scale,
              angle: 90,
              originX: 'center',
              originY: 'center',
              selectable: false,
              evented: false,
              typeName: 'sideMachiningSequenceDiagramHole',
            })

            // 复制两个图片，分别放在左右两侧 模拟侧孔
            const imgLeft = await cloneImage(holeImg)
            imgLeft.set({
              left: holeCenterLeft - holeSpacing,
              top: holeTop,
              scaleX: scale,
              scaleY: scale,
              angle: 90,
              originX: 'center',
              originY: 'center',
              selectable: false,
              evented: false,
              typeName: 'sideMachiningSequenceDiagramHole',
            })

            const imgRight = await cloneImage(holeImg)
            imgRight.set({
              left: holeCenterLeft + holeSpacing,
              top: holeTop,
              scaleX: scale,
              scaleY: scale,
              angle: 90,
              originX: 'center',
              originY: 'center',
              selectable: false,
              evented: false,
              typeName: 'sideMachiningSequenceDiagramHole',
            })

            // 将三个图片组成一个组（上边的组）
            const holeGroupTop = new fabric.Group(
              [holeImg, imgLeft, imgRight],
              {
                left: holeCenterLeft,
                top: holeTop,
                selectable: false,
                evented: false,
                originX: 'center',
                originY: 'center',
                typeName: 'sideMachiningSequenceDiagramHoleGroup',
              }
            )

            // 复制三个组，分别放到矩形的另外三边
            const holeGroupBottom = await cloneImage(holeGroupTop)
            const holeBottom = codeHeight + mmToPx(1, this.arrDPI) + 1
            holeGroupBottom.set({
              left: holeCenterLeft,
              top: holeBottom,
              angle: 0,
              originX: 'center',
              originY: 'center',
            })

            const holeGroupLeft = await cloneImage(holeGroupTop)
            const holeLeft = -mmToPx(1, this.arrDPI)
            const holeCenterTop = codeHeight / 2
            holeGroupLeft.set({
              left: holeLeft,
              top: holeCenterTop,
              angle: 90,
              originX: 'center',
              originY: 'center',
            })

            const holeGroupRight = await cloneImage(holeGroupTop)
            const holeRight = codeWidth + mmToPx(1, this.arrDPI) + 1
            holeGroupRight.set({
              left: holeRight,
              top: holeCenterTop,
              angle: 90,
              originX: 'center',
              originY: 'center',
            })

            // 侧槽图片
            const slotImg = await loadSideSlotImage()
            const slotImgWidth = slotImg.width || slotImg.getScaledWidth()
            const slotImgHeight = slotImg.height || slotImg.getScaledHeight()
            const slotImgScale = 0.34
            const slotImgScaledWidth = slotImgWidth * slotImgScale
            const slotImgScaledHeight = slotImgHeight * slotImgScale

            slotImg.set({
              left: 0,
              top: 0 - slotImgScaledHeight - 1,
              scaleX: slotImgScale,
              scaleY: slotImgScale,
              selectable: false,
              evented: false,
              typeName: 'sideMachiningSequenceDiagramSlot',
            })
            // 复制另外三个图片，分别放在矩形的另外三边
            const slotImgLeft = await cloneImage(slotImg)
            slotImgLeft.set({
              left: -1,
              top: 0,
              angle: 90,
              scaleX: slotImgScale,
              scaleY: slotImgScale,
            })
            const slotImgRight = await cloneImage(slotImg)
            slotImgRight.set({
              left: codeWidth + 1 + slotImgScaledHeight + 1,
              top: 0,
              angle: 90,
              scaleX: slotImgScale,
              scaleY: slotImgScale,
            })
            const slotImgBottom = await cloneImage(slotImg)
            slotImgBottom.set({
              left: 0,
              top: codeHeight + 1 + 1,
              angle: 0,
              scaleX: slotImgScale,
              scaleY: slotImgScale,
            })

            // 1/3 再上移一个孔宽；2/4 左移一个孔宽，贴槽外沿不再外推
            const numberFontPt = Number(this.nowFontSize) || 8
            const textFontSize = PtToPx(numberFontPt, this.arrDPI)
            const slotOutset = slotImgScaledHeight + 1
            const holeWidth = scaledHeight

            // 创建四个L型角标，分别放在矩形的四角
            const cornerMarkLength = mmToPx(2, this.arrDPI) // 角标长度 2mm
            const cornerStrokeWidth = 2
            const cornerColor = 'rgba(0,0,0,0.8)'

            // 左下角直角三角形角标（直角对应原 L 形角点 (0, codeHeight)）
            const cornerBottomLeft = new fabric.Polygon(
              [
                { x: 0, y: codeHeight },
                { x: cornerMarkLength, y: codeHeight },
                { x: 0, y: codeHeight - cornerMarkLength },
              ],
              {
                fill: cornerColor,
                stroke: cornerColor,
                strokeWidth: 0,
                selectable: false,
                evented: false,
                typeName: 'sideMachiningSequenceDiagramCorner',
              }
            )

            // 创建最终的 Group，包含矩形、四个图片组、四个数字文本、四个L型角标
            const sideMachiningSequenceDiagram = new fabric.Group(
              [
                sideMachiningSequenceDiagramBaseRect,
                holeGroupTop,
                holeGroupBottom,
                holeGroupLeft,
                holeGroupRight,
                cornerBottomLeft,
              ],
              {
                left: newX,
                top: newY,
                selectable: true,
                hasControls: true,
                typeName: 'sideMachiningSequenceDiagram',
                originX: 'left',
                originY: 'top',
                // 启用 8 个方向的拖动放大缩小以及旋转
                lockRotation: false, // 允许旋转
                lockScalingX: false, // 允许 X 轴缩放
                lockScalingY: false, // 允许 Y 轴缩放
                lockMovementX: false, // 允许 X 轴移动
                lockMovementY: false, // 允许 Y 轴移动
                showSideMachiningSequenceDiagramBorder:
                  this.isShowSideMachiningSequenceDiagramBorder,
                showSideMachiningSequenceNumber:
                  this.isShowSideMachiningSequenceNumber,
                flipOverProcessing: this.isFlipOverProcessing,
                fontPt: numberFontPt,
                textFontSize: textFontSize,
                mWidth: this.codeW,
                mHeight: this.codeH,
                uniqueID: String(Date.now()),
              }
            )

            // 计算所有元素的边界，包括矩形外部的元素
            // 获取孔图片组的实际尺寸（考虑缩放后的尺寸）
            const holeGroupHalfWidth = (scaledWidth / 2) * 1.5
            const holeGroupHalfHeight = scaledHeight / 2
            const cornerHalfStroke = cornerStrokeWidth / 2

            const minLeft = Math.min(
              holeLeft - holeGroupHalfWidth,
              -slotOutset,
              -cornerHalfStroke
            )
            const minTop = Math.min(
              holeTop - holeGroupHalfHeight,
              -slotOutset,
              -cornerHalfStroke
            )
            const maxRight = Math.max(
              holeRight + holeGroupHalfWidth,
              codeWidth + slotOutset,
              codeWidth + cornerMarkLength + cornerHalfStroke
            )
            const maxBottom = Math.max(
              holeBottom + holeGroupHalfHeight,
              codeHeight + slotOutset,
              codeHeight + cornerMarkLength + cornerHalfStroke
            )

            // 计算 Group 需要的实际宽度和高度（包含所有外部元素）
            const actualWidth = Math.round(maxRight - minLeft)
            const actualHeight = Math.round(maxBottom - minTop)

            // 调整 Group 的位置和尺寸，使其包含所有元素
            // 由于元素都是相对于 (0, 0) 定位的，我们需要调整 Group 的 left 和 top
            sideMachiningSequenceDiagram.set({
              left: Math.round(newX + minLeft),
              top: Math.round(newY + minTop),
              width: actualWidth,
              height: actualHeight,
              innerOffsetX: -minLeft,
              innerOffsetY: -minTop,
              slotOutset,
              holeWidth,
            })
            sideMachiningSequenceDiagram.setCoords()

            sideMachiningSequenceDiagram.setControlVisible('mtr', false)
            this[this.mycanvasId].add(sideMachiningSequenceDiagram)
            // 设置元素ID
            this.setItemId(sideMachiningSequenceDiagram)
            this.createSideDiagramAuxiliaryNumbers(
              sideMachiningSequenceDiagram,
              this.mycanvasId
            )
            // 选中该元素
            this.currentItem = sideMachiningSequenceDiagram
            this[this.mycanvasId].setActiveObject(sideMachiningSequenceDiagram)
            this.getKclassValueToAttr(sideMachiningSequenceDiagram)
            this[this.mycanvasId].renderAll()
          })()
          break
        }
        case 'SurplusSize':
        case 'Typography':
          let imgUrl =
            type == 'Typography' ? paibanTestImage : surplusPlankImage
          fabric.Image.fromURL(imgUrl, (img) => {
            img.set({
              left: 10,
              top: 10,
              hasControls: true,
              lockRotation: true,
              typeName: type,
              mWidth: type == 'Typography' ? 15 : 12,
              mHeight: type == 'Typography' ? 25 : 15,
            })
            this.setControlVisible(img, false, 'mtr')
            this.imgScaleY(
              img,
              mmToPx(this.codeH, this.arrDPI) - 10,
              img.height
            )
            this.imgScaleX(img, mmToPx(this.codeW, this.arrDPI) - 10, img.width)
            this.setItemId(img)
            let edgeNumber = this.labelTemplates == 'plank' ? 0.5 : ''
            let edges =
              type == 'Typography'
                ? [
                    {
                      value: edgeNumber,
                      name: 'LE',
                    },
                    {
                      value: edgeNumber,
                      name: 'BE',
                    },
                    {
                      value: edgeNumber,
                      name: 'RE',
                    },
                    {
                      value: edgeNumber,
                      name: 'TE',
                    },
                  ]
                : [
                    {
                      value: 977,
                      name: 'RE',
                    },
                    {
                      value: 762,
                      name: 'BE',
                    },
                  ]
            let parentW = mmToPx(this.codeW, this.arrDPI)
            let parentH = mmToPx(this.codeH, this.arrDPI)
            let edgeText = []
            let openL = 0,
              openT = 0
            edges.forEach((item, index) => {
              let text = new fabric.Text(String(item.value), {
                positionName: item.name,
                fontSize: this.nowFontSize,
                fontPt: this.nowFontSize,
                fontFamily: this.nowFontFamily,
              })
              let left = 0
              let top = 0
              switch (item.name) {
                case 'LE':
                  top = parentH / 2
                  // left = -20;
                  break
                case 'BE':
                  top = parentH
                  left = parentW / 2
                  break
                case 'RE':
                  top = parentH / 2
                  left = parentW
                  openL = left
                  openT = top
                  break
                case 'TE':
                  // top = -20;
                  left = parentW / 2
                  break
              }
              text.set({
                top: top,
                left: left,
                oTop: top,
                oLeft: left,
              })
              edgeText.push(text)
            })
            const offsetLeft = edgeText[0].width + 6
            const offsetTop = edgeText[0].height / 2
            let circle
            if (type == 'Typography') {
              circle = this.drawCircle(6, 6, {
                left: openL + offsetLeft,
                top: openT + offsetTop,
                uniqueID: 'showDoor',
              })
            }
            const text = this.drawText(
              this.labelTemplates == 'plank' ? '开' : '',
              openT + offsetTop,
              openL + offsetLeft,
              8,
              12,
              '',
              {
                uniqueID: 'showDoor',
              }
            )
            let group = new fabric.Group(
              this.labelTemplates == 'plank'
                ? [img].concat(edgeText, circle, text)
                : [img].concat(edgeText, text),
              {
                top: newY,
                left: newX,
                fontPt: this.nowFontSize,
                typeName: type,
                width: parentW + offsetLeft,
                height: parentH,
                mWidth: this.codeW,
                mHeight: this.codeH,
                hasControls: true,
                showEdgeOff: this.showEdgeOff,
                showEdgeDisplay: this.showEdgeDisplay,
                showOpenDoor: this.showOpenDoor,
                plankRotate: this.plankRotate,
                showFrontEdge: this.showFrontEdge,
                showVisibleEdge: this.showVisibleEdge,
                isShowDiffEdgeColor: this.isShowDiffEdgeColor,
                hideSameEdgeColorAsPlank: this.hideSameEdgeColorAsPlank,
              }
            )
            // 处理缩放
            this.imgScaleY(group, mmToPx(this.codeH, this.arrDPI), group.height)
            this.imgScaleX(group, mmToPx(this.codeW, this.arrDPI), group.width)
            this.setControlVisible(group, false, 'mtr')
            this.setItemId(group)
            this[this.mycanvasId].add(group)
          })
          break
        case 'FixedText':
          // eslint-disable-next-line no-case-declarations
          let fixedText = new fabric.Textbox(
            translateTemplateWay('请双击输入文本'),
            {
              top: newY,
              left: newX,
              fontSize: PtToPx(this.nowFontSize, this.arrDPI),
              fontPt: this.nowFontSize,
              typeName: 'FixedText',
              fontWeight: '',
              lineHeight: this.lineSpace,
              lineCount: this.lineCount,
              lockRotation: true,
              hasControls: true,
              // splitByGrapheme: this.splitByGrapheme,
              objectCaching: false,
              textAlign: 'left',
              fontFamily: this.nowFontFamily,
              language: this.$store.state.exportLanguage || 'zh',
            }
          )
          fixedText.set({
            originWidth: fixedText.width,
            originHeight: fixedText.height,
          })
          this.setControlVisible(fixedText, false, 'mtr')
          this.setItemId(fixedText)
          this[this.mycanvasId].add(fixedText)
          break
        case 'DataSource':
          // eslint-disable-next-line no-case-declarations
          let Text = new fabric.Text(translateTemplateWay('请选择对应数据项'), {
            top: newY,
            left: newX,
            fontSize: PtToPx(this.nowFontSize, this.arrDPI),
            fontPt: this.nowFontSize,
            typeName: 'DataSource',
            fontWeight: '',
            lineHeight: this.lineSpace,
            lineCount: this.lineCount,
            textBackgroundColor: '#F6F6F6',
            hasControls: true,
            source_data: '',
            textWrapping: 'wrap',
            isAutoFontSize: true,
            fontFamily: this.nowFontFamily,
            lineCount: this.lineCount,
            oriText: translateTemplateWay('请选择对应数据项'),
          })
          Text.set({
            originWidth: Text.width,
            originHeight: Text.height,
            rectHeight: Text.height,
            rectWidth: Text.width,
          })
          this.setControlVisible(Text, false, 'mtr')
          this.setItemId(Text)
          this[this.mycanvasId].add(Text)
          this.isAutoFontSize = true
          break
        case 'QRcode':
          fabric.Image.fromURL(
            require('../../assets/tag_tem_test.png'),
            (img) => {
              img.set({
                // scaleX: mmToPx(this.codeH,this.arrDPI) / 200,
                // scaleY: mmToPx(this.codeH,this.arrDPI) / 200,
                top: newY,
                left: newX,
                hasControls: true,
                source_data:
                  this.labelTemplates == 'plank' ? 'ggid' : 'restockingCode',
                typeName: 'QRcode',
                mWidth: this.codeW,
                mHeight: this.codeH,
                pxWidth: mmToPx(this.codeW, this.arrDPI),
                pxHeight: mmToPx(this.codeH, this.arrDPI),
                showCode: true,
                isQRcodeNCSuffix: true,
              })
              this.imgScaleY(img, mmToPx(this.codeH, this.arrDPI), img.height)
              this.imgScaleX(img, mmToPx(this.codeW, this.arrDPI), img.width)
              this.setControlVisible(img, false, 'mtr', 'ml', 'mr', 'mt', 'mb')
              this.setItemId(img)
              this[this.mycanvasId].add(img)
            }
          )
          break
        case 'Onecode':
          let codeImgInfo =
            this.labelTemplates == 'plank'
              ? this.createImgUrl('EAN13', 'plankNum')
              : this.createImgUrl('EAN13', 'oriPlankNum')
          let url = codeImgInfo.url
          fabric.Image.fromURL(url, (img) => {
            img.set({
              source_data:
                this.labelTemplates == 'plank' ? 'plankNum' : 'oriPlankNum',
              code_type: 'EAN13',
              fontPt: this.nowFontSize,
              fontSize: PtToPx(this.nowFontSize, this.arrDPI),
              lineHeight: this.lineSpace,
              width: codeImgInfo.width,
              fontFamily: this.nowFontFamily,
            })
            // img.set({
            //     left:0,
            //     top:0
            // })
            // this.imgScaleY(img,mmToPx(this.codeH - 3,this.arrDPI), img.height)
            // this.imgScaleX(img,mmToPx(this.codeW,this.arrDPI), img.width)
            // let oText = new fabric.Text('6160479583801',{
            //     top:25,
            //     fontPt:this.nowFontSize,
            //     fontSize:PtToPx(this.nowFontSize,this.arrDPI),
            //     lineHeight:this.lineSpace
            // })
            let W = pxTomm(codeImgInfo.width, this.arrDPI)
            let H = pxTomm(codeImgInfo.height, this.arrDPI)
            this.codeW = W
            this.codeH = H
            let group = new fabric.Group([img], {
              typeName: 'Onecode',
              hasControls: true,
              top: newY,
              left: newX,
              width: codeImgInfo.width,
              height: codeImgInfo.height,
              originWidth: codeImgInfo.width,
              originHeight: codeImgInfo.height,
              mWidth: W,
              mHeight: H,
              pxWidth: codeImgInfo.width,
              pxHeight: codeImgInfo.height,
              showCode: true,
              rotateDeg: 0,
              isOnecodeNCSuffix: true,
              switchCodeValueShunt: this.switchCodeValueShunt,
              // originY:'top',
              // originX: "left"
            })
            group.setControlVisible('mtr', false)
            this.setItemId(group)
            this[this.mycanvasId].add(group)
          })
          break
        case 'Graphics':
          let w = mmToPx(this.codeW, this.arrDPI)
          let h = mmToPx(this.codeH, this.arrDPI)
          let ox = newX
          let oy = newY
          let pointArr = [
            {
              x: ox,
              y: oy + h / 3, //1
            },
            {
              x: ox + w / 2, //2
              y: oy,
            },
            {
              x: ox + w,
              y: oy + h / 3, //3
            },
            {
              x: ox + (w / 3) * 2, //4
              y: oy + h / 3,
            },
            {
              x: ox + (w / 3) * 2, //5
              y: oy + h,
            },
            {
              x: ox + w / 3, //6
              y: oy + h,
            },
            {
              x: ox + w / 3, //7
              y: oy + h / 3,
            },
          ]
          let Graphics = new fabric.Polygon(pointArr, {
            top: oy,
            left: ox,
            angle: this.angle,
            fill: this.GraColor,
            hasControls: true,
            typeName: 'Graphics',
            originX: 'center',
            originY: 'center',
            mWidth: this.codeW,
            mHeight: this.codeH,
          })
          Graphics.setControlVisible('mtr', false)
          this.setItemId(Graphics)
          this[this.mycanvasId].add(Graphics)
          break
        // case 'Marking':
        case 'wardrobeNum':
          this.selectWardrobeNum(this.currentItem)
          break
        case 'specialMark':
          this.selectSpecialMark(this.currentItem, 'init')
          break
        case 'Table':
          const tableUrl = fabricTable(
            this[this.mycanvasId],
            true,
            false,
            PtToPx(this.nowFontSize, this.arrDPI) * 2,
            'extraParts',
            10,
            10,
            this.nowFontFamily
          )
          fabric.Image.fromURL(tableUrl, (img) => {
            img.set({
              top: newY,
              left: newX,
              fontPt: this.nowFontSize,
              fontSize: PtToPx(this.nowFontSize, this.arrDPI),
              hasControls: true,
              source_data: 'extraParts',
              typeName: 'Table',
              mWidth: img.width,
              mHeight: img.height,
              // pxWidth: mmToPx(this.codeW, this.arrDPI),
              // pxHeight: mmToPx(this.codeH, this.arrDPI),
              showCode: true,
              scaleX: 0.5,
              scaleY: 0.5,
              fontFamily: this.nowFontFamily,
            })
            img.setControlVisible('mtr', false)
            this.setItemId(img)
            // 查看setItemId
            this[this.mycanvasId].add(img)
          })
          break
        case 'Marking':
          // 绘制余料标识
          const circle = new fabric.Circle({
            radius: mmToPx(this.drawDiameter / 2, this.arrDPI),
            fill: '#fff',
            stroke: '#000',
            strokeWidth: 1,
            mRadius: this.drawDiameter,
            realRadius: this.nowDiameter,
            originX: 'center',
            originY: 'center',
            top: this.drawDiameter,
            left: this.drawDiameter,
            visible: this.nowDiameter,
          })
          const text = new fabric.IText('余', {
            fontSize: PtToPx(this.nowFontSize, this.arrDPI) ?? 13,
            fontPt: this.nowFontSize ?? 10,
            fontWeight: this.fontWeight ? 'bold' : '',
            originX: 'center',
            originY: 'center',
            top: this.drawDiameter,
            left: this.drawDiameter,
            fontFamily: this.nowFontFamily ?? '微软雅黑',
          })
          const group = new fabric.Group([circle, text], {
            top: newY,
            left: newX,
            hasControls: false,
            typeName: 'Marking',
          })
          this.setItemId(group)
          this[this.mycanvasId].add(group)
          break
        case 'smallPlateMarking':
          this.drawSmallPlateMarking(this.currentItem)
          break
        case 'sixSideDrillArrow':
          this.drawSixSideDrillArrow(this.currentItem)
          break
        case 'sixSideDrillTriangle':
          this.drawSixSideDrillTriangle(this.currentItem)
          break
        case 'EdgeBand':
          let width = mmToPx(this.codeW, this.arrDPI)
          let height = mmToPx(this.codeH, this.arrDPI)

          let left = newX
          let top = newY
          let square = new fabric.Rect({
            left,
            top,
            width,
            height,
            fill: 'rgba(0,0,0,0)', // 透明填充
            stroke: '#000000', // 黑色边框
            strokeWidth: 4, // 较粗的边框
            selectable: true,
            typeName: 'EdgeBand',
            originX: 'left',
            originY: 'top',
          })
          this[this.mycanvasId].add(square)
          break
        case 'VisibleEdge':
          // 绘制见光边标识
          const codeWidth = this.codeW
          const codeHeight = this.codeH
          const triangleSize = this.triangleSize || 6
          const baseRect = new fabric.Rect({
            left: 0,
            top: 0,
            width: codeWidth,
            height: codeHeight,
            fill: 'rgba(0,0,0,0)',
            stroke: 'rgba(0,0,0,.2)',
            strokeWidth: 1,
            selectable: false,
            evented: false,
            opacity: 1,
            typeName: 'VisibleEdgeBase',
          })
          // 创建基础（向上）
          const topTriangleOptions = {
            left: codeWidth / 2 + 0.5, // +0.5 是一个微调值
            top: -triangleSize / 2 - 1,
            width: triangleSize,
            height: triangleSize,
            fill: '#000000',
            selectable: false,
            typeName: 'VisibleEdgeArrow',
            hasControls: false,
            originX: 'center',
            originY: 'center',
            position: 'top',
          }
          const TopTriangleCtor =
            this.visibleEdgeOrFrontEdgeStyle === 'triangle'
              ? fabric.Triangle
              : fabric.Rect
          const topTriangle = new TopTriangleCtor(topTriangleOptions)

          const bottomTriangle = fabric.util.object.clone(topTriangle)
          bottomTriangle.set({
            top: codeHeight + triangleSize / 2 + 1 + 1,
            angle: 180,
            position: 'bottom',
          })

          const leftTriangle = fabric.util.object.clone(topTriangle)
          leftTriangle.set({
            left: -triangleSize / 2 - 1,
            top: codeHeight / 2 + 0.5,
            angle: -90,
            position: 'left',
          })

          const rightTriangle = fabric.util.object.clone(topTriangle)
          rightTriangle.set({
            left: codeWidth + triangleSize / 2 + 1 + 1,
            top: codeHeight / 2 + 0.5,
            angle: 90,
            position: 'right',
          })

          const visibleEdge = new fabric.Group(
            [
              baseRect,
              topTriangle,
              bottomTriangle,
              leftTriangle,
              rightTriangle,
            ],
            {
              left: newX,
              top: newY,
              selectable: true,
              hasControls: true,
              typeName: 'VisibleEdge',
              triangleSize: triangleSize,
              originX: 'left',
              originY: 'top',
              visibleEdgeOrFrontEdgeStyle: this.visibleEdgeOrFrontEdgeStyle,
            }
          )
          const arr = ['mtr', 'ml', 'mr', 'mt', 'mb']
          arr.forEach((item) => {
            visibleEdge.setControlVisible(item, false)
          })
          this[this.mycanvasId].add(visibleEdge)
          // 设置元素ID
          this.setItemId(visibleEdge)
          break
        case 'FrontEdge':
          // 绘制前封边标识
          const codeW = this.codeW
          const codeH = this.codeH
          const size = this.triangleSize || 6
          const frontEdgeBaseRect = new fabric.Rect({
            left: 0,
            top: 0,
            width: codeW,
            height: codeH,
            fill: 'rgba(0,0,0,0)',
            stroke: 'rgba(0,0,0,.2)',
            strokeWidth: 1,
            selectable: false,
            evented: false,
            opacity: 1,
            typeName: 'FrontEdgeBase',
          })
          // 创建基础（向上）
          const frontEdgeTopTriangleOptions = {
            left: codeW / 2 + 0.5, // +0.5 是一个微调值
            top: -size / 2 - 1,
            width: size,
            height: size,
            fill: '#000000',
            selectable: false,
            typeName: 'FrontEdgeArrow',
            hasControls: false,
            originX: 'center',
            originY: 'center',
            position: 'top',
          }
          const FrontEdgeTopTriangleCtor =
            this.visibleEdgeOrFrontEdgeStyle === 'triangle'
              ? fabric.Triangle
              : fabric.Rect
          const frontEdgeTopTriangle = new FrontEdgeTopTriangleCtor(
            frontEdgeTopTriangleOptions
          )

          const frontEdgeBottomTriangle =
            fabric.util.object.clone(frontEdgeTopTriangle)
          frontEdgeBottomTriangle.set({
            top: codeH + size / 2 + 1 + 1,
            angle: 180,
            position: 'bottom',
          })

          const frontEdgeLeftTriangle =
            fabric.util.object.clone(frontEdgeTopTriangle)
          frontEdgeLeftTriangle.set({
            left: -size / 2 - 1,
            top: codeH / 2 + 0.5,
            angle: -90,
            position: 'left',
          })

          const frontEdgeRightTriangle =
            fabric.util.object.clone(frontEdgeTopTriangle)
          frontEdgeRightTriangle.set({
            left: codeW + size / 2 + 1 + 1,
            top: codeH / 2 + 0.5,
            angle: 90,
            position: 'right',
          })

          const frontEdge = new fabric.Group(
            [
              frontEdgeBaseRect,
              frontEdgeTopTriangle,
              frontEdgeBottomTriangle,
              frontEdgeLeftTriangle,
              frontEdgeRightTriangle,
            ],
            {
              left: newX,
              top: newY,
              selectable: true,
              hasControls: true,
              typeName: 'FrontEdge',
              triangleSize: size,
              originX: 'left',
              originY: 'top',
              visibleEdgeOrFrontEdgeStyle: this.visibleEdgeOrFrontEdgeStyle,
            }
          )
          const frontEdgeControlArr = ['mtr', 'ml', 'mr', 'mt', 'mb']
          frontEdgeControlArr.forEach((item) => {
            frontEdge.setControlVisible(item, false)
          })
          this[this.mycanvasId].add(frontEdge)
          // 设置元素ID
          this.setItemId(frontEdge)
          break
      }
      this.currentCanvas.renderAll()
    },

    // 处理孔槽图封边元素绘制
    dealPartEdgeDraws(left, top, w, h, unique) {
      const imgLeft = left
      const imgTop = top
      const edgeTextDraws = []

      const edgeArr = ['1', '2', '3', '4']
      for (let idx = 0; idx < edgeArr.length; idx++) {
        const str = edgeArr[idx]
        let left = 0
        let top = 0
        let elW = this.getElementInfo('span', 'offsetWidth', str)
        elW = pxTomm(elW, this.arrDPI) / 2
        switch (str) {
          case '1':
            left = imgLeft - elW * 2
            top = imgTop + h / 2
            break
          case '2':
            left = imgLeft
            top = imgTop + h + 10
            break
          case '3':
            left = imgLeft + w
            top = imgTop + h / 2 - 10
            break
          case '4':
            left = imgLeft + w / 2
            top = imgTop - 10
            break
          default:
            break
        }

        edgeTextDraws.push(
          new fabric.Text(str, {
            left,
            top,
            selectable: false,
            fill: 'rgb(0,0,0)',
            isShow: this.partEdge,
            positionName: `edge${str}`,
            fontSize: this.nowFontSize,
            fontPt: this.nowFontSize,
            hasControls: false,
            createElementWidth: elW,
            typeName: 'holeSlotPicture-edge',
            uniqueID: unique,
            opacity: Number(this.partEdge),
            selectable: false,
            fontFamily: this.nowFontFamily,
          })
        )
      }

      edgeTextDraws.forEach((item) => {
        this.klassSetMethods(item, { show: 'partEdge' })
        this.setItemId(item)
        this[this.mycanvasId].add(item)
      })
      return edgeTextDraws
    },
    // 在fabric画布上按下
    listenerContextMenu(e) {
      if (e.button === 2) {
        this.isFabricCanvasMove = true
        this.nowChooseSet = null
        this.fabricCutPoint = { x: e.offsetX, y: e.offsetY }
        e.preventDefault()
      }
    },
    // 抬起
    listenerFabricMouseUp() {
      this.isFabricCanvasMove = false
    },
    // 改变画布位置
    listenerFabricMouseMove(e) {
      if (this.isFabricCanvasMove) {
        const { offsetX, offsetY } = e
        const fabricCanvasOffset = {
          x: offsetX - this.fabricCutPoint.x,
          y: offsetY - this.fabricCutPoint.y,
        }
        this.setFabricTransform(fabricCanvasOffset.x, fabricCanvasOffset.y)
        this.fabricCutPoint = { x: offsetX, y: offsetY }
      }
    },
    // 绘制圆形
    drawCircle(radius, mRadius, other = {}) {
      return new fabric.Circle({
        radius: radius, //圆形半径
        fill: '#fff', //填充的颜色
        stroke: '#000', // 边框颜色
        strokeWidth: 1, // 边框大小
        mRadius,
        originX: 'cneter',
        originY: 'cneter',
        left: radius,
        top: radius,
        ...other,
      })
    },
    drawText(text, top, left, pt, fontSize, fontWeight, other = {}) {
      return new fabric.IText(text + '', {
        fontSize: pt,
        fontPt: fontSize,
        fontWeight: fontWeight,
        originX: 'cneter',
        originY: 'cneter',
        left: left,
        top: top,
        hasControls: true,
        ...other,
      })
    },
    async listenerKeydown(e) {
      let that = this

      // 需要移动的元素
      let canvasItems = [...this.controlRects, this.currentItem]

      let payload = null

      // 方向键按下移动事件
      switch (e.key) {
        case 'ArrowLeft':
          payload = ['left', 'sub']
          break
        case 'ArrowUp':
          payload = ['top', 'sub']
          break
        case 'ArrowRight':
          payload = ['left', 'add']
          break
        case 'ArrowDown':
          payload = ['top', 'add']
          break
        default:
          break
      }
      if (payload) {
        // 检查当前选中的对象是否为 sixSideDrillTriangle 类型，如果是则禁用键盘移动
        if (
          this.currentItem &&
          this.currentItem.typeName === 'sixSideDrillTriangle'
        ) {
          return
        }
        this.handleKeybordMove(canvasItems, ...payload)
      }
      const page = this[this.mycanvasId]
        .getObjects()
        .find((item) => item.typeName == 'TageBox')
      // page && this[this.mycanvasId].sendToBack(page)
      this[this.mycanvasId].renderAll()

      if (e.keyCode == 46) {
        that.deleteEl()
      }
      if (e.keyCode == 27) {
        // ESC 键清除当前活跃对象
        that.currentCanvas.discardActiveObject()
        that.clearControlRect()
        that.currentItem = null
      }
      if (e.keyCode == 17) {
        that.mouse_wheel = true
        that.keyboard.isCtrlDown = true
        that.getCurrentUseSelectedControl()?.current.currentSelected?.set({
          evented: false,
          selectable: false,
        })
        /** 改变内部按键状态 */
        fabricMovingControlList.forEach((item) => {
          item.keyboardStatusChange('ctrl', true)
        })
      }
      if (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey) {
        e.preventDefault()
        if (e.keyCode == 83) {
          that.save()
        } else if (e.keyCode == 67 && that.currentItem) {
          // 复制
          that.copyValue = handleTagSaveData([that.currentItem])
        } else if (e.keyCode == 86 && that.copyValue.length) {
          // 粘贴
          that.copyValue[0].data.left += 10
          that.copyValue[0].data.top += 10
          that.copyValue[0].item_id = nanoid()
          that.countOldTem()
          that.drawItemTem(that.copyValue, false, this.mycanvasId)
        } else if (e.keyCode == 90) {
          // 撤销
          const operateArrs = that.operateArrs.filter(
            (it) => it.id === that.currentCanvas.lowerCanvasEl.id
          )
          if (operateArrs.length) {
            const index = operateArrs.length - 1
            that.currentItem = null
            that[this.mycanvasId].clear().renderAll()
            that[this.mycanvasId].loadFromJSON(operateArrs[index])

            let items = that[this.mycanvasId].getObjects()
            for (let i = 0; i < items.length; i++) {
              if (items[i].typeName == 'FixedText') {
                this.setControlVisible(items[i], false, 'mtr', 'mt', 'mb')
              }
            }
            that[this.mycanvasId].renderAll()
            // 需要清空之前的板件标注信息
            this.plankSignBox = []
            // 此处是因为直接获取getObjects是空的，可能是内部有异步，所以在此处等待异步完成
            await new Promise((resolve) => setTimeout(resolve, 1))
            this.plankSignBox = this[this.mycanvasId]
              .getObjects()
              .filter((klass) => klass.source_data == 'plankSign')
            this.drawAllSignRect()
            // 再找到恢复的数据并删除此记录
            const targetIdx = that.operateArrs.findIndex(
              (it) => it === operateArrs[index]
            )
            that.operateArrs.splice(targetIdx, 1)
          }
        }
      }
    },

    handleKeybordMove(data, key, type) {
      data.forEach((obj) => {
        const payload = {}
        payload[key] = type == 'add' ? obj?.[key] + 1 : obj?.[key] - 1
        Object.keys(payload).forEach((key) => {
          obj?.set(key, payload[key])
        })
      })
    },

    listenerMousewheel(e) {
      if (e.ctrlKey) {
        e.preventDefault()
      }
    },
    getKclassValueToAttr(obj) {
      if (!obj) return
      this.nowChooseSet = obj.typeName
      this.fontSizeOpeion = [4, 6, 8, 10, 12, 14, 16, 20, 26, 32]
      this.inputAlert.fontSizeAlert = ''
      switch (obj.typeName) {
        case 'FixedText':
          this.nowFontSize = obj.fontPt
          this.fontWeight = obj.fontWeight == 'bold' ? true : false
          this.lineSpace = obj.lineHeight
          this.splitByGrapheme = obj.splitByGrapheme
          this.textAlign = obj.textAlign ? obj.textAlign : 'left'
          this.nowFontFamily = obj.fontFamily ?? '微软雅黑'
          break
        case 'Typography': {
          this.codeW = obj.mWidth
          this.codeH = obj.mHeight
          let TypographyTextItems = obj.getObjects()[1]
          this.nowFontSize = TypographyTextItems.fontPt
          this.fontWeight =
            TypographyTextItems.fontWeight == 'bold' ? true : false
          this.showEdgeOff = obj.showEdgeOff
          this.showEdgeDisplay = obj.showEdgeDisplay
          this.showOpenDoor = obj.showOpenDoor
          this.plankRotate = obj.plankRotate
          this.nowFontFamily = TypographyTextItems.fontFamily
          this.showFrontEdge = obj.showFrontEdge
          this.showVisibleEdge = obj.showVisibleEdge
          this.isShowDiffEdgeColor = obj.isShowDiffEdgeColor
          this.hideSameEdgeColorAsPlank = obj.hideSameEdgeColorAsPlank ?? false
          break
        }
        case 'Onecode':
          // let oneCodeText = obj.getObjects()[1];
          let oneCodeImg = obj.getObjects()[0]
          this.nowFontSize = oneCodeImg.fontPt
          this.fontWeight = oneCodeImg.fontWeight == 'bold' ? true : false
          this.lineSpace = oneCodeImg.lineHeight
          this.codeW = obj.mWidth
          this.codeH = obj.mHeight
          this.nowCodeInfo = oneCodeImg.source_data ?? true
          this.codeAtt = oneCodeImg.code_type
          this.switchCodeValue = obj.showCode
          this.switchCodeValueShunt = obj.switchCodeValueShunt
          this.isOnecodeNCSuffix = obj.isOnecodeNCSuffix
          this.nowFontFamily = oneCodeImg.fontFamily
          if (
            ['plankNum', 'oriPlankNum', 'remarks', 'ncName'].includes(
              oneCodeImg.source_data
            )
          ) {
            this.codeAttOpeion = mockData.codeAttOpeion
          } else {
            this.codeAttOpeion = mockData.codeAttOpeionK
          }
          if (oneCodeImg.code_type == 'EAN13') {
            this.fontSizeOpeion = [4, 6, 8]
          } else {
            this.fontSizeOpeion = [4, 6, 8, 10, 12, 14, 16, 20, 26, 32]
          }
          break
        case 'QRcode':
          this.codeW = obj.mWidth
          this.codeH = obj.mHeight
          this.nowCodeInfo = obj.source_data
          this.switchCodeValue = obj.showCode
          this.isQRcodeNCSuffix = obj.isQRcodeNCSuffix ?? true
          this.QRCodeFormat = obj.QRCodeFormat ?? 'QRCode'
          break
        case 'DataSource':
          this.nowFontSize = obj.fontPt
          this.fontWeight = obj.fontWeight == 'bold' ? true : false
          this.lineSpace = obj.lineHeight
          this.lineCount = obj.lineCount
          this.nowDataInfo = obj.source_data
          if (obj.source_data == 'oSize' || obj.source_data == 'cutSize') {
            this.sizeRestrict = obj.sizeRestrict ? obj.sizeRestrict : false
            // moduleq1 因为小数位数设置切割/成品用的同一个组件，但此处会更改绑定值，触发到 change 事件导致数据 BUG，所以这里手动触发一次失焦
            this.$refs['sizeRestrictNumRef']?.blur()
            this.sizeRestrictNum = obj.sizeRestrictNum ?? 2
          }
          if (obj.source_data == 'sameSizeBoardCount') {
            this.statisticsDimension = obj.statisticsDimension ?? 'noLimit'
          }
          this.nowFontFamily = obj.fontFamily ?? '微软雅黑'
          break
        case 'Graphics':
          this.codeH = obj.mHeight
          this.codeW = obj.mWidth
          this.GraColor = obj.fill
          // 和 moduleq1 相同的问题
          this.$refs['angleRef']?.blur()
          this.angle = obj.angle
          break
        case 'SurplusSize': {
          this.codeW = obj.mWidth
          this.codeH = obj.mHeight
          let SurplusSizeTextItems = obj.getObjects()[1]
          this.nowFontSize = SurplusSizeTextItems.fontPt
          this.fontWeight =
            SurplusSizeTextItems.fontWeight == 'bold' ? true : false
          this.nowFontFamily = SurplusSizeTextItems.fontFamily
          break
        }
        case 'Marking':
        case 'wardrobeNum':
          if (typeof obj.getObjects !== 'function') {
            break
          }
          let cir = obj.getObjects()[0]
          let cirNum = obj.getObjects()[1]
          this.nowDiameter = cir.realRadius ?? cir.mRadius
          this.fontWeight = cirNum.fontWeight == 'bold' ? true : false
          this.nowFontSize = cirNum.fontPt
          if (obj.typeName == 'wardrobeNum') {
            this.partSignValue = obj.field ?? 'wardrobeNum'
            if (this.partSignValue == 'wardrobeNumToRoom') {
              this.roomSortWay = cirNum.roomSortWay
            }
          }
          this.nowFontFamily = cirNum.fontFamily
          break
        case 'holeSlotPicture':
          const auxiliaryItem = obj.auxiliaryEl?.[0]
          const edgeTextItem = obj.partEdgeElList?.[0]
          const textItem = auxiliaryItem ?? edgeTextItem
          if (!auxiliaryItem && !edgeTextItem) {
            break
          }
          this.fontWeight = textItem.fontWeight == 'bold' ? true : false
          this.nowFontSize = textItem.fontPt
          this.plankSize = textItem.isShow
          this.holeF = obj.holeF
          this.holeZ = obj.holeZ
          this.partEdge = obj.partEdge
          this.pictureScale = obj.defaultScale
          this.nowFontFamily = textItem.fontFamily
          break
        case 'sideMachiningSequenceDiagram':
          this.codeW = obj.mWidth || 20
          this.codeH = obj.mHeight || 20
          this.triangleSize = obj.triangleSize
          this.nowFontSize = obj.fontPt || 8
          break
        case 'Table':
          this.nowTableData = obj.source_data
          this.nowFontSize = obj.fontPt
          this.nowFontFamily = obj.fontFamily ?? '微软雅黑'
          break
        case 'smallPlateMarking':
          const rect = obj.getObjects()[0]
          const text = obj.getObjects()[1]
          this.smallPlateW = rect.width
          this.smallPlateH = rect.height
          this.fontWeight = text.fontWeight == 'bold' ? true : false
          this.nowFontSize = text.fontPt
          this.nowFontFamily = text.fontFamily
          break
        case 'sixSideDrillArrow': {
          this.sixSideDrillArrowSize = Math.ceil(obj.width * obj.scaleX)
          break
        }
        case 'EdgeBand':
          this.codeH = obj.mHeight || pxTomm(obj.height, this.arrDPI)
          this.codeW = obj.mWidth || pxTomm(obj.width, this.arrDPI)
          this.stroke = obj.stroke
          break
        case 'VisibleEdge':
          //  纵横方向分别减去 箭头的高度 * 2 - 间距* 2 - 边框* 2  这样换算下来才是对的
          this.triangleSize = Math.floor(obj.triangleSize * obj.scaleX)
          // this.codeW = Math.floor(pxTomm((obj.width - this.triangleSize * 2 - 2 - 2) * obj.scaleX, this.arrDPI))
          // this.codeH = Math.floor(pxTomm((obj.height - this.triangleSize * 2 - 2 - 2) * obj.scaleY, this.arrDPI))
          this.codeW = Math.floor(
            obj.width * obj.scaleX - this.triangleSize * 2 - 2 - 2
          )
          this.codeH = Math.floor(
            obj.height * obj.scaleY - this.triangleSize * 2 - 2 - 2
          )
          break
        case 'FrontEdge':
          this.triangleSize = Math.floor(obj.triangleSize * obj.scaleX)
          this.codeW = Math.floor(
            obj.width * obj.scaleX - this.triangleSize * 2 - 2 - 2
          )
          this.codeH = Math.floor(
            obj.height * obj.scaleY - this.triangleSize * 2 - 2 - 2
          )
          break
        default:
          break
      }
    },
    // 获取元素的一些属性
    getElementInfo(elName, attribute, msg, style = {}) {
      const el = document.createElement(elName)
      el.innerHTML = msg
      document.body.appendChild(el)
      const styles = Object.keys(style)
      if (styles.length) {
        styles.forEach((k) => {
          el.style[k] = style[k]
        })
      }
      const d = el[attribute]
      document.body.removeChild(el)
      return d
    },
    // 注入加工顺序图数字：独立画在画布上，跟随主图移动，不被 Group 缓存裁切
    bindSideDiagramNumberMoveF(klass) {
      const that = this
      const moveF = function (oriKlass) {
        const sx = oriKlass.scaleX || 1
        const sy = oriKlass.scaleY || 1
        const innerLeft = oriKlass.left + (oriKlass.innerOffsetX || 0) * sx
        const innerTop = oriKlass.top + (oriKlass.innerOffsetY || 0) * sy
        const codeWidth = mmToPx(oriKlass.mWidth, that.arrDPI) * sx
        const codeHeight = mmToPx(oriKlass.mHeight, that.arrDPI) * sy
        const slotOutset = (oriKlass.slotOutset || 0) * sy
        const holeWidth = (oriKlass.holeWidth || 0) * sy
        let left = 0
        let top = 0
        switch (this.positionName) {
          case '1':
            left = innerLeft - slotOutset
            top = innerTop + codeHeight / 2 - holeWidth * 2
            break
          case '2':
            left = innerLeft + codeWidth / 2 - holeWidth
            top = innerTop + codeHeight + slotOutset
            break
          case '3':
            left = innerLeft + codeWidth + slotOutset
            top = innerTop + codeHeight / 2 - holeWidth * 2
            break
          case '4':
            left = innerLeft + codeWidth / 2 - holeWidth
            top = innerTop - slotOutset
            break
        }
        this.set({ left, top })
      }
      const fontF = function (font) {
        this.set({ ...font })
      }
      klass.set({
        moveF: moveF.bind(klass),
        fontF: fontF.bind(klass),
      })
    },
    createSideDiagramAuxiliaryNumbers(group, canvasId) {
      const uniqueID = group.uniqueID
      const numberFontPt = Number(group.fontPt) || 8
      const textFontSize = PtToPx(numberFontPt, this.arrDPI)
      const opacity = group.showSideMachiningSequenceNumber ? 1 : 0
      const numberConfigs = [
        { text: '1', positionName: '1', originX: 'right', originY: 'center' },
        { text: '2', positionName: '2', originX: 'center', originY: 'top' },
        { text: '3', positionName: '3', originX: 'left', originY: 'center' },
        { text: '4', positionName: '4', originX: 'center', originY: 'bottom' },
      ]
      const textEls = numberConfigs.map((cfg) => {
        const text = new fabric.Text(cfg.text, {
          fontSize: textFontSize,
          fontPt: numberFontPt,
          originX: cfg.originX,
          originY: cfg.originY,
          selectable: false,
          evented: false,
          hasControls: false,
          opacity,
          typeName: 'sideMachiningSequenceDiagramNumber',
          uniqueID,
          positionName: cfg.positionName,
        })
        this.bindSideDiagramNumberMoveF(text)
        text.moveF(group)
        this[canvasId].add(text)
        return text
      })
      group.set({ auxiliaryEl: textEls })
      return textEls
    },
    // 注入给子级元素的一些方法
    klassSetMethods(klass, attrs) {
      const showF = function (that) {
        this.set({
          isShow: that[attrs.show],
          opacity: Number(that[attrs.show]),
        })
      }
      const fontF = function (font) {
        this.set({ ...font })
      }
      if (klass.positionName) {
        let moveF = null

        moveF = function (oriKlass) {
          const w = mmToPx(oriKlass.mWidth, DPI)
          const h = mmToPx(oriKlass.mHeight, DPI)
          let left = 0
          let top = 0
          switch (klass.positionName) {
            case 'width':
              left = oriKlass.left + w / 2
              top = oriKlass.top + h
              break
            case 'height':
              left = oriKlass.left + w
              top = oriKlass.top + h / 2
              break
            case 'edge1':
              left = oriKlass.left - 5
              top = oriKlass.top + h / 2
              break
            case 'edge2':
              left = oriKlass.left + w / 2
              top = oriKlass.top + h + 10
              break
            case 'edge3':
              left = oriKlass.left + w
              top = oriKlass.top + h / 2 - 10
              break
            case 'edge4':
              left = oriKlass.left + w / 2
              top = oriKlass.top - 10
              break
          }
          this.set({
            left,
            top,
          })
        }
        klass.set({
          moveF: moveF.bind(klass),
        })
      }
      klass.set({
        showF: showF.bind(klass, this),
        fontF: fontF.bind(klass),
      })
    },
    // 绘制板件特殊标识
    drawOrderOrPanel(field, position, from) {
      const {
        radius: pRadius,
        fontSize,
        left,
        top,
        fontWeight,
        fontFamily,
        roomSortWay,
        realRadius: pRealRadius,
      } = position
      const radius = mmToPx(pRadius / 2, this.arrDPI)
      const realRadius = mmToPx(pRealRadius / 2, this.arrDPI)
      let groupArr = []

      const circle = new fabric.Circle({
        radius: radius, //圆形半径
        fill: '#fff', //填充的颜色
        stroke: '#000', // 边框颜色
        strokeWidth: 1, // 边框大小
        mRadius: pRadius,
        originX: 'cneter',
        originY: 'cneter',
        realRadius: pRealRadius,
        left: radius,
        top: radius,
        visible: realRadius > 0,
      })

      groupArr.push(circle)
      let t = ''
      if (from === 'wardrobeNum') {
        // 由于选择了按房间排序后，需要对其余两个字段进行初始化赋值
        if (field === 'wardrobeNum') {
          t = '1'
        } else if (field === 'isFrontPlank') {
          t = '面'
        } else if (field === 'wardrobeNumToRoom') {
          this.roomSortWay = roomSortWay
          if (this.roomSortWay === 'letters') t = 'A-1'
          else t = '1-1'
        }
      } else {
        t = '余'
      }

      const numText = new fabric.IText(t, {
        fontSize: PtToPx(fontSize, this.arrDPI),
        fontPt: fontSize,
        fontWeight: fontWeight ?? '',
        originX: 'cneter',
        originY: 'cneter',
        left: radius,
        top: radius,
        fontFamily: fontFamily,
        roomSortWay: roomSortWay,
      })
      groupArr.push(numText)
      const cirGroup = new fabric.Group(groupArr, {
        left: left,
        top: top,
        typeName: from,
        hasControls: true,
        field,
      })
      if (from === 'wardrobeNum') {
        cirGroup.setControlVisible('mtr', false)
      }
      this.setItemId(cirGroup)
      this.currentItem = cirGroup
      this[this.mycanvasId].add(cirGroup)
      this.getKclassValueToAttr(cirGroup)
      return cirGroup
    },
    // 添加画布的监听
    addFabricCanvasListener() {
      const fabricCreateEl = this[this.mycanvasId].upperCanvasEl
      // 监听鼠标右键
      fabricCreateEl.addEventListener('mousedown', this.listenerContextMenu)
      fabricCreateEl.addEventListener('mouseup', this.listenerFabricMouseUp)
      fabricCreateEl.addEventListener('mousemove', this.listenerFabricMouseMove)
      // 取消默认菜单显示
      fabricCreateEl.addEventListener('contextmenu', (e) => e.preventDefault())
    },
    // 移动fabric画布到中心点
    moveFabricCanvasToCenter() {
      const centerPoint = this[this.mycanvasId].getCenter() // 获取中心坐标
      const { left, top, height, width } = this[this.mycanvasId].getObjects()[0] // getObjects 获取画布上的所有对象
      const cutLeft = centerPoint.left - (left + width / 2)
      const cutTop = centerPoint.top - (top + height / 2)
      this.setFabricTransform(cutLeft, cutTop)
    },
    // 更改fabric画布位置
    setFabricTransform(x, y) {
      const transform = this[this.mycanvasId].viewportTransform.slice()
      transform[4] += x // 水平移动
      transform[5] += y // 垂直移动
      this[this.mycanvasId].setViewportTransform(transform) // 设置画布视口转换
      this[this.mycanvasId].renderAll() // 重新渲染一遍画布，当画布中的对象有变更，在最后显示的时候，需要执行一次该操作
    },

    // 在元素位置生成操作框
    genControlRect(obj) {
      /** 当 ctrl 键位按下时点击元素不需要生成操作框，避免影响其他功能的运行 */
      if (this.keyboard.isCtrlDown) {
        return
      }
      const { width, height, left, top, rectWidth, rectHeight, source_data } =
        obj
      // obj为激活元素
      const ids = this.hasGenControlRectList.map((item) => item.item_id)
      if (!ids.includes(obj.item_id)) {
        const ControlRect = new fabric.Rect({
          width: rectWidth ?? width + 2,
          height: rectHeight ?? height + 2,
          left: left - 1,
          top: top - 1,
          fill: 'transparent',
          stroke: '#b8d0ff',
          source_data,
          typeName: 'controlRect',
          item_id: obj.item_id,
          strokeWidth: 0.5,
        })
        ControlRect.setControlVisible('mtr', false)
        this.hasGenControlRectList.push(obj)
        this.controlRects.push(ControlRect)
        this[this.mycanvasId].add(ControlRect)
        this[this.mycanvasId].setActiveObject(ControlRect)
      }
    },

    // 清除所有的控制框
    clearControlRect() {
      this.hasGenControlRectList = []
      this.currentCanvas.getObjects().forEach((item) => {
        if (isControlRectEl(item)) {
          this.currentCanvas.remove(item)
        }
      })
      this[this.mycanvasId].renderAll()
      this.controlRects = []
    },
    handleChangeDataSourceSize(e) {
      if (e.key === 'Enter') {
        this.currentItem.rectHeight = Number(this.dataSourceHeight)
        this.currentItem.rectWidth = Number(this.dataSourceWidth)
        this.controlRects[0].set({
          width: Number(this.dataSourceWidth),
          height: Number(this.dataSourceHeight),
        })
        this[this.mycanvasId].renderAll()
      }
    },
    handleFocusRectSize() {
      window.removeEventListener('keydown', this.listenerKeydown, false)
    },
    handleBlurRectSize() {
      window.addEventListener('keydown', this.listenerKeydown)
    },
    handleChangeAutoFontSize() {
      const obj = this.currentItem
      if (!obj.text) return
      const { text, fontSize } = dealTextStr(
        obj.text,
        obj.fontSize,
        obj.rectWidth,
        obj.rectHeight,
        this.isAutoFontSize,
        this.lineCount
      )
      obj.text = text
      if (this.isAutoFontSize) {
        obj.fontSize = fontSize
        obj.fontPt = Math.ceil(PxToPt(fontSize))
        this.nowFontSize = Math.ceil(PxToPt(fontSize))
      }
      obj.set({
        isAutoFontSize: this.isAutoFontSize,
      })
      this[this.mycanvasId].renderAll()
    },
    // 统计维度
    handleChangeStatisticsDimension() {
      this.countOldTem() // 保存顺序，序列化，不知道有啥用，先写着
      let current = this.currentItem
      if (current) {
        if (current.source_data == 'sameSizeBoardCount') {
          current.set({
            statisticsDimension: this.statisticsDimension,
          })
        }
      }
    },
    // 根据字体或其他变化改变当前元素内rectWidth/Height值的大小以及控制框的大小
    changeKlassControlRect(klass) {
      if (!klass) return
      let { width, height } = klass
      if (isNaN(width)) return
      width = parseInt(width)
      height = parseInt(height)
      klass.rectWidth = width
      klass.rectHeight = height
      this.controlRects[0]?.set({ width, height })
      this.dataSourceWidth = width
      this.dataSourceHeight = height
    },
    handleChangeQRNCSuffix() {
      this.currentItem.set({
        isQRcodeNCSuffix: this.isQRcodeNCSuffix,
      })
      this[this.mycanvasId].renderAll()
    },
    handleChangeOneNCSuffix() {
      this.currentItem.set({
        isOnecodeNCSuffix: this.isOnecodeNCSuffix,
      })
      this[this.mycanvasId].renderAll()
    },
    handleChangeQRCodeFormat() {
      this.currentItem.set({
        QRCodeFormat: this.QRCodeFormat,
      })
    },
    // 修改按房间排序方式
    handleChangeRoomSort(value) {
      const current = this.currentItem
      current.set({
        field: `wardrobeNumToRoom`,
      })
      const textObj = current.getObjects()[1]
      const currentText = textObj.text
      const wardrobeSort = currentText.split('-')[1]
      // 按字母排序
      if (value === 'letters') {
        textObj.set({
          text: `A-${wardrobeSort}`,
          roomSortWay: value,
        })
      } else {
        textObj.set({
          text: `1-${wardrobeSort}`,
          roomSortWay: value,
        })
      }
      this[this.mycanvasId].renderAll()
    },
    translateLang(key) {
      return translate(key)
    },
    // 数据信息实现模糊搜索
    filterOption(value, option) {
      return option.componentOptions.children[0].text?.includes(value)
    },
    /** 处理其他操作点击 */
    handleOtherClick(operate) {
      const actives = getActiveObjectByNotAssignField(this.currentCanvas)
      // 获取选中元素的边界点
      const points = actives.map((it) => {
        const buound = getElRealRect(it)
        return [
          { x: buound.x || 0, y: buound.y || 0 },
          {
            x: buound.x + buound.width || 0,
            y: buound.y + buound.height || 0,
          },
        ]
      })
      /** 均分公共逻辑 */
      const distributeElements = (
        sortedObjects,
        fixedStart,
        totalSpace,
        getSize,
        posKey
      ) => {
        const totalObjectSize = sortedObjects
          .slice(1, -1) // 中间元素
          .reduce((sum, obj) => sum + getSize(obj), 0)
        const gap = (totalSpace - totalObjectSize) / (sortedObjects.length - 1)
        let currentPos = fixedStart + getSize(sortedObjects[0])
        sortedObjects.slice(1, -1).forEach((obj) => {
          const position = {}
          const { x, y } = getElRealRect(obj)
          const startX = currentPos + gap
          const oriPos = posKey === 'left' ? x : y
          const diffVal = oriPos - startX
          position[posKey] = obj[posKey] - diffVal
          obj.set(position)
          currentPos += getSize(obj) + gap
        })
      }
      const [minx, miny, maxx, maxy] = getPathMinMaxPoint(points.flat(1))
      const center = { x: (maxx + minx) / 2, y: (miny + maxy) / 2 }
      /**
       * 下面的计算为什么会不直接将值等于某一个计算出来的边界，比如左对齐直接=最小 x？
       * 因为 fabric 原点不再中心，然后基于中心旋转之后的 left top 很奇怪，left top 也顺时针旋转了，比如旋转
       * 90° 那么旋转后的左下角点位将替代左上角的点位，所以这里都是基于差值来得到要移动的位置，单是origin 是center 则又不需要处理
       */
      switch (operate.type) {
        case 'leftAlign':
          actives.forEach((it) => {
            const { x } = getElRealRect(it)
            const diffVal = it.left - (x - minx)
            it.set({ left: diffVal })
          })
          break
        case 'rightAlign':
          actives.forEach((it) => {
            const { x, width } = getElRealRect(it)
            const diffVal = it.left - (x + width - maxx)
            it.set({ left: diffVal })
          })
          break
        case 'topAlign':
          actives.forEach((it) => {
            const { y } = getElRealRect(it)
            const diffVal = it.top - (y - miny)
            it.set({ top: diffVal })
          })
          break
        case 'bottomAlign':
          actives.forEach((it) => {
            const { y, height } = getElRealRect(it)
            const diffVal = it.top - (y + height - maxy)
            it.set({ top: diffVal })
          })
          break
        case 'horizontalAlign':
          actives.forEach((it) => {
            const { x, width } = getElRealRect(it)
            const diffVal = it.left - (x + width / 2 - center.x)
            it.set({ left: diffVal })
          })
          break
        case 'verticalAlign':
          actives.forEach((it) => {
            const { y, height } = getElRealRect(it)
            const diffVal = it.top - (y + height / 2 - center.y)
            it.set({ top: diffVal })
          })
          break
        case 'horizontalSplit':
          {
            const sortedObjects = [...actives].sort((a, b) => {
              a = getElRealRect(a)
              b = getElRealRect(b)
              return (a.x || 0) - (b.x || 0)
            })
            const first = getElRealRect(sortedObjects[0])
            const last = getElRealRect(sortedObjects[sortedObjects.length - 1])
            distributeElements(
              sortedObjects,
              first.x,
              last.x - first.x - first.width,
              (obj) => getElRealRect(obj).width,
              'left'
            )
          }
          break
        case 'verticalSplit':
          {
            const sortedObjects = [...actives].sort((a, b) => {
              a = getElRealRect(a)
              b = getElRealRect(b)
              return (a.y || 0) - (b.y || 0)
            })
            const first = getElRealRect(sortedObjects[0])
            const last = getElRealRect(sortedObjects[sortedObjects.length - 1])
            distributeElements(
              sortedObjects,
              first.y,
              last.y - first.y - first.height,
              (obj) => getElRealRect(obj).height,
              'top'
            )
          }
          break
      }
      // 孔槽图需要同步一下移动
      actives.forEach((object) => {
        object.auxiliaryEl?.forEach((klass) => {
          klass.moveF(object)
        })
        object.partEdgeElList?.forEach((klass) => {
          klass.moveF(object)
        })
      })
      // 更新画布
      this.currentCanvas.discardActiveObject()
      this.calcActiveCount(this.currentCanvas)
      this.currentCanvas.renderAll()
    },
    /** 在存储的控制类中找到指定的类 */
    getCurrentUseSelectedControl(canvas) {
      return fabricControlList.find(
        (item) => item.canvas === (canvas || this.currentCanvas)
      )
    },
    /** @desc 创建自定义的 fabric 控制类 */
    createFabricControl(canvas) {
      //  创建 FabricSelectedControl 对象 用于控制 fabric 多选等相关操作
      const fabricControl = new FabricSelectedControl(canvas)
      fabricControl.on('selectedUpdate', (e) => {
        const first = e?.getObjects()?.[0]
        this.nowChooseSet = e.typeName
        this.currentItem = e
        // 记录激活个数
        this.calcActiveCount(canvas)
        // 重置部分数据
        this.codeH = 10
        this.codeW = 10
        this.angle = 0
        this.fontWeight = false
        // this.nowFontSize = ''
        // this.nowFontFamily = '微软雅黑'
        this.showEdgeOff = false
        this.showEdgeDisplay = false
        this.showFrontEdge = true
        this.showVisibleEdge = true
        this.isShowDiffEdgeColor = false
        this.hideSameEdgeColorAsPlank = false
        this.showOpenDoor = false
        this.plankRotate = 0
        this.textAlign = 'left'
        this.QRCodeFormat = 'QRCode'
        this.isQRcodeNCSuffix = true
        this.nowCodeInfo = ''
        this.nowDataInfo = ''
        this.lineSpace = 1
        this.lineCount = ''
        // this.nowTableData = ''
        this.plankSize = false
        this.holeF = false
        this.holeZ = false
        this.partEdge = false
        this.pictureScale = 1
      })
      // 监听选区值的设置，便于单个修改
      fabricControl.on('selectedAttributeUpdate', (objects, options) => {
        Object.keys(options).forEach((k) => {
          switch (k) {
            case 'fontSize':
              objects.forEach((object) =>
                this.handleFontSizeChange(options['fontPt'], object)
              )
              break
            case 'fontWeight':
              objects.forEach((object) => this.changeFontWeight(object))
              break
            case 'fontFamily':
              objects.forEach((object) =>
                this.handleFontFamilyChange(options[k], object)
              )
              break
            default:
              objects.forEach((object) => object.set({ ...options }))
          }
        })
      })
      // 记录创建的控制类
      fabricControlList.push(fabricControl)
      // 移动控制,对目标的移动进行控制
      const fabricMoveingControl = new FabricMovingControl(canvas)
      fabricMovingControlList.push(fabricMoveingControl)
    },
    /** @description 计算活跃元素个数 用于显示对齐功能，但默认限制了部分活跃不计算 */
    calcActiveCount(canvas, cb) {
      cb =
        cb ||
        function (it) {
          return (
            !['holeSlotPicture-size', 'holeSlotPicture-edge'].includes(
              it.typeName
            ) && !isSelectedEl(it)
          )
        }
      const count =
        canvas?.getActiveObjects().filter((it) => cb(it))?.length || 0
      this.activeElementCount = count
    },
    handleSmallPlateSizeChange(type, value) {
      if (type === 'w') {
        this.smallPlateW = value
      } else {
        this.smallPlateH = value
      }
      // // 如果当前是小板标记，实时更新
      if (this.partSignValue === 'smallPlateMarking' && this.currentItem) {
        this.drawSmallPlateMarking(this.currentItem)
      }
    },
    drawSmallPlateMarking(current) {
      // 移除当前
      this[this.mycanvasId].remove(current)
      // 计算位置
      const left = current?.left ?? this.overUpPoint.x
      const top = current?.top ?? this.overUpPoint.y
      const w = this.smallPlateW
      const h = this.smallPlateH
      // 画矩形
      const rect = new fabric.Rect({
        width: w,
        height: h,
        fill: '#fff',
        stroke: '#000',
        strokeWidth: 1,
        left: w / 2,
        top: h / 2,
        originX: 'center',
        originY: 'center',
      })
      // 画文字
      const text = new fabric.Text('小板', {
        fontSize: PtToPx(this.nowFontSize, this.arrDPI),
        fontPt: this.nowFontSize,
        left: w / 2,
        top: h / 2,
        originX: 'center',
        originY: 'center',
        fontFamily: this.nowFontFamily,
        fontWeight: this.fontWeight ? 'bold' : '',
      })
      // group
      const group = new fabric.Group([rect, text], {
        left,
        top,
        typeName: 'smallPlateMarking',
        hasControls: true,
        fontWeight: this.fontWeight ? 'bold' : '',
        fontFamily: this.nowFontFamily,
      })
      this.setItemId(group)
      this.currentItem = group
      this.setControlVisible(group, false, 'mtr')
      this[this.mycanvasId].add(group)
      this.getKclassValueToAttr(group)
    },
    async getTagOpacityPermission() {
      const res = await fetchUserPermission({ permission_type: 'TAG_OPACITY' })
      if (res.status) {
        this.hasOpacityAuth = res.data.enable
      } else {
        this.$message({
          message: res.msg,
          type: 'error',
          duration: 1000,
        })
      }
    },
    getImportTemplateDraft() {
      const importDraftKey = this.$route.query.importDraftKey
      if (!importDraftKey) return null
      try {
        const rawDraft = sessionStorage.getItem(importDraftKey)
        if (!rawDraft) return null
        const draft = JSON.parse(rawDraft)
        if (draft?.type !== 'importTemplateDraft' || !draft?.data) {
          return null
        }
        return draft
      } catch (error) {
        return null
      } finally {
        sessionStorage.removeItem(importDraftKey)
      }
    },
    // 绘制五六面钻放板基准-箭头
    drawSixSideDrillArrow(current) {
      // 获取当前画布实例
      const canvas = this[this.mycanvasId]
      if (!canvas) {
        console.error('画布实例不存在')
        return
      }
      // 移除
      this[this.mycanvasId].remove(current)

      // 获取位置和尺寸信息
      const left = current?.left
      const top = current?.top
      const width = this.sixSideDrillArrowSize
      const height = this.sixSideDrillArrowSize
      // 计算圆形背景的半径（取宽高的较小值的一半）
      const radius = width / 2

      // 创建白色圆形背景 - 使用相对位置
      const circle = new fabric.Circle({
        left: 0, // 相对于组的中心位置
        top: 0, // 相对于组的中心位置
        radius: radius,
        fill: '#ffffff',
        stroke: '#d3d3d3', // 浅灰色边框
        strokeWidth: 1,
        strokeUniform: true, // 关键：保持边框宽度不随缩放变化
        selectable: true,
        hasControls: true,
        originX: 'center',
        originY: 'center',
        // width: width,
        // height: height,
      })

      // 创建等腰三角形 - 底边长是半径的1.6，高是半径的0.8
      const arrow = new fabric.Triangle({
        width: radius * 1.6, // 底边长是半径的1.6倍
        height: radius * 0.8, // 高是半径的0.8倍
        left: 0, // 相对于组的中心位置
        top: -radius * 0.4, // 中心点在圆心
        originX: 'center',
        originY: 'center',
        fill: '#555555', // 深灰色
        stroke: 'transparent',
        selectable: false,
        hasControls: false,
        angle: 0, // 确保三角形朝上
      })

      // 创建矩形 - 使用相对位置
      const rect = new fabric.Rect({
        width: radius * 0.6,
        height: radius * 0.8,
        fill: '#555555', // 深灰色
        strokeWidth: 1,
        strokeUniform: true, // 保持边框宽度不随缩放变化
        left: 0, // 相对于组的中心位置
        top: radius * 0.4 - 1, // 在圆形下方
        originX: 'center',
        originY: 'center',
      })

      // 将圆形和箭头组合成一个组
      const group = new fabric.Group([circle, arrow, rect], {
        left: left, // 组的中心位置
        top: top, // 组的中心位置
        selectable: true,
        hasControls: true,
        typeName: 'sixSideDrillArrow',
        opacity: 1,
        item_id: nanoid(),
        width: width,
        height: height,
      })

      group.setControlVisible('mtr', false) // 隐藏控制点
      // 隐藏上面中间的控制点
      group.setControlVisible('mt', false)
      // 隐藏下面中间的控制点
      group.setControlVisible('mb', false)
      // 隐藏左边中间的控制点
      group.setControlVisible('ml', false)
      // 隐藏右边中间的控制点
      group.setControlVisible('mr', false)
      // 添加到画布
      canvas.add(group)
      canvas.setActiveObject(group)
      canvas.renderAll()
      // 设置当前选中项
      this.currentItem = group
      this.getKclassValueToAttr(group)
    },
    /**
     * 绘制五六面钻放板基准三角形
     * @param {Object} current - 当前要移除的元素
     * @param {boolean} skipSelection - 是否跳过选中和属性设置，默认为 false
     */
    drawSixSideDrillTriangle(current, skipSelection = false) {
      this[this.mycanvasId].remove(current)
      const left = this.rectData.left
      const top = this.rectData.top + this.tagSizeHPx - 20
      // 基于left和top绘制矩形
      const rect1 = new fabric.Rect({
        width: 5,
        height: 20,
        fill: '#000',
        stroke: '#000',
        left: left,
        top: top - 15,
      })
      const rect2 = new fabric.Rect({
        width: 15,
        height: 5,
        fill: '#000',
        stroke: '#000',
        left: left + 5,
        top: top,
      })
      const group = new fabric.Group([rect1, rect2], {
        left: left,
        top: top,
        item_id: nanoid(),
        typeName: 'sixSideDrillTriangle',
        selectable: true, // 允许选中
        evented: true, // 允许事件响应
        hasControls: false, // 隐藏控制点
        hasBorders: false, // 隐藏边框
        lockMovementX: true, // 锁定X轴移动
        lockMovementY: true, // 锁定Y轴移动
        lockRotation: true, // 锁定旋转
        lockScalingX: true, // 锁定X轴缩放
        lockScalingY: true, // 锁定Y轴缩放
        lockSkewingX: true, // 锁定X轴倾斜
        lockSkewingY: true, // 锁定Y轴倾斜
      })
      this[this.mycanvasId].add(group)
      if (!skipSelection) {
        this[this.mycanvasId].setActiveObject(group)
        this.getKclassValueToAttr(group)
        this[this.mycanvasId].renderAll()
        this.currentItem = group
      }
    },
    // 五六面钻放板基准图形样式
    handleSixSideDrillPlankBaseGraphChange(value, currentItem) {
      if (value == 'arrow') {
        this.drawSixSideDrillArrow(currentItem)
      } else {
        this.drawSixSideDrillTriangle(currentItem)
      }
      // 埋点记录
      buryPointApi('tag', 'graph_style')
    },
    // 五六面钻放板基准图像尺寸
    handleSixSideDrillPlankBaseSizeChange(type, value) {
      if (
        this.partSignValue === 'sixSideDrillPlankBase' &&
        this.currentItem &&
        this.sixSideDrillPlankBaseGraph === 'arrow'
      ) {
        this.drawSixSideDrillArrow(this.currentItem)
      }
    },
    dealSurplusDataToSurplusWasteData(data) {
      return data.filter((item) => {
        const { type, data } = item
        if (!wasteSurplusTemSetData.find((it) => it.type === type)) return false
        if (type === 'DataSource') {
          if (
            !wasteSurplusDataSource.find((it) => it.value === data.source_data)
          )
            return false
        } else if (type === 'QRcode') {
          if (
            !this.dataSources.wasteSurplusCodeList.find(
              (it) => it.value === data.source_data
            )
          )
            return false
        }
        return true
      })
    },
    /** 标签名称变化限制不能输入特殊字符 */
    handleTagNameChange(e) {
      const value = e.target.value
      this.tagName = value.replace(REGEXP_REPLACE_FILE_NAME, '')
    },
  },
  async created() {
    // 从接口获取小板的数据信息
    const { data: res } = await getLabelInfo()
    if (res.status) {
      this.dataSources.fieldData = res.data.map((item) => {
        item.text = item.sample
        return item
      })
    }
    this.getTagOpacityPermission()
  },
  async mounted() {
    // 非老板良定制用户没有包数选项
    if (!needApartPackUser.includes(this.$store.state.userInfo.phone)) {
      if (this.dataSources.fieldData && this.dataSources.fieldData.length) {
        const packageCountIdx = this.dataSources.fieldData.findIndex(
          (it) => it.value === 'packageCount'
        )
        // 删除包数选项
        if (packageCountIdx !== -1) {
          this.dataSources.fieldData.splice(packageCountIdx, 1)
        }
      }
    }
    if (sessionStorage.getItem('thinkerx_material')) {
      this.thinkerxMaterial = true
    }

    this.arrDPI = getDeviceXDPI()
    let tagId = this.$route.query.id
    const importDraft = this.getImportTemplateDraft()
    let source = null
    // 小板副标签模板数据
    let subSource = []
    // 裁剪板余料标签数据
    let surplusSource = null
    // 废料余料标签数据
    let wasteSource = null
    if (importDraft) {
      let data = importDraft.data
      this.rectData = data.rectInfo
      if (typeof importDraft?.permissions?.hasOpacityAuth === 'boolean') {
        this.hasOpacityAuth = importDraft.permissions.hasOpacityAuth
      }
      data.tem_data.forEach((item) => {
        if (item.data && item.data.source_data == 'oSize') {
          item.data = { ...item.data, text: '2440X1220X18' }
        }
        if (item.data && item.data.source_data == 'plankSize') {
          item.data = { ...item.data, text: '2440X1220X18' }
        }
        item.data.opacity = item.data.opacity ?? 1
      })
      if (!data.surplus_data) {
        data.surplus_data = JSON.parse(defaultTagData).surplus_tem_data
      }
      data.surplus_data.forEach((item) => {
        if (item.data && item.data.source_data == 'oSize') {
          item.data = { ...item.data, text: '2440X1220X18' }
        }
        if (item.data && item.data.source_data == 'plankSize') {
          item.data = { ...item.data, text: '2440X1220X18' }
        }
      })
      if (!data.surplus_waste_data) {
        data.surplus_waste_data = this.dealSurplusDataToSurplusWasteData(
          data.surplus_data
        )
      }
      data.surplus_waste_data.forEach((item) => {
        if (item.data && item.data.source_data == 'oSize') {
          item.data = { ...item.data, text: '2440X1220X18' }
        }
        if (item.data && item.data.source_data == 'plankSize') {
          item.data = { ...item.data, text: '2440X1220X18' }
        }
      })
      source = data.tem_data
      surplusSource = data.surplus_data
      wasteSource = data.surplus_waste_data
      subSource = resolveSubTagTemData(data.sub_tem_data)
      this.enable_sub = !!data.enable_sub
      this.initialEnableSub = this.enable_sub
      this.tagName = importDraft.name || '导入模板'
      this.tagSizeWmm = data.tag_width
      this.tagSizeHmm = data.tag_height
      this.saveCanvas = cloneDeep(data)
      this.saveCanvas.name = this.tagName
      this.tagId = 0
      if (importDraft.missingFeatures?.length) {
        this.importPermissionHintText = `导入模板中已关闭以下无权限功能：${importDraft.missingFeatures.join(
          '、'
        )}`
      }
    } else if (tagId) {
      await this.$getByToken('/load_tag_setting', { id: tagId }, (res) => {
        if (res.status == 1) {
          let data = res.data.data
          this.rectData = data.rectInfo
          this.hasOpacityAuth = res.data.has_opacity_auth
          // 小板标签模板
          data.tem_data.forEach((item) => {
            if (!item.data) {
              return
            }
            if (item.data && item.data.source_data == 'oSize') {
              item.data = { ...item.data, text: '2440X1220X18' }
            }
            if (item.data && item.data.source_data == 'plankSize') {
              item.data = { ...item.data, text: '2440X1220X18' }
            }
            item.data.opacity = item.data.opacity ?? 1
          })
          // 余料标签模板
          if (!data.surplus_data) {
            data.surplus_data = JSON.parse(defaultTagData).surplus_tem_data
          }

          data.surplus_data.forEach((item) => {
            if (item.data && item.data.source_data == 'oSize') {
              item.data = { ...item.data, text: '2440X1220X18' }
            }
            if (item.data && item.data.source_data == 'plankSize') {
              item.data = { ...item.data, text: '2440X1220X18' }
            }
          })
          // 废料标签模板
          if (!data.surplus_waste_data) {
            data.surplus_waste_data = this.dealSurplusDataToSurplusWasteData(
              data.surplus_data
            )
          }

          data.surplus_waste_data.forEach((item) => {
            if (item.data && item.data.source_data == 'oSize') {
              item.data = { ...item.data, text: '2440X1220X18' }
            }
            if (item.data && item.data.source_data == 'plankSize') {
              item.data = { ...item.data, text: '2440X1220X18' }
            }
          })
          source = data.tem_data
          surplusSource = data.surplus_data
          wasteSource = data.surplus_waste_data
          subSource = resolveSubTagTemData(data.sub_tem_data)
          this.enable_sub = !!data.enable_sub
          this.initialEnableSub = this.enable_sub
          this.tagName = res.data.name
          this.tagSizeWmm = data.tag_width
          this.tagSizeHmm = data.tag_height
          this.saveCanvas = data
          this.saveCanvas.name = res.data.name
        } else {
          source = null
          surplusSource = null
          subSource = []
        }
      })
      this.tagId = tagId ? tagId : 0
    } else {
      let data = JSON.parse(defaultTagData)
      this.rectData = data.rectInfo
      // 获取小板标签模板的默认数据
      source = data.tem_data
      // 获取余料标签模板的默认数据
      surplusSource = data.surplus_tem_data
      wasteSource = data.surplus_waste_data
      subSource = resolveSubTagTemData(data.sub_tem_data)
      this.enable_sub = !!data.enable_sub
      this.initialEnableSub = this.enable_sub
      this.tagName = '自定义标签'
      this.tagSizeWmm = data.tag_width
      this.tagSizeHmm = data.tag_height
      this.saveCanvas = data
      this.saveCanvas.name = '自定义标签'
    }

    window.addEventListener('mousedown', this.listenerMousedown)
    window.addEventListener('mousemove', this.listenerMousemove)
    window.addEventListener('mouseup', this.listenerMouseup)
    // 禁止滚轮默认事件
    window.addEventListener('mousewheel', this.listenerMousewheel, {
      passive: false,
    })
    // 进入的时求返候就根据请回的数据源进行绘制
    // 需要绘制小板标签模板和余料标签模板两种数据 需要先绘制余料标签，保证此时的this.mycanvasId的值
    // 余料标签模板
    // this.draw(surplusSource, false, 'mycanvas_surplus')
    await escapeTemplate({
      tem_data: source,
      surplus_data: surplusSource,
      surplus_waste_data: wasteSource,
    })
    this.draw(surplusSource, false, 'mycanvas_surplus_cut')
    this.draw(wasteSource, false, 'mycanvas_surplus_waste')
    // 小板副标签模板（需在主标签前初始化，避免切换时报 null）
    this.draw(subSource, false, 'mycanvas_sub_tag')
    // 小板标签模板
    this.draw(source, false, 'mycanvas_tag')
    this.mycanvasId = 'mycanvas_tag'
    this.mainTemplates = 'main'
    // 存一份小板标签模板
    this.oriTempData = window.$copy(source)
    if (this.importPermissionHintText) {
      this.$message.warning(this.importPermissionHintText)
    }
    let that = this
    window.addEventListener('keydown', this.listenerKeydown)
    window.addEventListener('keyup', (e) => {
      if (e.keyCode == 17) {
        this.mouse_wheel = false
        this.keyboard.isCtrlDown = false
        this.getCurrentUseSelectedControl()?.current.currentSelected?.set({
          evented: true,
          selectable: true,
        })
        /** 改变内部按键状态 */
        fabricMovingControlList.forEach((item) => {
          item.keyboardStatusChange('ctrl', false)
        })
      }
    })
    // 循环
    for (let i = 0; i < canvasIdList.length; i++) {
      let mycanvas = this[canvasIdList[i]]
      if (!mycanvas) continue
      this.createFabricControl(mycanvas)
      let isMove = false
      let point = {
        x: mycanvas.width / 2,
        y: mycanvas.height / 2,
      }
      this.canvasZoomPoint = point
      mycanvas.zoomToPoint(point, this.zoomNum)
      mycanvas.on({
        'mouse:wheel': (e) => {
          if (that.mouse_wheel) {
            var zoom = (event.deltaY > 0 ? -0.1 : 0.1) + mycanvas.getZoom()
            zoom = Math.max(0.1, zoom) //最小为原来的1/10
            zoom = Math.min(3, zoom) //最大是原来的3倍
            var zoomPoint = new fabric.Point(e.pointer.x, e.pointer.y)
            that.zoomNum = Number(zoom.toFixed(2))
            mycanvas.zoomToPoint(zoomPoint, zoom)
          }
        },
        'mouse:move': (e) => {
          if (e.target) {
            this.isDraw = true // 是否可以绘制，只有点击标签数据栏拖动才能绘制
            this.nowETarget = e.target
            this.overUpPoint = e.absolutePointer
            if (isMove) {
              this.countOldTem()
              isMove = false
            }
            if (
              this.nowETarget.source_data == 'plankSignBox' &&
              this.plankSignBox.length
            ) {
              let sign = this.plankSignBox.find(
                (item) => item.item_id == this.nowETarget.item_id
              )
              sign.left = this.nowETarget.left + pxTomm(30, this.arrDPI) / 2
              sign.top = this.nowETarget.top + pxTomm(30, this.arrDPI) / 2
              this[canvasIdList[i]].renderAll()
            }
            // 在 ctrl 按下以及鼠标未按下的时候都不触发
            if (
              e.target.typeName &&
              e.target.typeName == 'controlRect' &&
              !this.keyboard.isCtrlDown
            ) {
              let obj = this.hasGenControlRectList.find(
                (item) => item.item_id == e.target.item_id
              )
              obj?.set({
                top: e.target.top + 1,
                left: e.target.left + 1,
              })
              this[canvasIdList[i]].bringToFront(obj)
              const w = e.target.width * e.target.scaleX
              const h = e.target.height * e.target.scaleY
              e.target.set({
                width: w,
                height: h,
                scaleX: 1,
                scaleY: 1,
              })

              // 是否为缩放操作
              if (e.transform && e.transform.action.includes('scale')) {
                obj.rectWidth = w // 外框宽度
                obj.rectHeight = h // 外框高度
                const { text, fontSize } = dealTextStr(
                  obj.text,
                  obj.fontSize,
                  obj.rectWidth,
                  obj.rectHeight,
                  obj.isAutoFontSize ?? this.isAutoFontSize,
                  obj.lineCount ?? ''
                )
                obj.text = text
                if (obj.isAutoFontSize) {
                  obj.fontSize = fontSize
                  obj.fontPt = Math.ceil(PxToPt(fontSize))
                  this.nowFontSize = Math.ceil(PxToPt(fontSize))
                }
              }
              obj?.setCoords()
              this.currentItem = obj
              this[canvasIdList[i]].renderAll()
            }
            if (
              e.target.typeName &&
              ['DataSource'].includes(e.target.typeName) &&
              this.currentItem
            ) {
              let obj = this.controlRects.find(
                (item) => item.item_id == e.target.item_id
              )
              if (obj) {
                obj.set({
                  top: e.target.top - 1,
                  left: e.target.left - 1,
                })
                this[canvasIdList[i]].renderAll()
              }
              // 不懂！
              // e.target.set({
              //   left: e.target.left,
              //   top: e.target.top,
              // })
            }
            if (
              e.target.typeName &&
              e.target.typeName == 'Onecode' &&
              e.transform &&
              e.transform.action.includes('scale')
            ) {
              const w = e.target.width * e.target.scaleX
              const h = e.target.height * e.target.scaleY
              e.target.set({
                mWidth: pxTomm(w, this.arrDPI),
                mHeight: pxTomm(h, this.arrDPI),
                Xscale: e.target.scaleX,
                Yscale: e.target.scaleY,
              })
              this[canvasIdList[i]].renderAll()
            }
            if (
              e.target.typeName &&
              e.target.typeName == 'sixSideDrillArrow' &&
              e.transform &&
              e.transform.action.includes('scale')
            ) {
              this.sixSideDrillArrowSize = Math.ceil(
                e.target.width * e.target.scaleX
              )
            }
            if (
              this.nowETarget.typeName == 'holeSlotPicture' ||
              this.nowETarget.typeName == 'sideMachiningSequenceDiagram'
            ) {
              const current = this.nowETarget
              current.auxiliaryEl?.forEach((klass) => {
                klass.moveF(current)
              })
              current.partEdgeElList?.forEach((klass) => {
                klass.moveF(current)
              })
            }
          } else {
            this.isDraw = false
          }
        },
        'mouse:up': (e) => {
          if (e.target) {
            this[canvasIdList[i]].renderAll()
            if (e.target.typeName == 'Onecode') {
              this.codeH = e.target.mHeight
              this.codeW = e.target.mWidth
            }
            if (
              e.target.typeName == 'VisibleEdge' ||
              e.target.typeName == 'FrontEdge'
            ) {
              this.triangleSize = Math.floor(
                e.target.triangleSize * e.target.scaleX
              )
              // this.codeH = Math.floor(pxTomm((e.target.height - this.triangleSize * 2 - 2 - 2) * e.target.scaleY, this.arrDPI))
              // this.codeW = Math.floor(pxTomm((e.target.width - this.triangleSize * 2 - 2 - 2) * e.target.scaleX, this.arrDPI))
              this.codeW = Math.floor(
                e.target.width * e.target.scaleX - this.triangleSize * 2 - 2 - 2
              )
              this.codeH = Math.floor(
                e.target.height * e.target.scaleY -
                  this.triangleSize * 2 -
                  2 -
                  2
              )
              this.visibleEdgeOrFrontEdgeStyle =
                e.target.visibleEdgeOrFrontEdgeStyle
              this.visibleEdgeOrFrontEdge = e.target.typeName
            }
            if (e.target.typeName == 'sixSideDrillArrow') {
              this.sixSideDrillArrowSize = Math.ceil(
                e.target.width * e.target.scaleX
              )
            }
          }
          isMove = false
          const page = this[canvasIdList[i]]
            .getObjects()
            .find((item) => item.typeName == 'TageBox')
          this[canvasIdList[i]].sendToBack(page)
          this[canvasIdList[i]].renderAll()
          if (e.target && e.target.typeName == 'controlRect') {
            this.dataSourceWidth = e.target.width.toFixed(2)
            this.dataSourceHeight = e.target.height.toFixed(2)
          }
          /** 多选控制 */
          if (this.keyboard.isCtrlDown && e.button === 1) {
            this.getCurrentUseSelectedControl()?.addObjectToSelected(e.target)
          }
        },
        'mouse:dblclick': (e) => {
          this.calcActiveCount(this.currentCanvas)
          if (e.target && e.target.typeName == 'TageBox' && !this.isAllSelect) {
            this[canvasIdList[i]].discardActiveObject()
            var sel = new fabric.ActiveSelection(
              this[canvasIdList[i]]
                .getObjects()
                .filter((it) => !['TageBox'].includes(it.typeName)),
              {
                canvas: this[canvasIdList[i]],
              }
            )
            this[canvasIdList[i]].setActiveObject(sel)
            sel.set({
              hasControls: false,
            })
            this.currentCanvas.requestRenderAll()
            this.isAllSelect = true
          } else if (!e.target) {
            this.currentCanvas.discardActiveObject()
            this.currentCanvas.requestRenderAll()
            this.isAllSelect = false
          } else if (e.target.typeName == 'DataSource') {
            this.$message({
              type: 'warning',
              message: '请在右侧属性栏选择数据信息',
              duration: 1500,
              offset: 100,
            })
          }
        },
        'mouse:down': (e) => {
          this.calcActiveCount(this.currentCanvas)
          this.mouseInCanvas = true
          this.isDraw = false
          if (e.target) {
            // 这里加的原因是，在切换选中元素的时候，input-numver组件会触发一次onblur事件，又因为用的都是同一个组件爱你，所以，他们新的元素的值会被修改。
            this.$refs['lintCountRef']?.blur()
            isMove = true
            let obj = e.target
            let active = mycanvas.getActiveObject() // 获取画布上的活动对象
            if (active) {
              this.isShowReset = e.target.source_data != 'plank_remarks'
              // this.mouse_wheel ? this.currentDelList.push(active) : []
              if (active.source_data == 'plankSignBox') {
                let sign = this.plankSignBox.find(
                  (item) => item.item_id == active.item_id
                )
                active = sign
                obj = sign
              }
              if (active.typeName == 'controlRect') {
                this.currentItem = this.hasGenControlRectList.find(
                  (item) => item.item_id == active.item_id
                )
                if (this.currentItem) {
                  this.dataSourceWidth = this.currentItem.rectWidth
                    ? Number(this.currentItem.rectWidth).toFixed(2)
                    : (this.currentItem.width + 2).toFixed(2)
                  this.dataSourceHeight = this.currentItem.rectHeight
                    ? Number(this.currentItem.rectHeight).toFixed(2)
                    : (this.currentItem.height + 2).toFixed(2)
                }
              } else {
                this.clearControlRect()
                this.itemOpacity = active._afterOpacity ?? active.opacity
                this.currentItem = active
              }
              if (['DataSource'].includes(e.target.typeName) && e.target) {
                this.isAutoFontSize = e.target.isAutoFontSize ?? true
                this.lineCount = e.target.lineCount ?? ''
                this.dataSourceWidth = e.target.rectWidth
                  ? Number(e.target.rectWidth).toFixed(2)
                  : (e.target.width + 2).toFixed(2)
                this.dataSourceHeight = e.target.rectHeight
                  ? Number(e.target.rectHeight).toFixed(2)
                  : (e.target.height + 2).toFixed(2)
                this.isAutoFontSize = e.target.isAutoFontSize ?? true
                this.clearControlRect()
                this.genControlRect(e.target)
              }
              if (e.target.typeName == 'Onecode') {
                this.codeH = e.target.mHeight
                this.codeW = e.target.mWidth
                this.codeRotateDeg = e.target.rotateDeg ?? 0
              }
              if (e.target.typeName == 'sixSideDrillArrow') {
                this.sixSideDrillArrowSize = Math.ceil(
                  e.target.width * e.target.scaleX
                )
              }
              if (e.target.typeName == 'Typography') {
                this.rotateDeg = e.target.rotateDeg ?? 0
              }

              if (e.target.typeName === 'specialMark') {
                // 需要使用存储的透明度，因为在元素点击之前就会将透明度设置为 0 以便完成吸附等操作
                this.inputOpacity = e.target._afterOpacity
                this.partSignValue = 'specialMark'
              }
              if (e.target.typeName === 'smallPlateMarking') {
                this.partSignValue = e.target.typeName
              }
              if (
                e.target.typeName === 'sixSideDrillArrow' ||
                e.target.typeName === 'sixSideDrillTriangle'
              ) {
                this.partSignValue = 'sixSideDrillPlankBase'
              }
              if (e.target.typeName === 'sixSideDrillArrow') {
                this.sixSideDrillPlankBaseGraph = 'arrow'
              }
              if (e.target.typeName === 'sixSideDrillTriangle') {
                this.sixSideDrillPlankBaseGraph = 'triangle'
              }
              if (e.target.typeName === 'sideMachiningSequenceDiagram') {
                this.holeSlotPictureDataInfo = 'sideMachiningSequenceDiagram'
                this.isShowSideMachiningSequenceDiagramBorder =
                  e.target.showSideMachiningSequenceDiagramBorder
                this.isShowSideMachiningSequenceNumber =
                  e.target.showSideMachiningSequenceNumber
                this.isFlipOverProcessing = e.target.flipOverProcessing
                this.nowFontSize = e.target.fontPt || 8
              }
              if (e.target.typeName === 'holeSlotPicture') {
                this.holeSlotPictureDataInfo = 'holeSlotPicture'
              }
              if (!this.mouse_wheel) {
                this.getKclassValueToAttr(this.currentItem)
              }
            } else {
              this.currentItem = null
            }
          } else {
            this.isAllSelect = false
          }
          if (!e.target || !e.target.item_id) {
            this.clearControlRect()
          }
        },
        'object:scaling': (e) => {
          // 记录是否在拖拽元素角标
          this.isObjectScaling = true
        },
        'object:modified': async (e) => {
          if (!e.target) return
          const { target } = e
          if (this.isObjectScaling) {
            const rectFields = [
              'Typography',
              'holeSlotPicture',
              'QRcode',
              'smallPlateMarking',
            ]
            const circleFields = ['wardrobeNum']
            const smallPlateMarkingFields = ['smallPlateMarking']
            const type = target.typeName
            if (type === 'sideMachiningSequenceDiagram') {
              target.auxiliaryEl?.forEach((klass) => {
                klass.moveF(target)
              })
              this.$nextTick(() => {
                this.currentCanvas.renderAll()
              })
            }
            if (!rectFields.includes(type) && !circleFields.includes(type))
              return
            const isRect = rectFields.includes(type)
            const isCircle = circleFields.includes(type)
            const isSmallPlateMarking = smallPlateMarkingFields.includes(type)
            if (isRect) {
              const width = target.width * target.scaleX
              const height = target.height * target.scaleY
              target.set({
                mWidth: pxTomm(width, this.arrDPI),
                mHeight: pxTomm(height, this.arrDPI),
              })
            }
            if (isSmallPlateMarking) {
              const rect = target.getObjects()[0]
              const text = target.getObjects()[1]

              rect.set({
                width: toDecimal(rect.width * target.scaleX, 0),
                height: toDecimal(rect.height * target.scaleY, 0),
                scaleX: 1,
                scaleY: 1,
              })
              text.set({
                scaleX: 1,
                scaleY: 1,
              })
              target.set({
                scaleX: 1,
                scaleY: 1,
              })
              // 更新 group 边界
              target?.addWithUpdate?.()
            }
            if (isCircle) {
              if (type === 'wardrobeNum') {
                const objects = target.getObjects()
                const circle = objects[0]
                // 计算缩放后的新半径
                const newRadius = circle.radius * target.scaleX
                // 应用到 circle 的实际 radius
                circle.set({
                  radius: newRadius,
                  mRadius: pxTomm(newRadius * 2, this.arrDPI),
                  realRadius: pxTomm(newRadius * 2, this.arrDPI),
                })
                // 重置 group 的 scale 为 1
                target.set({
                  scaleX: 1,
                  scaleY: 1,
                })
              }
              // 更新 group 边界
              target?.addWithUpdate?.()
            }
            if (type === 'holeSlotPicture') {
              target.auxiliaryEl?.forEach((klass) => {
                klass.moveF(target)
              })
              target.partEdgeElList?.forEach((klass) => {
                klass.moveF(target)
              })
              this.$nextTick(() => {
                this.currentCanvas.renderAll()
              })
            }
            target?.setCoords?.()
            this.getKclassValueToAttr(target)
          }
          this.isObjectScaling = false
        },
      })
    }
  },

  destroyed() {
    window.removeEventListener('mousedown', this.listenerMousedown, false)
    window.removeEventListener('mousemove', this.listenerMousemove, false)
    window.removeEventListener('mouseup', this.listenerMouseup, false)
    window.removeEventListener('keydown', this.listenerKeydown, false)
    window.removeEventListener('mousewheel', this.listenerMousewheel, false)
    canvasIdList.forEach((id) => {
      const canvas = this[id]
      if (!canvas) return
      canvas.off()
      this.getCurrentUseSelectedControl(canvas)?.removeAll()
    })
    // 清除控制器的引用
    fabricControlList.length = 0
    fabricMovingControlList.length = 0
  },
  computed: {
    ...mapState(['thinkerxMaterialKeys']),
    /** 是否有小板副标签权限 */
    hasSecondaryLabelPermission() {
      return (
        checkUserPermissions([USER_PERMISSION_KEY.SECONDARY_LABEL]) === true
      )
    },
    isWebToQt() {
      return Boolean(window.webToQt)
    },
    /** 用于圆形外圈半径计算 */
    drawDiameter() {
      return this.nowDiameter >= 4 ? this.nowDiameter : 4
    },
    /** 返回当前使用的 fabric canvas 对象 */
    currentCanvas() {
      return this[this.mycanvasId]
    },
    menuStyle() {
      return 'display:flex;justify-content: space-between;padding:9px 0;width:180px;border-bottom:1px solid #E5E5E5;'
    },
    btnStyle() {
      return 'display:inline-lock;padding:0 3px;border:1px solid #DDDDDD;border-radius: 2px; font-size:12px'
    },
    // 计算放大倍数
    calcZoom() {
      return ((this.zoomNum / 1) * 100).toFixed(0) + '%'
    },
    attItemShow() {
      const currentArr = [...new Set(this.nowChooseSet.split(','))]
      return (data) => {
        // 始终求交集
        const dataKeys = data.split(',')
        const result = currentArr.every((k) => dataKeys.includes(k))
        return result
      }
    },
    nowDataSources() {
      // 需要判断数据是小板标签模板还是余料标签模板
      if (this.nowChooseSet == 'DataSource' && this.labelTemplates == 'plank') {
        let arr = [...this.dataSources.fieldData, ...this.thinkerxMaterialKeys]
        arr = Object.values(
          arr.reduce((obj, item) => ({ ...obj, [item.value]: item }), {})
        )
        arr = arr.map((item) => {
          if (item.value == 'plankSize') {
            return { ...item, text: '2440*1220*18' }
          } else return item
        })
        return arr
      } else if (
        this.nowChooseSet == 'DataSource' &&
        this.labelTemplates == 'surplus' &&
        this.surplusTemplates == 'cut'
      ) {
        // 余料标签数据的处理
        return this.dataSources.cutSurplusDataSource
      } else if (
        this.nowChooseSet == 'DataSource' &&
        this.labelTemplates == 'surplus' &&
        this.surplusTemplates == 'waste'
      ) {
        // 废料余料标签数据的处理
        return this.dataSources.wasteSurplusDataSource
      } else if (
        this.nowChooseSet == 'QRcode' &&
        this.labelTemplates == 'plank'
      ) {
        // 判断当前是否是从老板良跳过来的
        if (window.sessionStorage.getItem('thinkerx_material')) {
          return [
            ...this.dataSources.codeData,
            ...this.dataSources.lblSpecialCodeData,
            ...(this.thinkerxMaterialKeys ?? []),
          ]
        }
        return this.dataSources.codeData
      } else if (
        this.nowChooseSet == 'QRcode' &&
        this.labelTemplates == 'surplus' &&
        this.surplusTemplates == 'cut'
      ) {
        return this.dataSources.cutSurplusCodeList
      } else if (
        this.nowChooseSet == 'QRcode' &&
        this.labelTemplates == 'surplus' &&
        this.surplusTemplates == 'waste'
      ) {
        return this.dataSources.wasteSurplusCodeList
      } else if (
        this.nowChooseSet == 'Onecode' &&
        this.labelTemplates == 'plank'
      ) {
        return this.dataSources.onCodeData
      } else if (
        this.nowChooseSet == 'Onecode' &&
        this.labelTemplates == 'surplus'
      ) {
        return this.dataSources.suplusOnCodeList
      } else {
        return ''
      }
    },
    // 需要判断当前所在的标签模板
    groupDataSource() {
      let bluenDataList =
        this.labelTemplates == 'plank'
          ? this.dataSources.fieldData
          : this.surplusTemplates == 'cut'
          ? this.dataSources.cutSurplusDataSource
          : this.dataSources.wasteSurplusDataSource
      let thirdDataList = this.thinkerxMaterialKeys

      if (bluenDataList) {
        const locSizeIndex = bluenDataList.findIndex(
          (item) => item.value == 'loc_size'
        )
        if (locSizeIndex !== -1) {
          const locIndex = bluenDataList.findIndex(
            (item) => item.value == 'loc'
          )
          const locSizeItem = bluenDataList[locSizeIndex]
          bluenDataList.splice(locSizeIndex, 1)
          bluenDataList.splice(locIndex + 1, 0, locSizeItem)
        }
      }
      let arr = [
        {
          label: '云排版数据',
          options: bluenDataList,
        },
      ]
      if (thirdDataList.length && this.labelTemplates == 'plank') {
        arr.push({
          label: '第三方数据',
          options: thirdDataList,
        })
      }
      return arr
    },

    // 设置模板数据（左侧可拖动工具栏，小板主/副标签共用）
    templateData() {
      return this.labelTemplates == 'plank'
        ? partTemSetData
        : this.surplusTemplates == 'cut'
        ? cutSurplusTemSetData
        : this.surplusTemplates == 'waste'
        ? wasteSurplusTemSetData
        : ''
    },
  },
}
</script>

<style lang="less">
//at.alicdn.com/t/font_2721570_5lfysiyv55s.css
.edit_tagTem_wapper {
  min-height: calc(100vh - 60px);

  .topBtn {
    display: flex;

    > div {
      width: 110px;
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      background: #fafafa;
      border: 1px solid #dddddd;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-left: 8px;

      > span {
        display: inline-block;
        margin-left: 4px;
      }

      &.funBtn {
        &:hover {
          border: 1px solid #18a8c7;
          color: #18a8c7;
        }
      }

      &.save {
        background-color: #18a8c7;
        color: #fff;
        border: 1px solid #18a8c7;
      }
    }
  }

  .com_content {
    // margin-top: 30px;
    display: flex;
    width: 100%;
    position: relative;

    .classTitle {
      display: flex;
      align-items: center;

      .title {
        display: inline-block;
        margin-right: 5px;
        font-size: 14px;
      }

      .dian {
        display: inline-block;
        margin-right: 10px;
        width: 6px;
        background-color: #999;
        width: 6px;
        height: 6px;
        border-radius: 50%;
      }

      font-weight: bold;
      color: #999;
    }

    .hint {
      padding: 0 0 14px;
      color: #999999;
    }

    .edit_tagTem_left {
      width: 316px;
      height: calc(100vh - 172px);
      padding: 10px 10px 20px 24px;
      background-color: #fff;
      font-size: 14px;

      .temp-switch {
        line-height: 36px;
        justify-content: space-around;
        margin-bottom: 10px;

        .tab-nav {
          width: 50%;
        }

        // 选中背景颜色
        .tab-background {
          background-color: #eee;
        }
      }

      > div {
        user-select: none;

        &.tagTemBox_info {
          > div {
            display: flex;
            align-items: center;
            padding: 10px 0;

            &.tagTem_size {
            }
          }
        }

        &.tagTem_set {
          .tagTem_setItem_list {
            display: flex;
            // justify-content: space-between;
            flex-wrap: wrap;

            .img-class {
              width: 16px;
              height: 16px;
            }

            .color-cover {
              filter: drop-shadow(10, 10, #fff);
            }

            > div {
              margin-bottom: 20px;
              width: 120px;
              display: flex;
              // flex-flow: column;
              background-color: #f6f6f6;
              align-items: center;
              padding: 10px 0px 10px 24px;
              cursor: pointer;
              border-radius: 4px;

              &.active {
                background-color: #18a8c7;
                color: #fff;
              }

              &:nth-child(2n) {
                margin-left: 16px;
              }
            }
          }
        }
      }
      .surplus_tag_type {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0;
        box-sizing: border-box;
        .surplus_tag_type_item {
          display: flex;
          justify-content: center;
          flex: 1;
          height: 32px;
          line-height: 32px;
          background-color: #fafafa;
          cursor: pointer;
          border: 1px solid #ddd;
          // margin-right: 2px;
          border-radius: 2px;
          &.active {
            background-color: #fff;
            color: #18a8c7;
          }
        }
      }
    }

    .edit_tagTem_mid {
      width: calc(100% - 316px - 316px);
      height: 700px;
      height: calc(100vh - 172px);
      overflow-y: hidden;
      position: relative;
      background-color: #eee;

      .hintMessage {
        user-select: none;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 40px;
        background-color: #e6f7ff;
        border: 1px solid #91d5ff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 17px;

        > div {
          display: flex;
          align-items: center;

          > span {
            display: inline-block;
            margin-left: 8px;
          }
        }

        > span {
          cursor: pointer;
        }
      }

      .permissionHint {
        user-select: none;
        position: absolute;
        top: 44px;
        left: 0;
        z-index: 1;
        width: 100%;
        min-height: 40px;
        background-color: #fff7e6;
        border: 1px solid #ffd591;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 17px;

        > div {
          display: flex;
          align-items: center;

          > span {
            display: inline-block;
            margin-left: 8px;
          }
        }

        > span {
          cursor: pointer;
        }
      }

      canvas {
        width: 100%;
        height: 100%;
      }

      .operate_wap {
        font-size: 14px;
        user-select: none;
        position: absolute;
        bottom: 10px;
        right: 20px;
        display: flex;
        align-items: center;

        > div {
          color: #999999;

          .icon_btn {
            cursor: pointer;

            &:hover {
              color: #333;
            }
          }

          &.operate_menu {
            margin: 0 10px;
          }
        }
      }
    }

    .edit_tagTem_right {
      height: calc(100vh - 172px);
      position: absolute;
      right: 0;
      top: 0;
      width: 316px;
      background: #eeeeee;

      > div {
        padding: 10px 10px 20px 24px;
        background: #fff;
      }

      .attBox {
        // height: 400px;
        > div {
          > div {
            display: flex;
            flex: 4;
            align-items: center;
            padding: 10px 0;

            .att-name {
              display: inline-block;
              margin-right: 6px;
              min-width: 70px;
              max-width: 120px;
              overflow: hidden;
              text-overflow: ellipsis;
              text-wrap: nowrap;
            }

            .el-slider {
              width: 110px;
              margin: 0 5px;
            }
          }
        }

        .ncname-remark {
          margin-left: 78px;
          margin-top: -5px;
          color: #f00;
        }

        .error-info {
          top: 45px;
          left: 80px;
          color: #fd3232;
        }
      }

      .delete_reset {
        margin-top: 4px;
        height: calc(100% - 406px);

        > div {
          display: flex;
          align-items: center;
          justify-content: space-around;
          flex-wrap: wrap;

          .ant-btn {
            width: 125px;
            margin-bottom: 22px;
            background-color: #fafafa;
          }
        }
      }
    }
  }

  .statistics-box {
    display: block !important;
  }
}

.enable-sub-tag-tooltip {
  max-width: 300px;

  .ant-tooltip-inner {
    color: rgba(0, 0, 0, 0.65);
    background-color: #fff;
  }

  .ant-tooltip-arrow::before {
    background-color: #fff;
  }

  .link-text {
    margin-left: 110px;
    color: #18a8c7;
    cursor: pointer;
    white-space: nowrap;
  }
}
</style>
